/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cef1fef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cef1fef0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"2151d914-4250-45f7-86b4-bdaf04b0b79f","title":"Informacje dotyczące drukarki","link":"finding-information-about-printer-topic.html","desc":"Znajdowanie informacji na temat drukarki","descFull":"Znajdowanie informacji na temat drukarki Zasoby i ich lokalizacja Czego szukasz? Znajdziesz to tu Instrukcje dotyczące wstępnej konfiguracji Zapoznaj się z dokumentacją instalacyjną dołączoną do drukarki. Oprogramowanie drukarki Sterownik drukarki lub faksu Oprogramowanie sprzętowe drukarki Utility Przejdź do strony  www.lexmark.com/downloads , wyszukaj model drukarki, a następnie w menu Typ wybierz odpowiedni sterownik, oprogramowanie sprzętowe lub narzędzie. Wybieranie i przechowywanie papieru i nośników specjalnych Ładowanie papieru Konfigurowanie ustawień drukarki Wyświetlanie i drukowanie dokumentów i zdjęć Konfigurowanie drukarki w sieci Obchodzenie się z drukarką i jej konserwacja Rozwiązywanie problemów Centrum informacji — wejdź na stronę  https://infoserve.lexmark.com . Filmy instruktażowe — wejdź na stronę  https://infoserve.lexmark.com/idv/ . Informacje pomocy dotyczące korzystania z oprogramowania drukarki. Pomoc dla systemów operacyjnych Microsoft Windows lub Macintosh — otwórz program lub aplikację związaną z drukarką i kliknij opcję  Pomoc . Kliknij opcję  , aby zostały wyświetlone informacje uzależnione od kontekstu. Pomoc jest automatycznie instalowana wraz z oprogramowaniem drukarki. Oprogramowanie drukarki znajduje się w folderze programów drukarki lub na pulpicie, w zależności od używanego systemu operacyjnego. Dokumentacja Obsługa chatu Obsługa wiadomości e-mail Pomoc telefoniczna Przejdź pod adres  http://support.lexmark.com . Wybierz kraj lub region, a następnie produkt, aby wyświetlić odpowiednią witrynę pomocy technicznej. Informacje kontaktowe działu pomocy technicznej dla danego kraju lub regionu można znaleźć w witrynie internetowej lub w gwarancji dostarczonej z drukarką. Podczas rozmowy z pracownikiem działu obsługi klienta należy mieć przygotowane następujące informacje: Miejsce i data zakupu Typ i numer seryjny urządzenia Więcej informacji można znaleźć w sekcji  . Informacje dotyczące bezpieczeństwa Informacje prawne Informacje o gwarancji Informacje na temat wpływu na środowisko Informacje dotyczące gwarancji mogą różnić się w zależności od kraju czy regionu: W Stanach Zjednoczonych  – należy zapoznać się z Oświadczeniem o ograniczonej gwarancji dostarczonym razem z tą drukarką lub opublikowanym pod adresem  http://support.lexmark.com . W innych krajach i regionach  — należy zapoznać się z drukowaną gwarancją dołączoną do drukarki. Informacje o produkcie  — więcej informacji na ten temat można znaleźć w dokumentacji dostarczonej z drukarką lub na stronie  http://support.lexmark.com . Informacje dotyczące paszportu cyfrowego firmy Lexmark Przejdź na stronę  https://csr.lexmark.com/digital-passport.php . informacje o drukarce znajdowanie znajdowanie informacji na temat drukarki"},{"UUID":"3171e8b4-2c0c-4379-a63c-fb7edb8e60ff","title":"Informacje dotyczące drukarki","link":"finding-printer-serial-number-topic.html","desc":"Odnajdywanie numeru seryjnego drukarki Wyciągnij","descFull":"Odnajdywanie numeru seryjnego drukarki Wyciągnij zasobnik. Odszukaj numer seryjny umieszczony poniżej podajnika ręcznego. odnajdywanie numeru seryjnego drukarki numer seryjny, drukarka znajdowanie"},{"UUID":"2687553b-98f0-428f-99a3-bd741dc8d784","title":"Informacje dotyczące drukarki","link":"configured-model-topic.html","desc":"Konfiguracja drukarki Części podstawowego modelu","descFull":"Konfiguracja drukarki Części podstawowego modelu drukarki 1 Automatyczny podajnik dokumentów 2 taca podajnika ADF 3 Odbiornik automatycznego podajnika dokumentów 4 Odbiornik standardowy 5 Przycisk zasilania 6 Podajnik ręczny 7 Zasobnik na 250 arkuszy 8 Panel operacyjny Wygląd może się różnić, zależnie od modelu drukarki. konfiguracja drukarki"},{"UUID":"350aa360-29e4-4889-a6bf-d0436f8cf2c0","title":"Korzystanie z panelu sterowania","link":"using-control-panel-group.html","desc":"Urządzenie wielofunkcyjne Lexmark MB2236adw Panel","descFull":"Urządzenie wielofunkcyjne Lexmark MB2236adw Panel z 2-liniowym wyświetlaczem LCD Części panelu sterowania oraz ich funkcje Część panelu sterowania Funkcja 1 Wyświetlanie Wyświetla komunikaty i informacje o stanie drukarki. Umożliwia konfigurowanie i obsługę drukarki. 2 Strzałka w lewo Umożliwia przewijanie pomiędzy menu oraz przechodzenie pomiędzy ekranami i opcjami menu. Zmniejsza numeryczną wartość ustawienia. 3 Przycisk Select (Wybierz) Wybiera opcję menu. Zapisuje zmian w ustawieniach. 4 Strzałka w prawo Umożliwia przewijanie pomiędzy menu oraz przechodzenie pomiędzy ekranami i opcjami menu. Zwiększa numeryczną wartość ustawienia. 5 Kontrolka Sprawdzenie stanu drukarki. 6 Przycisk Strona główna Przechodzi do ekranu głównego. 7 Przycisk Stop lub Cancel (Anuluj) Zatrzymuje bieżące zadanie. 8 Przycisk Wstecz Przechodzi do poprzedniego ekranu. 9 Przycisk Start Rozpoczyna zadanie w zależności od wybranego trybu. 10 Przycisk menu Umożliwia dostęp do menu drukarki. 11 Przycisk skrótów Wyświetla skróty do najczęściej używanych funkcji z uprzednio zapisanymi ustawieniami. 12 Przycisk Faks Włącza  Tryb faksowania . 13 Przycisk Kopiuj Włącza  Tryb kopiowania . 14 Klawiatura numeryczna W polu wprowadzania znaków można wpisać cyfry lub symbole. korzystanie z panelu sterowania Urządzenie wielofunkcyjne Lexmark MB2236adw korzystanie z panelu sterowania panel z 2-liniowym wyświetlaczem LCD"},{"UUID":"4064f052-31ae-4347-975e-622f8b254686","title":"Korzystanie z panelu sterowania","link":"using-control-panel-group.html","desc":"Urządzenia wielofunkcyjne Lexmark MB2236adwe i","descFull":"Urządzenia wielofunkcyjne Lexmark MB2236adwe i MB2236i Panel z ekranem dotykowym Część panelu sterowania Funkcja 1 Przycisk Strona główna Przechodzi do ekranu głównego. 2 Przycisk Wstecz Przechodzi do poprzedniego ekranu. 3 Przycisk Start Rozpoczyna zadanie w zależności od wybranego trybu. 4 Kontrolka Sprawdzenie stanu drukarki. 5 Wyświetlanie Wyświetla komunikaty i informacje o stanie drukarki. Umożliwia konfigurowanie i obsługę drukarki. korzystanie z panelu sterowania Urządzenie wielofunkcyjne Lexmark MB2236adwe korzystanie z panelu sterowania Urządzenie wielofunkcyjne Lexmark MB2236i korzystanie z panelu sterowania panel z ekranem dotykowym"},{"UUID":"cdb0d5d0-3184-42d6-a81b-54df0cc149b5","title":"Informacje dotyczące drukarki","link":"customizing-home-screen-topic.html","desc":"Dostosowywanie ekranu głównego Z poziomu","descFull":"Dostosowywanie ekranu głównego Z poziomu panelu sterowania dotknij kolejno  Ustawienia Urządzenie Widoczne ikony ekranu głównego . Wybierz ikony, które mają być wyświetlane na ekranie głównym. Zastosuj zmiany. ikony ekranu głównego wyświetlanie ikony na ekranie głównym wyświetlanie ekran główny dostosowywanie"},{"UUID":"abac51ad-87c6-469a-b21f-8733b1d7129c","title":"Informacje dotyczące drukarki","link":"changing-language-of-onscreen-keyboard-topic.html","desc":"Zmiana języka klawiatury ekranowej Język","descFull":"Zmiana języka klawiatury ekranowej Język klawiatury można zmienić tylko w zadaniach drukarki, które wymagają wprowadzenia znaków alfanumerycznych, np. e-mail lub skanowanie. Dotknij pola wprowadzania. Na klawiaturze dotknij klawisza języka i przytrzymaj go. Wybierz język. język, zmiana klawiatura ekranowa klawiatura ekranowa zmiana języka język klawiatury"},{"UUID":"c1e3db17-1746-48cc-97a1-b9aba130e5f4","title":"Informacje dotyczące drukarki","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Odczytywanie wskazań przycisku zasilania i","descFull":"Odczytywanie wskazań przycisku zasilania i kontrolki Kolor przycisku zasilania i odpowiadający mu status drukarki Kontrolka przycisku zasilania Stan drukarki Wyłączone Drukarka jest wyłączona, gotowa lub przetwarza dane. Biały Drukarka jest w trybie czuwania. Urządzenie wielofunkcyjne Lexmark MB2236adw Panel z 2-liniowym wyświetlaczem LCD Kolor kontrolki drukarki z 2-liniowym wyświetlaczem LCD Kontrolka Stan drukarki Wyłączone Drukarka jest wyłączona lub działa w trybie czuwania. Zielony Drukarka jest włączona lub jest gotowa do pracy. Migające zielone światło Drukarka przetwarza dane. Migające czerwone światło Drukarka wymaga interwencji użytkownika. Urządzenia wielofunkcyjne Lexmark MB2236adwe, Lexmark MB2236i Panel z ekranem dotykowym Kolor kontrolki drukarki z ekranem dotykowym Kontrolka Stan drukarki Wyłączone Drukarka jest wyłączona lub działa w trybie czuwania. Niebieski Drukarka jest włączona lub jest gotowa do pracy. Migające niebieskie światło Drukarka przetwarza dane. Migające czerwone światło Drukarka wymaga interwencji użytkownika. odczytywanie wskazań kontrolka odczytywanie wskazań kontrolka przycisku zasilania status drukarki"},{"UUID":"55e0c7ad-ad00-4d35-b286-2020fc29991a","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Wskazówki dotyczące papieru Stosowanie odpowiednich","descFull":"Wskazówki dotyczące papieru Stosowanie odpowiednich rodzajów papieru w celu uniknięcia zacięć i zapewnienia bezproblemowego drukowania. Zawsze należy używać nowego, nieuszkodzonego papieru. Przed załadowaniem papieru należy sprawdzić, która strona jest stroną zalecaną do zadrukowania. Informacja ta zazwyczaj znajduje się na opakowaniu papieru. Nie należy używać papieru wyciętego lub przyciętego ręcznie. Nie należy jednocześnie umieszczać papieru o różnych rozmiarach, rodzajach lub gramaturach w tym samym zasobniku, gdyż może to powodować zacięcia. Nie należy stosować papieru powlekanego, za wyjątkiem papierów powlekanych przeznaczonych do drukowania elektrofotograficznego. papier wybieranie wskazówki dotyczące papieru"},{"UUID":"1311baf2-3205-40ea-a40b-1547c9a82156","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Charakterystyka papieru Przedstawiona poniżej charakterystyka","descFull":"Charakterystyka papieru Przedstawiona poniżej charakterystyka papieru ma wpływ na jakość wydruku i niezawodność drukowania. Przed wydrukiem należy uwzględnić następujące czynniki: Gramatura Zasobnik drukarki może podawać papier o gramaturze od 60 do 105 g/m 2  z włóknami wzdłuż strony. Papier o gramaturze mniejszej niż 60 g/m 2  może nie być wystarczająco sztywny, co może skutkować problemami z podawaniem i powodować zacięcia. Zwijanie Zwijanie to tendencja papieru do zakrzywiania się na brzegach. Nadmierne zwijanie się może spowodować problemy z podawaniem papieru. Papier może zwijać się po przejściu przez drukarkę, gdzie wystawiony jest na działanie wysokiej temperatury. Trzymanie rozpakowanego papieru w warunkach o dużej wilgotności lub bardzo suchych, w wysokiej lub niskiej temperaturze może przyczynić się do zawinięcia brzegów przed drukowaniem i spowodować problemy z podawaniem. Gładkość Gładkość papieru ma bezpośredni wpływ na jakość wydruku. Jeśli papier jest zbyt szorstki, toner nie zostanie prawidłowo wtopiony w arkusz. Zbyt gładki papier może spowodować problemy z podawaniem lub jakością wydruku. Zalecamy korzystanie z papieru z 50 punktami Sheffielda. Zawartość wilgoci Ilość wilgoci zawartej w papierze ma wpływ zarówno na jakość wydruków, jak i zdolność do prawidłowego podawania papieru przez drukarkę. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Narażenie papieru na zmiany wilgotności może niekorzystnie wpływać na jego parametry. Od 24 do 48 godzin przed drukowaniem papier w oryginalnym opakowaniu należy umieścić w tym samym środowisku, co drukarkę. W przypadku dużej różnicy między warunkami przechowywania lub transportu a warunkami panującymi w otoczeniu drukarki okres ten papieru powinien zostać wydłużony do kilku dni. Również gruby papier może wymagać dłuższego okresu kondycjonowania. Kierunek ułożenia włókien Kierunek włókien określa sposób ułożenia włókien papieru w arkuszu. Kierunek włókien może być  wzdłużny , czyli równoległy do długości papieru, lub  poprzeczny , czyli równoległy do szerokości papieru. Dla papieru o gramaturze od 60 do 105 g/m 2  jest zalecany układ włókien wzdłuż strony. Zawartość włókien Większość papieru kserograficznego wysokiej jakości wykonana jest w 100% z przetworzonej chemicznie papierówki. Taki skład pozwala uzyskać papier o wysokim stopniu stabilności, gwarantującym mniejsze problemy z podawaniem papieru w drukarce i lepszą jakość wydruku. Papier zawierający inne włókna, np. bawełny, może powodować problemy podczas drukowania. charakterystyka papieru wybór papieru"},{"UUID":"c028bdff-9a3c-4370-bdfe-45a4e33176d7","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Niedozwolone rodzaje papieru Nie zaleca","descFull":"Niedozwolone rodzaje papieru Nie zaleca się stosowania w drukarce niżej wymienionych rodzajów papieru: Papier poddany obróbce chemicznej, który służy do wykonywania kopii bez zastosowania kalki. Są one również znane jako papiery samokopiujące, papier samokopiujący bez węgla (CCP) lub papier niezawierający węgla (NCR). Papier z nadrukiem zawierającym substancje mogące zanieczyścić drukarkę Papier z nadrukiem nieodpornym na wysoką temperaturę panującą w nagrzewnicy drukarki. Papier z nadrukiem wymagającym kalibracji (precyzyjnego usytuowania nadruku na stronie) dokładniejszej niż ±2,3 mm (±0,09 cala). Na przykład formularze optycznego rozpoznawania znaków (OCR). Aby właściwie drukować na takich formularzach, można czasami dokonać kalibracji za pomocą aplikacji. Papier powlekany (papier dokumentowy podatny na wycieranie), papier syntetyczny, papier termiczny Papier o nierównych krawędziach, papier szorstki lub papier o powierzchni z wyraźną teksturą bądź papier pofałdowany. Papier niespełniający wymagań europejskiej normy EN12281:2002. Papier o gramaturze mniejszej niż 60g/m 2 . Formularze lub dokumenty wieloczęściowe. niedozwolone rodzaje papieru"},{"UUID":"aa4e6312-665b-48ef-9471-ad0f9cb5c9e5","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Wybór form z nadrukiem i","descFull":"Wybór form z nadrukiem i papieru firmowego Użyj papieru o długich włóknach. Należy używać wyłącznie form i papieru firmowego zadrukowanych metodą litografii offsetowej lub druku wklęsłego. Nie należy stosować papieru szorstkiego lub o powierzchni z wyraźną teksturą. Należy używać farby drukarskiej odpornej na działanie żywicy w tonerze. Farba drukarska utrwalana przez utlenianie lub farba na bazie oleju z reguły spełnia te wymagania, natomiast lateksowa farba drukarska może ich nie spełniać. Przed zakupem dużej ilości druków formularzy i papieru firmowego należy zrobić na nich próbny wydruk. Dzięki temu można ustalić, czy toner na formularzach z nadrukiem i papierze firmowym będzie mieć wpływ na jakość druku. W razie wątpliwości należy skontaktować się z dostawcą papieru. W przypadku drukowania na papierze firmowym, papier należy załadować w prawidłowej orientacji dla danej drukarki. Aby uzyskać więcej informacji, patrz  Wskazówki dotyczące papieru i nośników specjalnych . W przypadku drukowania na papierze firmowym, papier należy załadować w prawidłowej orientacji dla danej drukarki. papier formularze z nadrukiem formularze z nadrukiem wybieranie papier papier firmowy papier firmowy wybieranie"},{"UUID":"8bfa6fe4-7de2-410e-ba60-a53f203f98f3","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Przechowywanie papieru Aby uniknąć problemów","descFull":"Przechowywanie papieru Aby uniknąć problemów z zacięciami papieru i nierówną jakością wydruku, należy zastosować się do poniższych wskazówek: Od 24 do 48 godzin przed drukowaniem papier w oryginalnym opakowaniu należy umieścić w tym samym środowisku, co drukarkę. W przypadku dużej różnicy między warunkami przechowywania lub transportu a warunkami panującymi w otoczeniu drukarki okres ten papieru powinien zostać wydłużony do kilku dni. Również gruby papier może wymagać dłuższego okresu kondycjonowania. Aby uzyskać jak najlepszą jakość wydruków, papier należy przechowywać w miejscu o temperaturze 21°C i wilgotności względnej 40%. Większość producentów etykiet zaleca drukowanie w temperaturze od 18 do 24°C i wilgotności względnej od 40 do 60%. Papier należy przechowywać w kartonach, a te umieszczać na paletach lub półkach, a nie na podłodze. Pojedyncze paczki papieru należy przechowywać na płaskiej powierzchni. Na pojedynczych paczkach papieru nie należy umieszczać żadnych przedmiotów. Papier należy wyjmować z kartonu lub opakowania tylko bezpośrednio przed załadowaniem do drukarki. Dzięki przechowywaniu w kartonie i opakowaniu papier pozostaje czysty, suchy i płaski. Przechowywanie papieru"},{"UUID":"ea3fe9fe-d172-4c8d-9839-676ef3c74f02","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Obsługiwane rozmiary papieru Arkusze węższe","descFull":"Obsługiwane rozmiary papieru Arkusze węższe niż 210 mm (8,3 cala) są zawsze drukowane wolniej. Skorzystaj z ręcznego podajnika papieru, by drukować na arkuszach węższych niż 105 mm (4,1 cala). Minimalne wymiary arkuszy papieru obsługiwane przez funkcję drukowania dwustronnego to 210 x 279,4 mm (8,3 x 11 cali). Maksymalna długość papieru obsługiwany przez szybę skanera to 297 mm (11,7 cala). W przypadku drukowania dwustronnego na papierze formatu Letter, Legal, Oficio oraz Folio należy upewnić się, że ustawienie rozmiaru papieru w module dupleksu jest ustawione na wartość Letter. Obsługiwane rozmiary papieru Rozmiar papieru Zasobnik na 250 arkuszy Podajnik ręczny Drukowanie dwustronne Szyba skanera Automatyczny podajnik dokumentów A4 210 x 297 mm (8,27 x 11,7 cala) A5 (podawanie wzdłuż krótkiej krawędzi) 148 x 210 mm (5,83 x 8,27 cala) X A5 (podawanie wzdłuż długiej krawędzi) 210 x 148 mm (8,27 x 5,83 cala) X A6 105 x 148 mm (4,13 x 5,83 cala) X B5 JIS 182 x 257 mm (7,17 x 10,1 cala) X Oficio (Meksyk) 215,9 x 340,4 mm (8,5 x 13,4 cala) X Hagaki 100 x 148 mm (3,94 x 5,83 cala) X X X Statement 139,7 x 215,9 mm (5,5 x 8,5 cala) X Executive 184,2 x 266,7 mm (7,25 x 10,5 cala) X Letter 215,9 x 279,4 mm (8,5 x 11 cala) Legal 215,9 x 355,6 mm (8,5 x 14 cala) X Folio 215,9 x 330,2 mm (8,5 x 13 cala) X Uniwersalny od 98 x 148 mm (3,9 x 5,8 cala) do 216 x 356 mm (8,5 x 14 cali) X X Uniwersalny od 105 x 148 mm (4,1 x 5,8 cali) do 216 x 356 mm (8.5 x 14 cali) X Koperta 7 3/4 (Monarch) 98,4 x 190,5 mm (3,875 x 7,5 cala) X X X Koperta 9 98,4 x 225,4 mm (3,875 x 8,9 cala) X X X Koperta 10 104,8 x 241,3 mm (4,12 x 9,5 cala) X X X Koperta DL 110 x 220 mm (4,33 x 8,66 cala) X X X Koperta C5 162 x 229 mm (6,38 x 9,01 cala) X X X Koperta B5 176 x 250 mm (6,93 x 9,84 cala) X X X Koperta uniwersalna od 98,4 x 162 mm (3,87 x 6,38 cala) do 176 x 250 mm (6,93 x 9,84 cali) X X X obsługiwane rozmiary papieru rozmiary papieru obsługiwane"},{"UUID":"8e63de0f-815f-4ee5-bd04-ca0a9219601a","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Obsługiwane typy papieru Etykiety, koperty","descFull":"Obsługiwane typy papieru Etykiety, koperty i karty są zawsze drukowane z mniejszą prędkością. Obsługiwane typy papieru Typ papieru Zasobnik na 250 arkuszy Podajnik ręczny Drukowanie dwustronne Automatyczny podajnik dokumentów Zwykły papier Karty X X X Etykiety X X X Papier dokumentowy Koperta X X X Papier firmowy Formularze Papier kolorowy O małej gramaturze O dużej gramaturze Makulaturowy obsługiwane typy papieru typy papieru obsługiwane"},{"UUID":"28e05371-71ce-407f-965d-ce8cdf4f8ae8","title":"Wybór papieru","link":"selecting-paper-group.html","desc":"Obsługiwane gramatury papieru Obsługiwane gramatury","descFull":"Obsługiwane gramatury papieru Obsługiwane gramatury papieru Zasobnik na 250 arkuszy Podajnik ręczny Drukowanie dwustronne Automatyczny podajnik dokumentów 60–105 g/m ²  (16–28 funtów, dokumentowy) 60-200 g/m ²  (16-54 funtów, dokumentowy) 60–105 g/m ²  (16–28 funtów, dokumentowy) 60–105 g/m ²  (16–28 funtów, dokumentowy) obsługiwane gramatury papieru gramatury papieru obsługiwane"},{"UUID":"e2370ad3-ab89-4ba6-b417-75da4ec3767a","title":"Przygotowanie, instalacja i konfiguracja","link":"selecting-location-printer-m-topic.html","desc":"Wybór miejsca na drukarkę Należy","descFull":"Wybór miejsca na drukarkę Należy pozostawić wystarczającą ilość miejsca, aby zasobniki, pokrywy i drzwiczki swobodnie się otwierały oraz by można było instalować opcjonalne wyposażenie. Ustaw drukarkę w pobliżu gniazdka elektrycznego. Aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach znajdującego się w pobliżu urządzenia. Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy umieszczać ani używać tego produktu w pobliżu wody lub w miejscach o dużej wilgotności. Należy upewnić się, że przepływ powietrza w pomieszczeniu spełnia wymagania najnowszej wersji standardu ASHRAE 62 lub standardu CEN Technical Committee 156. zadbać o płaską, mocną i stabilną powierzchnię. Drukarkę należy: utrzymywać w czystości i dbać, aby była sucha i nie osadzał się na niej kurz; trzymać z dala od zszywek i spinaczy do papieru; trzymać z dala od bezpośredniego przepływu powietrza klimatyzatorów, grzejników lub wentylatorów; trzymać w miejscu nienarażonym na bezpośrednio padające promienie słoneczne, dużą wilgotność lub gwałtowne zmiany temperatury. Należy przestrzegać zalecanych temperatur i unikać wahań: Zalecane temperatury Temperatura otoczenia Temperatura przechowywania Aby zapewnić odpowiednią wentylację, należy pozostawić następującą zalecaną ilość wolnego miejsca wokół drukarki: Zalecana ilość wolnego miejsca wokół drukarki 1 Góra 2 Tylny 3 Prawa strona 4 Przód 5 Lewa strona drukarka wybór miejsca drukarka minimalne odstępy przenoszenie drukarki wybór miejsca na drukarkę"},{"UUID":"36be8f2f-1366-44fd-ac71-47a07e5fad3d","title":"Przygotowanie, instalacja i konfiguracja","link":"attaching-cables-topic.html","desc":"Podłączanie kabli Aby uniknąć ryzyka","descFull":"Podłączanie kabli Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy instalować urządzenia i podłączać żadnych przewodów (np. faksu, przewodu zasilającego lub kabla telefonicznego) podczas burzy. aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach znajdującego się w pobliżu urządzenia. w celu uniknięcia ryzyka pożaru lub porażenia prądem należy korzystać wyłącznie z przewodu zasilającego dołączonego do tego produktu lub z części zamiennych autoryzowanych przez producenta. w celu zmniejszenia ryzyka pożaru, przyłączając niniejszy produkt do publicznej sieci telefonicznej, należy korzystać wyłącznie z przewodów telekomunikacyjnych (RJ-11) o grubości 26 AWG lub większej. Na terenie Australii należy stosować przewód zatwierdzony przez Australian Communications and Media Authority (Australijski urząd ds. komunikacji i mediów). Aby uniknąć utraty danych lub nieprawidłowego działania drukarki, nie wolno dotykać podczas drukowania kabla USB ani żadnej karty sieciowej czy części drukarki pokazanych na rysunku. Porty drukarki i ich funkcje Port drukarki Funkcja 1 Port EXT Dostępne wyłącznie w niektórych modelach drukarek. Podłączanie dodatkowych urządzeń (telefonu lub automatycznej sekretarki) do drukarki i linii telefonicznej. Użyj tego portu, jeśli nie posiadasz linii dedykowanej faksu przeznaczonej dla drukarki i jeśli ta metoda połączenia jest obsługiwana w twoim kraju lub regionie. 2 Port LINE Dostępne wyłącznie w niektórych modelach drukarek. Podłączanie drukarki do aktywnej linii telefonicznej przez standardowe gniazdo ścienne (RJ-11), filtr DSL, adapter VoIP lub dowolny inny adapter umożliwiający dostęp do linii telefonicznej i wysyłanie oraz odbieranie faksów. 3 port Ethernet Połączyć drukarkę z siecią. 4 port USB drukarki Połącz drukarkę z komputerem. 5 Gniazdo kabla zasilającego Łączy drukarkę z prawidłowo uziemionym gniazdkiem elektrycznym. podłączanie kabli porty drukarki port USB drukarki port Ethernet Port LINE Port EXT gniazdo przewodu zasilającego"},{"UUID":"9ddbd680-a477-4703-810b-3b6cfa25a87f","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Obsługiwane faksy Modele drukarek i","descFull":"Obsługiwane faksy Modele drukarek i obsługiwane przez nie faksy Model drukarki Faks analogowy etherFAX 1 Serwer faksów Fax over IP (FoIP) 2 1  Wymaga subskrypcji. Więcej informacji można uzyskać pod adresem  https://www.etherfax.net/lexmark  lub kontaktując się z punktem sprzedaży, w którym nabyto drukarkę. 2  Wymaga zainstalowanego pakietu licencji. Więcej informacji na ten temat można uzyskać w miejscu zakupu drukarki. MB2236adw X MB2236adwe MB2236i X faks obsługiwane obsługiwane faksy"},{"UUID":"60e11b0a-5f10-4233-8837-b904b25caeed","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Ustawianie funkcji faksu za pomocą","descFull":"Ustawianie funkcji faksu za pomocą faksu analogowego Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Niektóre sposoby połączeń mogą nie dotyczyć niektórych krajów lub regionów. Jeśli funkcja faksu jest włączona, ale nie jest w pełni skonfigurowana, kontrolka może migać na czerwono. Jeśli urządzenie nie pracuje w środowisku TCP/IP, użyj panelu sterowania, aby skonfigurować faks. Aby zapobiec utracie danych lub nieprawidłowemu działaniu drukarki, podczas wysyłania lub odbierania faksu nie należy dotykać przewodów lub części drukarki pokazanych na rysunku. Korzystanie z kreatora konfiguracji faksu w drukarce Kreator konfiguracji jest dostępny tylko wtedy, gdy nie skonfigurowano faksowania przy użyciu urządzenia, takiego jak faks analogowy, etherFAX lub Fax over IP (FoIP). Te instrukcje dotyczą tylko drukarek z ekranem dotykowym. Przed użyciem kreatora upewnij się, że oprogramowanie sprzętowe drukarki zostało zaktualizowane. Więcej informacji można znaleźć w sekcji  . Na ekranie głównym dotknij opcji  Faks . Dotknij opcji  Skonfiguruj teraz . Wpisz nazwę faksu, a następnie dotknij przycisku  Dalej . Wprowadź numer faksu, a następnie dotknij opcji  Gotowe . Korzystanie z menu  Ustawienia  w drukarce Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia ogólne faksu . W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skonfiguruj ustawienia. Korzystając z wbudowanego serwera WWW Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij  Ustawienia Faks Ustawienia faksu Ustawienia ogólne faksu . Skonfiguruj ustawienia. Zastosuj zmiany. faks konfiguracja konfiguracja faks"},{"UUID":"f7591fa2-04de-4fe3-91f0-1fb94a2d96b9","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Ustawianie funkcji faksu za pomocą","descFull":"Ustawianie funkcji faksu za pomocą etherFAX Oprogramowanie sprzętowe drukarki musi zostać zaktualizowane do najnowszej wersji. Więcej informacji można znaleźć w sekcji  . W drukarce musi być zainstalowany odpowiedni pakiet licencji. W celu uzyskania dodatkowych informacji należy skontaktować się z etherFAX. Upewnij się, że drukarka została zarejestrowana w portalu etherFAX. Więcej informacji można uzyskać pod adresem  https://www.etherfax.net/lexmark . Podczas rejestracji wymagany jest numer seryjny drukarki. Aby znaleźć numer seryjny, patrz  . Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij  Ustawienia Faks Ustawienia faksu Ustawienia ogólne faksu . Menu  Ustawienia faksu  pojawia się tylko wtedy, gdy opcja  Tryb faksowania  jest ustawiona na  Faks . W polu  Nazwa faksu  wpisz unikalną nazwę. W polu  Numer faksu  wprowadź numer faksu podany przez etherFAX. W menu  Transport faksu  wybierz  etherFAX . Zastosuj zmiany. etherFAX, za pomocą konfiguracja funkcji faksowania konfigurowanie funkcji faksu za pomocą etherFAX"},{"UUID":"2ad8f635-180a-41fd-ae4f-536eb857c71c","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Ustawianie funkcji faksu za pomocą","descFull":"Ustawianie funkcji faksu za pomocą serwera faksów Ta funkcja umożliwia wysyłanie wiadomości faksowych do dostawcy usług, który obsługuje odbieranie wiadomości e-mail. Ta funkcja obsługuje tylko faksy wychodzące. Aby umożliwić odbieranie faksów, upewnij się, że w drukarce jest skonfigurowane faksowanie przy użyciu urządzenia, takie jak faks analogowy, etherFAX lub Fax over IP (FoIP). Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij opcję  Ustawienia Faks . Z menu  Tryb faksowania  wybierz opcję  Serwer faksów , a następnie kliknij przycisk  Zapisz . Kliknij opcję  Ustawienia serwera faksu . W polu  Format  wpisz  [#]@myfax.com , gdzie  [#]  to numer faksu, a  myfax.com  to domena dostawcy faksu. Jeśli to konieczne, skonfiguruj pola  Adres zwrotny ,  Temat  lub  Wiadomość . Aby umożliwić drukarce odbieranie faksów, włącz ustawienie odbierania faksów przy użyciu urządzenia. Upewnij się, że skonfigurowano faksowanie przy użyciu urządzenia. Kliknij przycisk  Zapisz . Kliknij opcję  Ustawienia e-mail na serwerze faksów , a następnie wykonaj dowolną z następujących czynności: Włącz opcję  Użyj serwera poczty SMTP . Jeśli ustawienia SMTP poczty e-mail nie zostały skonfigurowane, patrz  . Konfiguracja ustawień SMTP. Więcej informacji na ten temat można uzyskać u dostawcy poczty e-mail. Zastosuj zmiany. serwer faksu, konfiguracja ustawianie funkcji faksu ustawianie funkcji faksu za pomocą serwera faksów"},{"UUID":"750f16ac-28bd-44a9-9bd1-699b5c93cb8e","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Konfiguracja faksu przy użyciu standardowej","descFull":"Konfiguracja faksu przy użyciu standardowej linii telefonicznej Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Więcej informacji można znaleźć w sekcji  . Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy instalować urządzenia i podłączać żadnych przewodów (np. faksu, przewodu zasilającego lub kabla telefonicznego) podczas burzy. Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy używać funkcji faksu podczas burzy. w celu zmniejszenia ryzyka pożaru, przyłączając niniejszy produkt do publicznej sieci telefonicznej, należy korzystać wyłącznie z przewodów telekomunikacyjnych (RJ-11) o grubości 26 AWG lub większej. Na terenie Australii należy stosować przewód zatwierdzony przez Australian Communications and Media Authority (Australijski urząd ds. komunikacji i mediów). Ustawienia 1: Drukarka jest podłączona do specjalnej linii dla faksów Podłącz jeden koniec przewodu telefonicznego do portu linii w drukarce. Podłącz drugi koniec kabla do działającego analogowego gniazdka telefonicznego. Drukarkę można skonfigurować w taki sposób, aby faksy były odbierane automatycznie ( Automatyczne odbieranie włączone ) lub ręcznie ( Automatyczne odbieranie wyłączone ). Jeśli faksy mają być odbierane automatycznie, drukarka powinna przejmować połączenie po określonej liczbie sygnałów. Ustawienia 2: Drukarka współdzieli linię z automatyczną sekretarką Jeśli subskrybujesz usługę dzwonków charakterystycznych, upewnij się, że został ustawiony prawidłowy wzorzec dzwonka dla drukarki. W przeciwnym wypadku drukarka nie będzie odbierać faksów nawet po ustawieniu funkcji odbierania automatycznego. Podłączenie do tego samego ściennego gniazda telefonicznego Te instrukcje dotyczą tylko drukarek wyposażonych w porty EXT i linii telefonicznej. Podłącz jeden koniec przewodu telefonicznego do portu linii w drukarce. Podłącz drugi koniec kabla do działającego analogowego gniazda ściennego. Podłącz automatyczną sekretarkę do portu telefonicznego w drukarce. Podłączenie do różnych gniazd ściennych Podłącz jeden koniec przewodu telefonicznego do portu linii w drukarce. Podłącz drugi koniec kabla do działającego analogowego gniazda ściennego. Jeżeli posiadasz tylko jeden numer telefonu na danej linii, skonfiguruj drukarkę rak, by automatycznie odbierać faksy. Ustaw drukarkę w taki sposób, aby przejmowała połączenia dwa sygnały po automatycznej sekretarce. Na przykład jeśli automatyczna sekretarka przejmuje połączenia po czterech dzwonkach, należy ustawić opcję  Liczba sygnałów do odebrania  na  6 . konfigurowanie faksu połączenie przez standardową linię telefoniczną faks, ustawienia połączenie przez standardową linię telefoniczną automatyczna sekretarka konfiguracja"},{"UUID":"826e40e1-e953-4ea4-b72c-c0ce2c352f1d","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Konfiguracja faksu w krajach lub","descFull":"Konfiguracja faksu w krajach lub regionach wykorzystujących inne gniazdka i wtyczki telefoniczne Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Więcej informacji można znaleźć w sekcji  . Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy instalować urządzenia i podłączać żadnych przewodów (np. faksu, przewodu zasilającego lub kabla telefonicznego) podczas burzy. Aby uniknąć ryzyka porażenia prądem elektrycznym, nie należy używać funkcji faksu podczas burzy. w celu zmniejszenia ryzyka pożaru, przyłączając niniejszy produkt do publicznej sieci telefonicznej, należy korzystać wyłącznie z przewodów telekomunikacyjnych (RJ-11) o grubości 26 AWG lub większej. Na terenie Australii należy stosować przewód zatwierdzony przez Australian Communications and Media Authority (Australijski urząd ds. komunikacji i mediów). Standardowym gniazdem ściennym jest gniazdo RJ‑11, stosowane w większości krajów i regionów. Jeżeli gniazdo ścienne lub wyposażenie w obiekcie nie jest zgodne z tym typem połączenia, należy użyć adaptera telefonicznego. Adapter odpowiedni dla danego kraju lub regionu może nie być dostarczany z drukarką. W takim wypadku należy go zakupić oddzielnie. W porcie telefonicznym może być zainstalowana wtyczka adaptera. Nie należy wyjmować wtyczki adaptera z portu telefonicznego drukarki w przypadku podłączenia do szeregowego lub kaskadowego systemu telefonicznego. Numer katalogowy wtyczki adaptera Nazwa elementu Numer części Wtyczka adaptera Lexmark 40X8519 Podłączanie drukarki do gniazda ściennego innego niż RJ-11 Podłącz jeden koniec przewodu telefonicznego do portu linii w drukarce. Podłącz drugi koniec kabla do adaptera RJ‑11, a następnie podłącz adapter do gniazda ściennego. Jeśli chcesz podłączyć inne urządzenie ze złączem innym niż RJ‑11 do tego samego gniazda ściennego, podłącz je bezpośrednio do adaptera telefonicznego. faks, ustawienia typowe dla kraju lub regionu konfigurowanie faksu typowe dla kraju lub regionu adapter RJ-11 wtyczka adaptera"},{"UUID":"ae818831-b743-4d63-9716-9630ad660c04","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Nawiązywanie połączenia z usługą rozróżniania","descFull":"Nawiązywanie połączenia z usługą rozróżniania dzwonków Usługa dzwonków charakterystycznych umożliwia połączenie kilku numerów telefonów na jednej linii telefonicznej. Każdemu numerowi telefonu jest przypisany inny sygnał dzwonka. Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Więcej informacji można znaleźć w sekcji  . Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksu Funkcje sterowania administratora Odpowiedz na W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz sygnał dzwonka. usługa dzwonków charakterystycznych, faks włączanie podłączanie drukarki do usługi dzwonków charakterystycznych przypisywanie drukarki do sygnału dzwonka"},{"UUID":"77de7017-59a0-49c4-8dcb-2c41ab684568","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Ustawianie daty i godziny faksu","descFull":"Ustawianie daty i godziny faksu upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Preferencje Data i godzina Skonfiguruj W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skonfiguruj ustawienia. faksowanie ustawianie daty i godziny data i godzina ustawienia faksu"},{"UUID":"c0086055-815f-4edb-92a8-58e8397dfab2","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Konfigurowanie czasu letniego upewnij się,","descFull":"Konfigurowanie czasu letniego upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Preferencje Data i godzina Skonfiguruj W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. W menu  Strefa czasowa  wybierz  (UTC+użytk.) Niestandardowa . Skonfiguruj ustawienia. konfigurowanie czasu letniego ustawianie czasu letniego konfiguracja"},{"UUID":"5fbe3b86-fea3-4064-9f78-4e8bfc907493","title":"Konfigurowanie drukarki w celu faksowania","link":"setting-up-printer-to-fax-group.html","desc":"Konfiguracja ustawień głośnika faksu upewnij","descFull":"Konfiguracja ustawień głośnika faksu upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia głośnika W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wykonaj następujące czynności: Ustaw  Tryb głośnika  na  Zawsze włączony . Ustaw  Głośność głośnika  na  Wysoką . Włącz opcję  Głośność dzwonka . konfiguracja ustawień głośnika faksu ustawienia głośnika faksu konfiguracja"},{"UUID":"247beded-0d83-4f20-8b09-4d60786b454f","title":"Przygotowanie, instalacja i konfiguracja","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Konfigurowanie ustawień protokołu SMTP poczty","descFull":"Konfigurowanie ustawień protokołu SMTP poczty e-mail Skonfiguruj ustawienia protokołu SMTP (Simple Mail Transfer Protocol), aby wysyłać zeskanowane dokumenty pocztą e-mail. Ustawienia różnią się w zależności od dostawcy usług. Więcej informacji można znaleźć w sekcji  dostawców usług poczty e-mail . Przed rozpoczęciem upewnij się, że drukarka jest podłączona do sieci i że sieć jest podłączona do Internetu. Korzystanie z wbudowanego serwera WWW Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Ustawienia E-mail . Skonfiguruj ustawienia w sekcji  Konfiguracja poczty e-mail . Kliknij opcję  Zapisz . Aby uzyskać więcej informacji na temat hasła, zapoznaj się z tematem  dostawców usług poczty e-mail . W przypadku dostawców usług poczty e-mail, którzy nie znajdują się na liście, skontaktuj się z dostawcą usług i poprosić o podanie ustawień. Korzystanie z kreatora konfiguracji poczty e-mail w drukarce Przed użyciem kreatora upewnij się, że oprogramowanie sprzętowe drukarki zostało zaktualizowane. Więcej informacji można znaleźć w sekcji  . Te instrukcje dotyczą tylko niektórych modeli drukarek. Na ekranie głównym dotknij opcji  E-mail . Dotknij przycisku  Skonfiguruj teraz , a następnie wpisz swój adres e-mail. Wpisz hasło. W zależności od dostawcy usług poczty e-mail wpisz hasło konta, hasło aplikacji lub hasło uwierzytelniania. Aby uzyskać więcej informacji na temat hasła, zapoznaj się z tematem  dostawców usług poczty e-mail Następnie wyszukaj  Hasło urządzenia . Jeśli dostawca nie znajduje się na liście, skontaktuj się z dostawcą i zapytaj o ustawienia  podstawowej bramy SMTP ,  portu podstawowej bramy SMTP ,  używanego protokołu SSL/TLS  i  serwera uwierzytelniania SMTP . Po uzyskaniu ustawień należy kontynuować konfigurację. Dotknij przycisku  OK . Korzystanie z menu  Ustawienia  w drukarce Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia E‑mail Konfiguracja poczty e-mail W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skonfiguruj ustawienia. Aby uzyskać więcej informacji na temat hasła, zapoznaj się z tematem  dostawców usług poczty e-mail . W przypadku dostawców usług poczty e-mail, którzy nie znajdują się na liście, skontaktuj się z dostawcą usług i poprosić o podanie ustawień. Dostawcy usług poczty e-mail AOL Mail Comcast Mail Gmail iCloud Mail Mail.com Poczta NetEase Mail (mail.126.com) Poczta NetEase Mail (mail.163.com) Poczta NetEase Mail (mail.yeah.net) Outlook Live lub Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Jeśli po zastosowaniu podanych ustawień wystąpią błędy, skontaktuj się z dostawcą usług poczty e-mail. W przypadku dostawców usług poczty e-mail, którzy nie znajdują się na liście, skontaktuj się z dostawcą usług. AOL Mail Ustawienie poczty AOL Mail Ustawienie Wartość Podstawowa brama SMTP smtp.aol.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło aplikacji Aby utworzyć hasło aplikacji, przejdź do strony  zabezpieczeń konta AOL , zaloguj się na swoje konto, a następnie kliknij opcję  Generuj hasło aplikacji . Comcast Mail Ustawienia poczty Comcast Mail Ustawienie Wartość Podstawowa brama SMTP smtp.comcast.net Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło konta Gmail Upewnij się, że na koncie Google jest włączona dwuetapowa weryfikacja. Aby włączyć dwuetapową weryfikację, przejdź do strony  zabezpieczeń konta Google , zaloguj się do swojego konta, a następnie w sekcji „ Logowanie się w Google ” kliknij opcję  Weryfikacja dwuetapowa . Ustawienia SMTP poczty Gmail Ustawienie Wartość Podstawowa brama SMTP smtp.gmail.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło aplikacji Aby utworzyć hasło aplikacji, przejdź do strony  zabezpieczeń konta Google , zaloguj się do swojego konta, a następnie w sekcji „ Logowanie się w Google ” kliknij opcję  hasła aplikacji . „ Hasła aplikacji ” są wyświetlane tylko wtedy, gdy włączona jest weryfikacja dwuetapowa. iCloud Mail Upewnij się, że na koncie jest włączona dwuetapowa weryfikacja. Ustawienia poczty iCloud Mail Ustawienie Wartość Podstawowa brama SMTP smtp.mail.me.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło aplikacji Aby utworzyć hasło aplikacji, przejdź do strony  zabezpieczeń konta iCloud , zaloguj się do swojego konta, a następnie w sekcji  Bezpieczeństwo  kliknij opcję  Wygeneruj hasło . Mail.com Ustawienia poczty Mail.com Ustawienie Wartość Podstawowa brama SMTP smtp.mail.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło konta Poczta NetEase Mail (mail.126.com) upewnij się, że usługa SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty NetEase Mail kliknij  Ustawienia POP3/SMTP/IMAP , a następnie włącz  usługę IMAP/SMTP  lub  POP3/SMTP . Ustawienia poczty NetEase Mail (mail.126.com) Ustawienie Wartość Podstawowa brama SMTP smtp.126.com Port podstawowej bramy SMTP 465 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło autoryzacji Hasło autoryzacji jest podawane, gdy włączona jest  usługa IMAP/SMTP  lub  POP3/SMTP . Poczta NetEase Mail (mail.163.com) upewnij się, że usługa SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty NetEase Mail kliknij  Ustawienia POP3/SMTP/IMAP , a następnie włącz  usługę IMAP/SMTP  lub  POP3/SMTP . Ustawienia poczty NetEase Mail (mail.163.com) Ustawienie Wartość Podstawowa brama SMTP smtp.163.com Port podstawowej bramy SMTP 465 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło autoryzacji Hasło autoryzacji jest podawane, gdy włączona jest  usługa IMAP/SMTP  lub  POP3/SMTP . Poczta NetEase Mail (mail.yeah.net) upewnij się, że usługa SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty NetEase Mail kliknij  Ustawienia POP3/SMTP/IMAP , a następnie włącz  usługę IMAP/SMTP  lub  POP3/SMTP . Ustawienia poczty NetEase Mail (mail.yeah.net) Ustawienie Wartość Podstawowa brama SMTP smtp.yeah.net Port podstawowej bramy SMTP 465 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło autoryzacji Hasło autoryzacji jest podawane, gdy włączona jest  usługa IMAP/SMTP  lub  POP3/SMTP . Outlook Live lub Microsoft 365 Ustawienia te dotyczą domen e-mail outlook.com i hotmail.com oraz kont Microsoft 365. Ustawienia programu Outlook Live lub Microsoft 365 Ustawienie Wartość Podstawowa brama SMTP smtp.office365.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło konta lub aplikacji W przypadku kont z wyłączoną dwuetapową weryfikacją należy użyć hasła do konta. W przypadku kont outlook.com lub hotmail.com z włączoną dwuetapową weryfikacją należy użyć hasła aplikacji. Aby utworzyć hasło aplikacji, przejdź do strony  zarządzania kontem Outlook Live , a następnie zaloguj się do swojego konta. Dodatkowe opcje konfiguracji dla firm korzystających z programu Microsoft 365 można znaleźć  na stronie pomocy technicznej platformy Microsoft 365 . QQ Mail upewnij się, że usługa SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty QQ Mail kliknij opcję  Ustawienia Konto , a następnie w sekcji  Usługa POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  włącz  Usługa POP3/SMTP  lub  Usługa IMAP/SMTP . Ustawienia poczty QQ Mail Ustawienie Wartość Podstawowa brama SMTP smtp.qq.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Kod autoryzacji Aby wygenerować kod autoryzacji, na stronie głównej poczty QQ Mail kliknij opcję  Ustawienia Konto . W sekcji  Usługa POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  kliknij  Generuj kod autoryzacji . Sina Mail upewnij się, że usługa POP3/SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty Sina Mail kliknij opcję  Ustawienia Więcej ustawień POP/IMAP/SMTP użytkownika , a następnie włącz  usługę POP3/SMTP . Ustawienia poczty Sina Mail Ustawienie Wartość Podstawowa brama SMTP smtp.sina.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Kod autoryzacji Aby utworzyć kod autoryzacji, na stronie głównej poczty e-mail kliknij kolejno opcje  Ustawienia Więcej ustawień POP/IMAP/SMTP użytkownika , a następnie włącz  Stan kodu autoryzacji . Sohu Mail upewnij się, że usługa SMTP jest włączona na koncie. Aby włączyć tę usługę, na stronie głównej poczty Sohu Mail kliknij  Opcje Ustawienia POP3/SMTP/IMAP , a następnie włącz  usługę IMAP/SMTP  lub  POP3/SMTP . Ustawienia poczty Sohu Mail Ustawienie Wartość Podstawowa brama SMTP smtp.sohu.com Port podstawowej bramy SMTP 465 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Niezależne hasło Niezależne hasło jest podawane, gdy włączona jest  usługa IMAP/SMTP  lub  POP3/SMTP . Yahoo! Mail Ustawienia poczty Yahoo! Mail Ustawienie Wartość Podstawowa brama SMTP smtp.mail.yahoo.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło aplikacji Aby utworzyć hasło aplikacji, przejdź do strony  zabezpieczeń konta Yahoo , zaloguj się na swoje konto, a następnie kliknij opcję  Generuj hasło aplikacji . Zoho Mail Ustawienia poczty Zoho Mail Ustawienie Wartość Podstawowa brama SMTP smtp.zoho.com Port podstawowej bramy SMTP 587 Zastosuj protokół SSL/TLS Wymagane Wymagaj zaufanego certyfikatu Wyłączone Adres zwrotny Adres e-mail użytkownika Uwierzytelnianie serwera SMTP Logowanie/Zwykły Urządzenie – zainicjowany adres e-mail Stosuj dane identyfikacyjne SMTP urządzenia Identyfikator użytkownika urządzenia Adres e-mail użytkownika Hasło urządzenia Hasło konta lub aplikacji W przypadku kont z wyłączoną dwuetapową weryfikacją należy użyć hasła do konta. W przypadku kont z włączoną dwuetapową weryfikacją należy użyć hasła aplikacji. Aby utworzyć hasło aplikacji, przejdź do strony  zabezpieczeń konta poczty Zoho Mail , zaloguj się do swojego konta, a następnie w sekcji  Hasła specyficzne dla aplikacji  kliknij opcję  Generuj nowe hasło . dostawców usług poczty e-mail konfigurowanie ustawień serwera poczty e-mail ustawienia SMTP konfiguracja funkcja e-mail konfiguracja serwer e-mail konfiguracja"},{"UUID":"30c502cd-a1f1-458a-820c-7c1b388036d0","title":"Ładowanie papieru i nośników specjalnych","link":"loading-paper-and-specialty-media-group.html","desc":"Ustawianie rozmiaru i typu papieru","descFull":"Ustawianie rozmiaru i typu papieru Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru wybierz źródło papieru W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Ustaw domyślny rozmiar i typ papieru. W przypadku drukowania dwustronnego na papierze formatu A4 upewnij się, że rozmiar papieru w module dupleksu jest ustawiony na A4. W przypadku drukowania dwustronnego na papierze formatu Letter, Legal, Oficio oraz Folio należy upewnić się, że ustawienie rozmiaru papieru w module dupleksu jest ustawione na wartość Letter. ustawianie rozmiaru papieru ustawianie typu papieru rozmiar papieru ustawianie typ papieru ustawianie moduł dupleksu ustawianie rozmiaru papieru"},{"UUID":"833d2d22-031d-4cda-8160-b6971f0c7de4","title":"Ładowanie papieru i nośników specjalnych","link":"loading-paper-and-specialty-media-group.html","desc":"Konfigurowanie ustawień uniwersalnego rozmiaru papieru","descFull":"Konfigurowanie ustawień uniwersalnego rozmiaru papieru Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja nośnika Ustawienia uniwersalne W drukarkach bez ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skonfiguruj ustawienia. konfigurowanie papieru Universal papier Universal konfiguracja"},{"UUID":"afd2eb06-8aac-47a1-bfac-41537015acf2","title":"Ładowanie papieru i nośników specjalnych","link":"loading-paper-and-specialty-media-group.html","desc":"Ładowanie zasobnika Zdejmij zasobnik. Dopasuj","descFull":"Ładowanie zasobnika Zdejmij zasobnik. Dopasuj prowadnice do rozmiaru ładowanego papieru. Przed załadowaniem papier należy wygiąć, przekartkować i wyrównać. Załaduj stos papieru stroną do druku skierowaną w dół, a następnie upewnij się, że boczne prowadnice są dokładnie dopasowane do papieru. W przypadku drukowania jednostronnego załaduj papier firmowy stroną do zadrukowania skierowaną w dół, górną krawędzią arkusza w kierunku przodu zasobnika. W przypadku drukowania dwustronnego załaduj papier firmowy stroną przeznaczoną do zadrukowania skierowaną w górę, dolną krawędzią arkusza w kierunku przodu zasobnika. Nie należy wsuwać papieru do zasobnika. Aby uniknąć zacięć, upewnij się, że wysokość stosu nie wykracza poza wskaźnik maksymalnego wypełnienia papierem. Włóż zasobnik. W razie potrzeby wybierz ustawienia rozmiaru i typu papieru odpowiadające papierowi załadowanemu do zasobnika. taca ładowanie ładowanie papieru w podajniku"},{"UUID":"6417ba12-dfec-41a9-b8f2-4525dc0c6abf","title":"Ładowanie papieru i nośników specjalnych","link":"loading-paper-and-specialty-media-group.html","desc":"Ładowanie nośników do podajnika ręcznego","descFull":"Ładowanie nośników do podajnika ręcznego Otwórz podajnik ręczny. Dopasuj prowadnicę do rozmiaru ładowanego papieru. Załaduj arkusz papieru stroną do zadrukowania skierowaną w górę W przypadku drukowania jednostronnego załaduj papier firmowy stroną do zadrukowania skierowaną w górę, górną krawędzią w kierunku drukarki. W przypadku drukowania dwustronnego załaduj papier firmowy stroną do zadrukowania skierowaną w dół, górną krawędzią w kierunku przeciwnym do drukarki. Koperty należy wkładać wzdłuż lewej strony prowadnicy papieru, skrzydełkami do góry. Aby uniknąć zacięć papieru, nie należy wpychać go do podajnika na siłę. ładowanie nośników do podajnika ręcznego podajnik ręczny ładowanie koperty ładowanie papier firmowy ładowanie"},{"UUID":"459e7b2d-2a6c-436c-8c63-d5754868d8ef","title":"Instalacja i aktualizacja oprogramowania, sterowników oraz oprogramowania sprzętowego","link":"installing-printer-software-topic.html","desc":"Instalowanie oprogramowania drukarki Sterownik drukarki","descFull":"Instalowanie oprogramowania drukarki Sterownik drukarki jest dołączony do pakietu instalatora oprogramowania. W przypadku komputerów Macintosh z systemem operacyjnym macOS w wersji 10.7 lub nowszej sterownik nie jest potrzebny, aby możliwe było drukowanie na drukarkach kompatybilnych z funkcją AirPrint. Jeśli chcesz korzystać z niestandardowych funkcji drukowania, pobierz sterownik drukarki. Przygotuj kopię pakietu instalatora oprogramowania. Z dysku CD z oprogramowaniem dostarczonego z drukarką. Odwiedź stronę  www.lexmark.com/downloads . Odwiedź stronę pod adresem  www.dell.com/support/printers . Z naszej strony internetowej lub punktu sprzedaży, w którym nabyto drukarkę. Uruchom instalator, a następnie wykonaj instrukcje wyświetlane na ekranie komputera. instalowanie oprogramowania drukarki oprogramowanie drukarki instalowanie instalacja sterownika drukarki sterownik drukarki instalowanie"},{"UUID":"79de37d3-a071-4bf7-8be3-d79521d49c4e","title":"Instalacja i aktualizacja oprogramowania, sterowników oraz oprogramowania sprzętowego","link":"installing-printer-software-topic.html","desc":"Dodawanie drukarek do komputera Przed","descFull":"Dodawanie drukarek do komputera Przed rozpoczęciem wykonaj jedną z następujących czynności: Podłącz drukarkę i komputer do tej samej sieci. Aby uzyskać więcej informacji na temat podłączania drukarki do sieci, zobacz  . Podłącz komputer do drukarki. Więcej informacji można znaleźć w sekcji  . Podłącz drukarkę do komputera przy użyciu kabla USB. Więcej informacji można znaleźć w sekcji  . Kabel USB jest sprzedawany oddzielnie. Użytkownicy systemu Windows Korzystając z komputera, zainstaluj sterownik drukarki. Więcej informacji można znaleźć w sekcji  . Otwórz menu  Drukarki i skanery , a następnie kliknij przycisk  Dodaj drukarkę lub skaner . W zależności od połączenia drukarki wykonaj jedną z następujących czynności: Wybierz drukarkę z listy, a następnie kliknij przycisk  Dodaj urządzenie . Kliknij przycisk  Pokaż drukarki Wi-Fi Direct , wybierz drukarkę, a następnie kliknij przycisk  Dodaj urządzenie . Kliknij przycisk  Drukarki, której szukam, nie ma na liście , a następnie w oknie  Dodaj drukarkę  wykonaj następujące czynności: Wybierz opcję  Dodaj drukarkę, używając adresu TCP/IP lub nazwy hosta , a następnie kliknij przycisk  Dalej . W polu „ Nazwa hosta lub adres IP ” wpisz adres IP drukarki, a następnie kliknij przycisk  Dalej . Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Wybierz sterownik drukarki, a następnie kliknij przycisk  Dalej . Wybierz opcję  Użyj aktualnie zainstalowanego sterownika drukarki (zalecane) , a następnie kliknij przycisk  Dalej . Wpisz nazwę drukarki, a następnie kliknij przycisk  Dalej . Wybierz opcję udostępniania drukarki, a następnie kliknij przycisk  Dalej . Kliknij przycisk  Zakończ . Użytkownicy komputerów Macintosh Korzystając z komputera, otwórz okno  Drukarki i skanery . Kliknij  , a następnie wybierz drukarkę. Z menu  Użyj  wybierz sterownik drukarki. Aby użyć sterownika drukarki dla komputera Macintosh, wybierz opcję  AirPrint  lub  Secure AirPrint . Jeśli chcesz korzystać z niestandardowych funkcji drukowania, wybierz sterownik drukarki Lexmark. Aby zainstalować sterownik, zobacz  . Jeśli chcesz korzystać z niestandardowych funkcji drukowania, wybierz sterownik drukarki producenta. Aby zainstalować sterownik, zobacz  . Dodaj drukarkę. dodawanie drukarek do komputera"},{"UUID":"cc0a8a47-48bb-4ebe-ad47-cf5393757ab9","title":"Instalacja i aktualizacja oprogramowania, sterowników oraz oprogramowania sprzętowego","link":"installing-printer-software-topic.html","desc":"Instalacja sterownika faksu Przejdź do","descFull":"Instalacja sterownika faksu Przejdź do strony  www.lexmark.com/downloads , wyszukaj model drukarki, a następnie pobierz odpowiedni pakiet instalatora. Przejdź do naszej witryny internetowej lub miejsca zakupu drukarki, a następnie pobierz pakiet instalatora. Przejdź do strony  www.dell.com/support , a następnie pobierz odpowiedni pakiet instalatora. Na komputerze kliknij opcję  Właściwości drukarki , a następnie przejdź do karty  Konfiguracja . Uruchom instalator, a następnie wykonaj instrukcje wyświetlane na ekranie komputera. Zaznacz  Faksowanie , a następnie kliknij przycisk  Dalej . sterownik faksu instalowanie instalowanie sterownika drukarki"},{"UUID":"ab5986a8-1cba-40a6-a329-292a634b6a42","title":"Instalacja i aktualizacja oprogramowania, sterowników oraz oprogramowania sprzętowego","link":"installing-printer-software-topic.html","desc":"Aktualizacja oprogramowania sprzętowego Niektóre aplikacje","descFull":"Aktualizacja oprogramowania sprzętowego Niektóre aplikacje do poprawnego działania wymagają odpowiedniej wersji oprogramowania sprzętowego. Aby uzyskać więcej informacji dotyczących aktualizacji oprogramowania sprzętowego, skontaktuj się z przedstawicielem firmy Lexmark. Aby uzyskać więcej informacji dotyczących aktualizacji oprogramowania sprzętowego, skontaktuj się z przedstawicielem firmy Dell. Aby uzyskać więcej informacji dotyczących aktualizacji oprogramowania sprzętowego, skontaktuj się z przedstawicielem handlowym. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij  Ustawienia Urządzenie Aktualizuj oprogramowanie sprzętowe . Wykonaj jedną z następujących czynności: Kliknij opcję  Sprawdź dostępność aktualizacji Zgadzam się, rozpocznij aktualizację . Prześlij plik flash. Aby pobrać najnowsze oprogramowanie sprzętowe, odwiedź stronę  www.lexmark.com/downloads  i odszukaj wybrany model drukarki. Wyszukaj żądany plik flash. Upewnij się, że plik zip z oprogramowaniem sprzętowym został rozpakowany. Kliknij przycisk  Prześlij Start . aktualizacja oprogramowania sprzętowego oprogramowanie sprzętowe, aktualizowanie"},{"UUID":"570b939f-73a5-4da4-8270-707ffa8e4b8d","title":"Instalacja i aktualizacja oprogramowania, sterowników oraz oprogramowania sprzętowego","link":"installing-printer-software-topic.html","desc":"Eksportowanie lub importowanie pliku konfiguracyjnego","descFull":"Eksportowanie lub importowanie pliku konfiguracyjnego Ustawienia konfiguracji drukarki można wyeksportować do pliku tekstowego, a następnie zaimportować, aby użyć tych ustawień w innych drukarkach. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. W oprogramowaniu Embedded Web Server kliknij opcję  Eksportuj konfigurację  lub  Importuj konfigurację . Postępuj według instrukcji wyświetlanych na ekranie. Jeśli drukarka obsługuje aplikacje, wykonaj następujące czynności: Kliknij pozycję  Aplikacje  wybierz aplikację  Konfiguruj . Kliknij opcję  Eksportuj  lub  Importuj . eksportowanie pliku konfiguracyjnego korzystanie z wbudowanego serwera WWW importowanie pliku konfiguracyjnego korzystanie z wbudowanego serwera WWW"},{"UUID":"2fdf7376-a711-4d4c-bc6b-75c05b87a226","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Podłączanie drukarki do sieci Wi-Fi","descFull":"Podłączanie drukarki do sieci Wi-Fi Zanim rozpoczniesz, upewnij się że: Opcja  Aktywny adapter  ma ustawioną wartość  Automatyczne . Przy użyciu panelu sterowania przejdź do opcji  Ustawienia Sieć/Porty Przegląd sieci Aktywny adapter . W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Kabel sieci Ethernet nie jest podłączony do drukarki. Korzystanie z kreatora konfiguracji sieci bezprzewodowej w drukarce Te instrukcje dotyczą tylko niektórych modeli drukarek. Przed użyciem kreatora upewnij się, że oprogramowanie sprzętowe drukarki zostało zaktualizowane. Więcej informacji można znaleźć w sekcji  . Na ekranie głównym dotknij opcji  Skonfiguruj teraz . Wybierz sieć Wi-Fi i wpisz hasło sieci. Dotknij opcji  Gotowe . Korzystanie z menu  Ustawienia  w drukarce Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Sieć bezprzewodowa Konfiguracja na panelu drukarki W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz sieć Wi-Fi i wpisz hasło sieci. Podczas wstępnej konfiguracji modeli drukarek z obsługą sieci Wi-Fi pojawia się monit o skonfigurowanie sieci Wi-Fi. Korzystanie z aplikacji Lexmark Mobile Assistant W zależności od posiadanego urządzenia mobilnego pobierz aplikację Lexmark Mobile Assistant ze sklepu  Google\nPlay  lub App Store. W zależności od modelu drukarki wykonaj jedną z następujących czynności: Na ekranie głównym dotknij kolejno  Ustawienia Sieć/porty Sieć bezprzewodowa Konfiguracja za pomocą aplikacji mobilnej Identyfikator drukarki . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Sieć bezprzewodowa Konfiguracja za pomocą aplikacji mobilnej W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Aby wyświetlić identyfikator drukarki, postępuj zgodnie z instrukcjami na wyświetlaczu. Identyfikatorem drukarki jest identyfikator SSID sieci bezprzewodowej  drukarki. W urządzeniu mobilnym uruchom aplikację, a następnie zaakceptuj warunki użytkowania. W razie potrzeby przyznaj uprawnienia. Dotknij  Połącz się z drukarką Przejdź do ustawień sieci Wi-Fi . Podłącz urządzenie przenośne do sieci bezprzewodowej drukarki. Powróć do aplikacji, a następnie dotknij opcji  Konfiguracja połączenia sieci Wi-Fi . Wybierz sieć Wi-Fi i wpisz hasło sieci. Dotknij przycisku  Gotowe . sieć bezprzewodowa podłączanie drukarki do podłączanie drukarki do sieci bezprzewodowej praca w sieci bezprzewodowej"},{"UUID":"71b91fdc-b603-4082-8fc2-7dbb4661c945","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Podłączanie drukarki do sieci bezprzewodowej","descFull":"Podłączanie drukarki do sieci bezprzewodowej za pomocą funkcji Wi‑Fi Protected Setup (WPS) Zanim rozpoczniesz, upewnij się że: Punkt dostępu (router bezprzewodowy) ma certyfikat WPS lub jest zgodny z WPS. Więcej informacji na ten temat można znaleźć w dokumentacji punktu dostępu. W drukarce jest zainstalowana karta sieci bezprzewodowej. Więcej informacji na ten temat można znaleźć w instrukcji dostarczonej wraz z kartą. Opcja  Aktywny adapter  ma ustawioną wartość  Automatyczne . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Przegląd sieci Aktywny adapter W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Korzystanie z przycisku Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Sieć Wi-Fi Protected Setup Metoda z przyciskiem W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Postępuj według instrukcji widocznych na wyświetlaczu. Użycie metody osobistego numeru identyfikacyjnego (kodu PIN) Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Sieć Wi-Fi Protected Setup Metoda kodu PIN W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skopiuj ośmiocyfrowy kod PIN WPS. Uruchom przeglądarkę internetową, a następnie wprowadź adres IP punktu dostępu w polu adresu. Aby uzyskać adres IP, zapoznaj się z dokumentacją punktu dostępu. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Przejdź do ustawień WPS. Więcej informacji na ten temat można znaleźć w dokumentacji punktu dostępu. Wprowadź ośmiocyfrowy kod PIN i zapisz zmiany. Wi‑Fi Protected Setup sieć bezprzewodowa sieć bezprzewodowa Wi‑Fi Protected Setup łączenie z siecią bezprzewodową korzystanie z kodu PIN metoda osobistego numeru identyfikacyjnego łączenie z siecią bezprzewodową korzystanie z metody przyciskowej metoda przyciskowa"},{"UUID":"f9f40c5e-184a-4ace-9ae3-ec4640d45254","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Konfigurowanie opcji Wi‑Fi Direct Wi-Fi","descFull":"Konfigurowanie opcji Wi‑Fi Direct Wi-Fi Direct  to technologia sieci Wi-Fi typu „każdy z każdym”, która umożliwia urządzeniom bezprzewodowym bezpośrednie połączenie z drukarką z funkcją Wi-Fi Direct bez użycia punktu dostępu (routera bezprzewodowego). Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieci/porty Wi-Fi Direct W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Skonfiguruj ustawienia. Włącz Wi-Fi Direct  — umożliwia drukarce rozgłaszanie własnej sieci Wi-Fi Direct. Nazwa Wi-Fi Direct  — przypisuje nazwę sieci Wi-Fi Direct. Hasło Wi-Fi Direct  — przypisuje hasło w celu negocjowania zabezpieczeń sieci bezprzewodowej podczas korzystania z połączenia „każdy z każdym”. Pokaż hasło na stronie konfiguracji  — wyświetla hasło na  stronie konfiguracji sieci . Automatycznie akceptuj żądania przycisków —  umożliwia drukarce automatyczne akceptowanie żądań połączenia. automatyczne akceptowanie żądań przycisku nie jest zabezpieczone. Domyślnie hasło sieci Wi-Fi Direct nie jest widoczne na wyświetlaczu drukarki. Aby wyświetlić hasło, włącz ikonę podglądu hasła. Na panelu sterowania przejdź do  Ustawienia Zabezpieczenia Różne Włącz ujawnienie hasła / kodu PIN . Aby poznać hasło sieci Wi-Fi Direct bez wyświetlania go na wyświetlaczu drukarki, na panelu sterowania przejdź do  Ustawienia Raporty Sieć Strona konfiguracji sieci . Wi‑Fi Direct konfiguracja konfigurowanie opcji Wi‑Fi Direct"},{"UUID":"b02efb38-ca21-4b4a-b4a0-d56ac1167683","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Podłączanie urządzenia przenośnego do drukarki","descFull":"Podłączanie urządzenia przenośnego do drukarki Przed podłączeniem urządzenia przenośnego upewnij się, że funkcja Wi-Fi Direct została skonfigurowana. Więcej informacji można znaleźć w sekcji  . Łączenie za pomocą funkcji Wi‑Fi Direct Te instrukcje dotyczą tylko urządzeń przenośnych z systemem Android. W urządzeniu przenośnym przejdź do menu ustawień. Włącz sieć  Wi-Fi , a następnie dotknij opcji  Wi-Fi Direct . Wybierz nazwę drukarki Wi-Fi Direct. Potwierdź połączenie na panelu sterowania drukarki. Łączenie za pomocą sieci Wi-Fi W urządzeniu przenośnym przejdź do menu ustawień. Dotknij opcji  Wi-Fi , a następnie wybierz nazwę drukarki Wi-Fi Direct. przed identyfikatorem nazwy sieci Wi-Fi Direct dodawano ciąg DIRECT-xy (gdzie x i y to dwa przypadkowe znaki). Wpisz hasło sieci Wi‑Fi Direct. podłączanie urządzenia przenośnego do drukarki urządzenie przenośne podłączanie do drukarki Wi‑Fi Direct włączanie włączanie opcji Wi‑Fi Direct"},{"UUID":"fbdc4225-d0cc-4a47-97cb-d9117e54ff26","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Podłączanie komputera do drukarki Przed","descFull":"Podłączanie komputera do drukarki Przed podłączeniem komputera, wykonaj następujące czynności: Włącz opcję  Wi‑Fi Direct  w drukarce. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Wi-Fi Direct Włącz Wi‑Fi Direct Włącz Zanotuj nazwę sieci Wi-Fi Direct. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty  Wi-Fi Direct Nazwa sieci Wi-Fi Direct Zanotuj hasło sieci Wi-Fi Direct. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty  Wi-Fi Direct Hasło sieci Wi-Fi Direct można także skonfigurować nazwę i hasło sieci Wi-Fi Direct. W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Użytkownicy systemu Windows Otwórz menu  Drukarki i skanery , a następnie kliknij przycisk  Dodaj drukarkę lub skaner . Kliknij opcję  Pokaż drukarki Wi-Fi Direct , a następnie wybierz nazwę drukarki Wi-Fi Direct. Na wyświetlaczu drukarki zostanie wyświetlony ośmiocyfrowy numer PIN. Zanotuj go. Wprowadź kod PIN do komputera. jeśli sterownik drukarki nie został jeszcze zainstalowany, system Windows pobierze odpowiedni sterownik. Użytkownicy komputerów Macintosh Kliknij ikonę sieci bezprzewodowej, a następnie wybierz nazwę sieci Wi-Fi Direct drukarki. przed identyfikatorem nazwy sieci Wi-Fi Direct dodawano ciąg DIRECT-xy (gdzie x i y to dwa przypadkowe znaki). Wpisz hasło sieci Wi‑Fi Direct. Po rozłączeniu z siecią Wi-Fi Direct połącz komputer z powrotem do poprzedniej sieci. komputer podłączanie drukarki podłączanie komputera do drukarki"},{"UUID":"6999008f-1766-4dcd-86ba-38f8655097cb","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Wyłączanie sieci Wi-Fi Przy użyciu","descFull":"Wyłączanie sieci Wi-Fi Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Przegląd sieci Aktywny adapter Sieć standardowa W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Postępuj według instrukcji widocznych na wyświetlaczu. sieć Wi-Fi wyłączanie wyłączanie sieci Wi-Fi"},{"UUID":"7e33505e-4d93-49eb-8a25-3ffd8ae4c4a8","title":"Sieć","link":"connecting-printer-to-wireless-network-topic.html","desc":"Sprawdzanie połączenia drukarki Drukowanie strony","descFull":"Sprawdzanie połączenia drukarki Drukowanie strony konfiguracji sieci. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Sieć Strona konfiguracji sieci W drukarkach bez ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Sprawdź w pierwszej sekcji strony, czy stan drukarki to Podłączona. Jeśli stan ma wartość Niepodłączona, może to oznaczać, że sieć LAN nie działa lub że kabel sieciowy jest odłączony lub uszkodzony. Aby uzyskać pomoc, skontaktuj się z administratorem systemu. sprawdzanie połączenia drukarki podłączenie drukarki sprawdzanie"},{"UUID":"8b2447e1-bcbb-4d74-a41a-310f1e7eeaa8","title":"Przygotowanie, instalacja i konfiguracja","link":"creating-cloud-connector-profile-topic.html","desc":"Tworzenie profilu Cloud Connector Zalecamy","descFull":"Tworzenie profilu Cloud Connector Zalecamy zalogowanie się do drukarki przed utworzeniem profilu. Aby aktywować metodę logowania, zobacz  Podręcznik administratora bezpieczeństwa wbudowanego serwera WWW . Na ekranie głównym dotknij opcji  Cloud Connector . Wybierz dostawcę usługi w chmurze. Dotknij opcji  Utwórz  lub  . Wprowadź unikatową nazwę profilu. Jeśli to konieczne, wprowadź kod PIN. Podczas korzystania z drukarki jako gość zabezpiecz swój profil kodem PIN. Dotknij opcji  OK , po czym zanotuj kod autoryzacji. Kod autoryzacji jest ważny tylko przez 24 godziny. Uruchom przeglądarkę internetową, a następnie przejdź do strony  https://lexmark.cloud-connect.co . Uruchom przeglądarkę internetową, a następnie przejdź do strony  https://dellprinter.com/cc1 . Kliknij  Dalej , a następnie zaakceptuj warunki użytkowania. Wprowadź kod autoryzacji, a następnie kliknij przycisk  Połącz . Zaloguj się na swoje konta u dostawcy usługi w chmurze. Przyznaj uprawnienia. Aby zakończyć proces autoryzacji, otwórz swój profil w ciągu 72 godzin. tworzenie profilu Cloud Connector profil Cloud Connector tworzenie"},{"UUID":"7a4ea539-fda9-4059-81df-504cc973f0e6","title":"Przygotowanie, instalacja i konfiguracja","link":"printing-menu-settings-page-h1-topic.html","desc":"Drukowanie strony ustawień menu Przy","descFull":"Drukowanie strony ustawień menu Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Strona ustawień menu W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. drukowanie Strona ustawień menu Strona ustawień menu drukowanie"},{"UUID":"b2112ac9-81b5-4d46-aa56-ea68953239ac","title":"Zabezpieczanie drukarki","link":"erasing-printer-memory-topic.html","desc":"Czyszczenie pamięci drukarki Aby wymazać","descFull":"Czyszczenie pamięci drukarki Aby wymazać pamięć ulotną lub zbuforowane dane, wyłącz drukarkę. Aby wymazać pamięć nieulotną lub ustawienia indywidualne, ustawienia urządzenia, sieci, zabezpieczeń oraz wbudowanych rozwiązań, wykonaj poniższe czynności: Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenia Konserwacja Usuwanie po awarii Wyczyść wszystkie informacje w pamięci nieulotnej W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wybierz opcję  Uruchom wstępną konfigurację  lub  Pozostaw drukarkę w trybie offline . pamięć ulotna wymazywanie pamięć nieulotna wymazywanie czyszczenie pamięci drukarki pamięć drukarki wymazywanie"},{"UUID":"9b173f54-4669-417a-b723-26d933fe7ab2","title":"Zabezpieczanie drukarki","link":"restoring-factory-default-settings-topic.html","desc":"Przywracanie ustawień fabrycznych Przy użyciu","descFull":"Przywracanie ustawień fabrycznych Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Przywróć ustawienia fabryczne W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz opcję  Przywróć wszystkie ustawienia . fabryczne ustawienia domyślne przywracanie ustawienia drukarki przywracanie ustawień fabrycznych przywracanie ustawień fabrycznych"},{"UUID":"8dffcfe8-1a4f-4bcd-bb3e-691102dfc352","title":"Zabezpieczanie drukarki","link":"statement-of-volatility-topic.html","desc":"Informacje o ulotności pamięci Drukarka","descFull":"Informacje o ulotności pamięci Drukarka jest wyposażona w różnego rodzaju pamięci mogące przechowywać ustawienia urządzenia i sieci oraz dane użytkowników. Rodzaje pamięci i ich opisy Typ pamięci Opis Pamięć ulotna Drukarka korzysta ze standardowej  pamięci o dostępie swobodnym  (RAM) w celu czasowego zbuforowania danych użytkownika podczas prostych zadań drukowania. Pamięć nieulotna Drukarka może wykorzystywać dwa rodzaje pamięci nieulotnej: EEPROM i NAND (pamięć flash). Oba typy są używane do zapisu informacji o systemie operacyjnym, ustawieniach urządzenia oraz sieci. Wymaż zawartość dowolnych zainstalowanych pamięci drukarki w następujących sytuacjach: Drukarka jest wycofywana z użycia. Drukarka jest przenoszona do innego działu lub lokalizacji. Osoba spoza organizacji wykonuje serwis drukarki. W celach serwisowych drukarka ma znaleźć się poza siedzibą organizacji. Drukarka jest sprzedawana innej organizacji. informacje o ulotności pamięci ulotność informacje o pamięć typy zainstalowanej w drukarce pamięć ulotna pamięć nieulotna"},{"UUID":"4e031ee5-b16e-49fd-8f60-f69c39c6444c","title":"Drukowanie","link":"printing-from-computer-h2-topic.html","desc":"Drukowanie z komputera W przypadku","descFull":"Drukowanie z komputera W przypadku nośników specjalnych, takich jak etykiety, karty i koperty, przed wydrukowaniem dokumentu ustaw rozmiar i typ papieru w drukarce. Przejdź do dokumentu, który chcesz wydrukować i otwórz okno dialogowe Drukuj. W razie potrzeby dostosuj ustawienia. Wydrukuj dokument. drukowanie z komputera dokumenty, drukowanie z komputera drukowanie z komputera"},{"UUID":"97840b00-0572-43cd-b9a6-cc600d022535","title":"Drukowanie z urządzenia przenośnego","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukowanie z urządzenia przenośnego za","descFull":"Drukowanie z urządzenia przenośnego za pomocą usługi Lexmark Mobile Print Drukowanie z urządzenia przenośnego za pomocą usługi Lexmark Mobile Print Lexmark  Usługa Mobile Print umożliwia wysyłanie dokumentów i obrazów bezpośrednio do obsługiwanego urządzenia Lexmark. Otwórz dokument, a następnie prześlij lub udostępnij go w usłudze Lexmark Mobile Print. Niektóre aplikacje innych producentów mogą nie obsługiwać funkcji wysyłania i udostępniania. Więcej informacji na ten temat można znaleźć w dokumentacji dostarczonej z aplikacją. Wybieranie drukarki z listy. Wydrukuj dokument. Lexmark Mobile Print korzystanie dokumenty, drukowanie z urządzenia przenośnego urządzenie przenośne drukowanie"},{"UUID":"10ef65a7-1d28-45a7-b5b0-c11761d02ae0","title":"Drukowanie z urządzenia przenośnego","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukowanie z urządzenia przenośnego za","descFull":"Drukowanie z urządzenia przenośnego za pomocą usługi Lexmark Print Lexmark  Print to mobilne rozwiązanie do drukowania dla urządzeń przenośnych z system  Android  6.0 lub nowszym. Umożliwia wysyłanie dokumentów i obrazów do podłączonych do sieci drukarek i serwerów zarządzania drukowaniem. Upewnij się, że pobierasz aplikację usługi drukowania Lexmark Print ze sklepu  Google Play  i włącz ją na urządzeniu przenośnym. Sprawdź, czy drukarka i urządzenie przenośne są podłączone do tej samej sieci. Na urządzeniu przenośnym wybierz dokument z menedżera plików. Wyślij lub udostępnij dokument w usłudze Lexmark Print. Niektóre aplikacje innych producentów mogą nie obsługiwać funkcji wysyłania i udostępniania. Więcej informacji na ten temat można znaleźć w dokumentacji dostarczonej z aplikacją. Wybierz drukarkę, a następnie w razie potrzeby dostosuj jej ustawienia. Wydrukuj dokument. Lexmark Print korzystanie dokumenty, drukowanie z urządzenia przenośnego urządzenie przenośne drukowanie"},{"UUID":"f66ed955-dd5b-4ba5-b82a-e4d35d79f5ea","title":"Drukowanie z urządzenia przenośnego","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukowanie z urządzenia przenośnego za","descFull":"Drukowanie z urządzenia przenośnego za pomocą usługi drukowania Mopria Usługa drukowania  Mopria to mobilne rozwiązanie do drukowania dla urządzeń przenośnych z system  Android  5.0 lub nowszym. Umożliwia bezpośrednie drukowanie na dowolnej drukarce kompatybilnej z usługą drukowania Mopria. Upewnij się, że pobierasz aplikację usługi drukowania Mopria ze sklepu  Google Play  i włącz ją na urządzeniu przenośnym. Na urządzeniu przenośnym z systemem Android otwórz dokument lub wybierz dokument przy pomocy menedżera plików. Dotknij opcji  Drukuj . Wybierz drukarkę, a następnie w razie potrzeby dostosuj jej ustawienia. Dotknij opcji  . usługa druku Mopria drukowanie z urządzenia przenośnego urządzenie przenośne drukowanie z drukowanie korzystanie z usługi druku Mopria"},{"UUID":"b2ce5dec-3df7-4f15-9579-882fffe2eb40","title":"Drukowanie z urządzenia przenośnego","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukowanie z urządzenia przenośnego za","descFull":"Drukowanie z urządzenia przenośnego za pomocą funkcji AirPrint Oprogramowanie AirPrint to mobilne rozwiązanie, które umożliwia bezpośrednie drukowanie z urządzeń firmy Apple na drukarkach kompatybilnych z tą funkcją. Upewnij się, że urządzenie Apple i drukarka są podłączone do tej samej sieci. Jeśli sieć ma więcej koncentratorów bezprzewodowych, upewnij się, że oba urządzenia są podłączone do tej samej podsieci. Ta aplikacja jest obsługiwana tylko w niektórych urządzeniach firmy Apple. W urządzeniu przenośnym wybierz dokument z menedżera plików lub uruchom zgodną aplikację. Dotknij opcji  Drukuj . Wybierz drukarkę, a następnie w razie potrzeby dostosuj jej ustawienia. Wydrukuj dokument. AirPrint korzystanie drukowanie z urządzenia przenośnego urządzenie przenośne drukowanie z"},{"UUID":"b8af3d83-fab7-43d7-b65d-5f38bdaedc66","title":"Drukowanie z urządzenia przenośnego","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukowanie z urządzenia przenośnego za","descFull":"Drukowanie z urządzenia przenośnego za pomocą funkcji Wi‑Fi Direct® Wi‑Fi Direct  to usługa drukowania, która umożliwia drukowanie na dowolnej drukarce kompatybilnej z funkcją Wi‑Fi Direct. Upewnij się, że urządzenie przenośne jest podłączone do sieci bezprzewodowej drukarki. Więcej informacji można znaleźć w sekcji  . Na urządzeniu przenośnym uruchom kompatybilną aplikację lub wybierz dokument z menedżera plików. W zależności od urządzenia przenośnego wykonaj jedną z następujących czynności: Dotknij opcji  Drukuj . Dotknij opcji  Drukuj . Dotknij opcji  Drukuj . Wybierz drukarkę, a następnie w razie potrzeby dostosuj jej ustawienia. Wydrukuj dokument. Wi‑Fi Direct drukowanie z urządzenia przenośnego drukowanie z urządzenia przenośnego urządzenie przenośne drukowanie z drukowanie korzystanie z opcji Wi‑Fi Direct"},{"UUID":"44624e8d-b9a2-49f2-912f-e1ae9a50cebf","title":"Drukowanie","link":"printing-from-flash-drive-topic.html","desc":"Drukowanie z napędu flash Ta","descFull":"Drukowanie z napędu flash Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Włóż dysk flash. Jeżeli włożysz napęd flash do portu USB w momencie wyświetlania komunikatu o błędzie, drukarka zignoruje napęd flash. Jeśli napęd flash zostanie włożony w momencie, gdy drukarka przetwarza inne zadania drukowania, na wyświetlaczu pojawi się komunikat  Zajęta . Wybierz dokument, który chcesz wydrukować. Jeśli jest to konieczne, skonfiguruj inne ustawienia drukowania. Wydrukuj dokument. Aby wydrukować kolejny dokument, wybierz opcję  Napęd USB . Podczas drukowania, odczytu z karty pamięci oraz zapisu na niej nie wolno dotykać napędu flash ani drukarki w pokazanych obszarach, aby uniknąć utraty danych lub uszkodzenia urządzenia. drukowanie z dysku flash drukowanie z napędu flash napęd flash drukowanie"},{"UUID":"c2ce259e-42e2-47c7-984e-af46d7d7998e","title":"Drukowanie","link":"supported-flash-drives-and-file-types-topic.html","desc":"Obsługiwane napędy flash i typy","descFull":"Obsługiwane napędy flash i typy plików Napędy flash Lexar JumpDrive S70 (16 GB i 32 GB) SanDisk Cruzer (16 GB i 32 GB) PNY Attache (16 GB i 32 GB) Drukarka obsługuje szybkie napędy flash zgodne ze standardem Hi-Speed. Napędy flash muszą obsługiwać system plików FAT (File Allocation Table). Przetestowano i zatwierdzono do użytku z tą drukarką wiele modeli napędów flash. Więcej informacji na ten temat można uzyskać w miejscu zakupu drukarki. Przetestowano i zatwierdzono do użytku z tą drukarką wiele modeli napędów flash. Więcej informacji można znaleźć na stronie  www.dell.com/support/printers . Typy plików Dokumenty PDF (wersja 1.7 lub starsze) Obrazy .dcx .gif .JPEG lub .jpg .bmp .pcx .TIFF lub .tif .png obsługiwane napędy flash obsługiwane typy plików"},{"UUID":"1f4b126e-bcc5-431d-bee7-f49d16110d39","title":"Drukowanie","link":"configuring-confidential-jobs-topic.html","desc":"Konfiguracja poufnych zadań Korzystanie z panelu","descFull":"Konfiguracja poufnych zadań Korzystanie z panelu sterowania Na ekranie głównym dotknij opcji: Ustawienia Bezpieczeństwo Ustawienia druku poufnego Skonfiguruj ustawienia. Korzystając z wbudowanego serwera WWW Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Ustawienia Bezpieczeństwo Ustawienia druku poufnego . Skonfiguruj ustawienia. zadania wydruku poufnego konfigurowanie zadania wstrzymane zadania drukowania przechowywanie zadania wydruku powtarzanego próbne zadania drukowania"},{"UUID":"950237fd-1092-46ef-b8b4-e2c82564ed97","title":"Drukowanie","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Drukowanie zadań poufnych i innych","descFull":"Drukowanie zadań poufnych i innych zadań wstrzymanych Użytkownicy systemu Windows Otwórz dokument i kliknij kolejno polecenia  Plik Drukuj . Wybierz drukarkę i kliknij kolejno  Właściwości ,  Preferencje ,  Opcje  lub  Ustawienia . Kliknij przycisk  Drukowanie z wstrzymaniem . Wybierz opcję  Użyj drukowania z zatrzymaniem , a następnie przypisz mu nazwę użytkownika. Wybierz typ zadania drukowania (Poufne, Odroczone, Powtarzane lub Próbne). W przypadku wybrania opcji  Poufne  zabezpiecz zadanie drukowania osobistym numerem identyfikacyjnym (PIN). Kliknij przycisk  OK  lub  Drukuj . Zwolnienie zadania drukowania z panelu sterowania drukarki. Aby uzyskać dostęp do poufnych zadań drukowania, wybierz kolejno pozycje: Zadania wstrzymane  wybierz nazwę użytkownika Poufne  wprowadź kod PIN  wybierz zadanie drukowania  skonfiguruj ustawienia Drukuj W przypadku innych zadań drukowania przejdź do opcji: Zadania wstrzymane  wybierz nazwę użytkownika  wybierz zadanie drukowania  skonfiguruj ustawienia Drukuj W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Użytkownicy komputerów Macintosh Korzystający z AirPrint Otwórz dokument i wybierz kolejno:  File  (Plik) Print  (Drukuj). Wybierz drukarkę, a następnie z menu rozwijanego w menu  Orientacja  wybierz opcję  Drukowanie z kodem PIN . Włącz opcję  Drukuj z kodem PIN , a następnie wprowadź czterocyfrowy kod PIN. Kliknij przycisk  Drukuj . Zwolnienie zadania drukowania z panelu sterowania drukarki. Przejdź do opcji: Zadania wstrzymane  Wybierz nazwę komputera Poufne  Wprowadź kod PIN Wybierz zadanie drukowania Drukuj W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Korzystanie ze sterownika drukowania Otwórz dokument i wybierz kolejno:  File  (Plik) Print  (Drukuj). Wybierz drukarkę, a następnie z menu rozwijanego w menu  Orientacja  wybierz opcję  Drukowanie ze wstrzymaniem . Wybierz opcję  Wydruk poufny  i wprowadź czterocyfrowy kod PIN. Kliknij przycisk  Drukuj . Zwolnienie zadania drukowania z panelu sterowania drukarki. Przejdź do opcji: Zadania wstrzymane  Wybierz nazwę komputera Poufne  Wybierz zadanie drukowania Wprowadź kod PIN Drukuj W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. drukowanie zadania wstrzymane drukowanie zadania wydruku poufnego drukowanie zadania wydruku powtarzanego drukowanie zadania wydruku odroczonego drukowanie próbne zadania drukowania"},{"UUID":"b2174231-f70c-4ed4-83d9-4bacd750698e","title":"Drukowanie","link":"printing-from-cloud-connector-profile-topic.html","desc":"Drukowanie za pomocą profilu Cloud","descFull":"Drukowanie za pomocą profilu Cloud Connector Drukowanie za pomocą profilu  Cloud Connector Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Na ekranie głównym dotknij opcji  Cloud Connector . Wybierz dostawcę usług w chmurze, a następnie wybierz profil. Więcej informacji na temat tworzenia profilu  Cloud Connector  znajduje się w sekcji  . Dotknij opcji  Drukuj , a następnie wybierz plik. W razie potrzeby zmień ustawienia. Upewnij się, że wybrano obsługiwany plik. Wydrukuj dokument. profil Cloud Connector drukowanie z drukowanie za pomocą profilu Cloud Connector"},{"UUID":"ccb76a02-f5d8-45e4-ba53-71983cf794e1","title":"Drukowanie","link":"printing-font-sample-list-topic.html","desc":"Drukowanie listy wzorców czcionek Przy","descFull":"Drukowanie listy wzorców czcionek Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia  Raporty Drukuj Drukuj czcionki W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Umożliwia wybranie  czcionek PCL . drukowanie lista wzorców czcionek lista wzorców czcionek drukowanie"},{"UUID":"580f31ad-cb85-48ed-bfc5-be7d48cb9354","title":"Drukowanie","link":"placing-separator-sheets-topic.html","desc":"Umieszczanie arkuszy separujących między kopiami","descFull":"Umieszczanie arkuszy separujących między kopiami Z ekranu głównego przejdź do opcji: Ustawienia Drukowanie Układ Arkusze separujące Między kopiami W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wydrukuj dokument. arkusze separujące umieszczanie rozmieszczenie arkuszy separujących"},{"UUID":"3b64ca1d-bf10-45d5-9887-add3dea489f5","title":"Drukowanie","link":"canceling-print-job-topic.html","desc":"Anulowanie zadania drukowania Z panelu","descFull":"Anulowanie zadania drukowania Z panelu sterowania drukarki W zależności od modelu drukarki wykonaj jedną z następujących czynności: Naciśnij dwukrotnie przycisk  , a następnie naciśnij przycisk  . Następnie dotknij opcji  Anuluj zadanie . Wybierz zadanie drukowania, które chcesz anulować. Z komputera W zależności od systemu operacyjnego wykonaj następujące czynności: Otwórz folder drukarek, a następnie wybierz drukarkę. Przejdź do drukarki w obszarze System Preferences (Preferencje systemowe) menu Apple. Zaznacz zadanie przeznaczone do anulowania. zadanie drukowania anulowanie za pomocą panelu sterowania drukarki anulowanie zadania drukowania z panelu sterowania drukarki zadanie drukowania anulowanie z komputera anulowanie zadania drukowania z komputera"},{"UUID":"a3e19a82-021f-4149-9f47-22e7ca967a2f","title":"Drukowanie","link":"adjusting-toner-darkness-topic.html","desc":"Regulowanie intensywności tonera Przy użyciu","descFull":"Regulowanie intensywności tonera Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukowanie Jakość Intensywność tonera W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Dostosuj ustawienia. Zastosuj zmiany. intensywność toneru dostosowywanie regulowanie intensywności toneru"},{"UUID":"1363a75c-4542-484c-bf91-726e105c0d25","title":"Kopiowanie","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Korzystanie z automatycznego podajnika dokumentów","descFull":"Korzystanie z automatycznego podajnika dokumentów i szyby skanera Ładowanie papieru do automatycznego podajnika dokumentów i na szybę skanera Automatyczny podajnik dokumentów Szyba skanera Automatyczny podajnik dokumentów (ADF) umożliwia obsługę dokumentów wielostronnych lub dwustronnych. Załaduj oryginalny dokument treścią do góry. W przypadku dokumentów wielostronicowych wyrównaj krawędź skierowaną w stronę drukarki przed załadowaniem. Dopasuj prowadnice ADF do szerokości ładowanego papieru. Z szyby skanera należy korzystać w przypadku pojedynczych arkuszy lub stron książek, małych przedmiotów (na przykład pocztówek lub fotografii), folii, papieru fotograficznego lub cienkich nośników (na przykład wycinków z czasopism). Umieść dokument zadrukowaną stroną w dół w narożniku oznaczonym strzałką. przy użyciu szyby skanera korzystanie z automatycznego podajnika dokumentów (ADF) automatyczny podajnik dokumentów korzystanie szyba skanera korzystanie kopiowanie korzystanie z automatycznego podajnika dokumentów (ADF) kopiowanie przy użyciu szyby skanera"},{"UUID":"419ca622-6922-4c82-8c7a-8ff7effa1fd9","title":"Kopiowanie","link":"making-copies-topic.html","desc":"Kopiowanie Umieść oryginał na tacy","descFull":"Kopiowanie Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Aby uniknąć przycięcia obrazu, upewnij się, że rozmiary oryginalnego dokumentu i wydruku są identyczne. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiowanie określ liczbę kopii do wykonania W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. W razie potrzeby dostosuj ustawienia. Skopiuj dokument. Aby wykonać szybkie kopiowanie za pomocą panelu sterowania, naciśnij przycisk  . kopiowanie dokumentów kopiowanie korzystanie z podajnika ADF kopiowanie przy użyciu szyby skanera"},{"UUID":"345d2b06-e771-46f6-97e7-e4f89e9d3105","title":"Kopiowanie","link":"copying-photos-topic.html","desc":"Kopiowanie zdjęć Umieść fotografię na","descFull":"Kopiowanie zdjęć Umieść fotografię na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Typ zawartości Fotografia W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skopiuj dokument. kopiowanie fotografii fotografie kopiowanie"},{"UUID":"2b66499c-ed9e-4066-a0e4-f0567281c61b","title":"Kopiowanie","link":"copying-letterhead-topic.html","desc":"Kopiowanie na papierze firmowym Umieść","descFull":"Kopiowanie na papierze firmowym Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Kopiuj z  wybierz rozmiar oryginalnego dokumentu W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz opcję  Kopiuj do , a następnie wybierz źródło papieru zawierające papier firmowy. Jeżeli wkładasz papier firmowy do podajnika ręcznego, przejdź do: Kopiuj do Podajnik ręczny` wybierz rozmiar papieru Papier firmowy . Skopiuj dokument. kopiowanie na papierze firmowym papier firmowy kopiowanie na"},{"UUID":"d7de1654-43d0-42af-8909-44be87bc2fb4","title":"Kopiowanie","link":"copying-on-both-sides-of-paper-topic.html","desc":"Kopiowanie na obu stronach papieru","descFull":"Kopiowanie na obu stronach papieru Umieść oryginalny dokument w automatycznym podajniku dokumentów lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Strony W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Dostosuj ustawienia. Skopiuj dokument. kopiowanie na obu stronach arkusza papieru kopiowanie dwustronne"},{"UUID":"fdff552e-201c-457a-9560-bda40c0f1c23","title":"Kopiowanie","link":"reducing-enlarging-copies-topic.html","desc":"Zmniejszanie lub powiększanie kopii Umieść","descFull":"Zmniejszanie lub powiększanie kopii Umieść oryginalny dokument w automatycznym podajniku dokumentów lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Skala  określ wartość skali W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Zmiana rozmiaru oryginalnego dokumentu lub wydruku po ustawieniu wartości  Skala  na  Auto . Skopiuj dokument. zmniejszanie kopii powiększanie kopii"},{"UUID":"28e8d795-3803-47c0-9b9c-eb71c2fe4a31","title":"Kopiowanie","link":"saving-paper-topic.html","desc":"Kopiowanie kilku stron na jednym","descFull":"Kopiowanie kilku stron na jednym arkuszu Umieść oryginalny dokument w automatycznym podajniku dokumentów lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Stron na arkusz W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Dostosuj ustawienia. Skopiuj dokument. kopiowanie kilku stron na jednym arkuszu kopiowanie wielu stron oszczędność papieru"},{"UUID":"6662bd01-8c9f-4d37-a5bf-c6e3715fb030","title":"Kopiowanie","link":"collating-copies-topic.html","desc":"Sortowanie kopii Umieść oryginał na","descFull":"Sortowanie kopii Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopiuj Sortuj Wł. [1,2,1,2,1,2] W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Skopiuj dokument. sortowanie kopii kopiowanie"},{"UUID":"454d71e4-e429-4ba3-81d6-68ebb1c3516b","title":"Kopiowanie","link":"copying-cards-topic.html","desc":"Kopiowanie kart Umieść kartę na","descFull":"Kopiowanie kart Umieść kartę na szybie skanera. W zależności od modelu drukarki wykonaj jedną z następujących czynności: Na ekranie głównym dotknij opcji  Kopiuj Kopia identyfikatora . Przy użyciu panelu sterowania drukarki przejdź do opcji: Kopia identyfikatora W razie potrzeby dostosuj ustawienia. Skopiuj dokument. kopiowanie karty karty kopiowanie"},{"UUID":"9ac168a4-78ac-460e-ab09-f487802147da","title":"Kopiowanie","link":"creating-copy-shortcut-topic.html","desc":"Tworzenie skrótu kopiowania Do utworzenia","descFull":"Tworzenie skrótu kopiowania Do utworzenia skrótu mogą być wymagane uprawnienia administratora. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . W menu  Typ skrótu  wybierz opcję  Kopiuj , a następnie skonfiguruj ustawienia. Zastosuj zmiany. kopiowanie tworzenie skrótu tworzenie skrótu kopiowanie tworzenie skrótu kopiowania"},{"UUID":"5f215e62-eb2b-495a-aec5-b53963a0c376","title":"Wysyłanie wiadomości e-mail","link":"using-ADF-and-scanner-glass-email-topic.html","desc":"Korzystanie z automatycznego podajnika dokumentów","descFull":"Korzystanie z automatycznego podajnika dokumentów i szyby skanera Ładowanie papieru do automatycznego podajnika dokumentów i na szybę skanera Automatyczny podajnik dokumentów Szyba skanera Automatyczny podajnik dokumentów (ADF) umożliwia obsługę dokumentów wielostronnych lub dwustronnych. Załaduj oryginalny dokument treścią do góry. W przypadku dokumentów wielostronicowych wyrównaj krawędź skierowaną w stronę drukarki przed załadowaniem. Dopasuj prowadnice ADF do szerokości ładowanego papieru. Z szyby skanera należy korzystać w przypadku pojedynczych arkuszy lub stron książek, małych przedmiotów (na przykład pocztówek lub fotografii), folii, papieru fotograficznego lub cienkich nośników (na przykład wycinków z czasopism). Umieść dokument zadrukowaną stroną w dół w narożniku oznaczonym strzałką. przy użyciu szyby skanera korzystanie z automatycznego podajnika dokumentów (ADF) automatyczny podajnik dokumentów korzystanie szyba skanera korzystanie wysyłanie wiadomości e-mail korzystanie z automatycznego podajnika dokumentów (ADF) wysyłanie wiadomości e-mail przy użyciu szyby skanera"},{"UUID":"6fc16f98-eabf-4941-bd40-a6b4175e2449","title":"Wysyłanie wiadomości e-mail","link":"sending-email-topic.html","desc":"Wysyłanie wiadomości e-mail Przed rozpoczęciem","descFull":"Wysyłanie wiadomości e-mail Przed rozpoczęciem upewnij się, że ustawienia SMTP zostały skonfigurowane. Więcej informacji można znaleźć w sekcji  . Korzystanie z panelu sterowania Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Na ekranie głównym dotknij opcji  E-mail , a następnie wprowadź potrzebne informacje. W razie konieczności skonfiguruj ustawienia typu pliku wyjściowego. Wyślij wiadomość e-mail. Przy użyciu numeru skrótu Utwórz skrót wiadomości e-mail. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . W menu  Typ skrótu  wybierz opcję  E‑mail , a następnie skonfiguruj ustawienia. Zastosuj zmiany. Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Skróty E-mail W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz skrót. Wyślij wiadomość e‑mail. e-mail wysyłanie wysyłanie wiadomości e-mail skanowanie do poczty e-mail"},{"UUID":"670f4b39-4a06-4f8c-a409-7a48d1a8118d","title":"Faksowanie","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Korzystanie z automatycznego podajnika dokumentów","descFull":"Korzystanie z automatycznego podajnika dokumentów i szyby skanera Ładowanie papieru do automatycznego podajnika dokumentów i na szybę skanera Automatyczny podajnik dokumentów Szyba skanera Automatyczny podajnik dokumentów (ADF) umożliwia obsługę dokumentów wielostronnych lub dwustronnych. Załaduj oryginalny dokument treścią do góry. W przypadku dokumentów wielostronicowych wyrównaj krawędź skierowaną w stronę drukarki przed załadowaniem. Dopasuj prowadnice ADF do szerokości ładowanego papieru. Z szyby skanera należy korzystać w przypadku pojedynczych arkuszy lub stron książek, małych przedmiotów (na przykład pocztówek lub fotografii), folii, papieru fotograficznego lub cienkich nośników (na przykład wycinków z czasopism). Umieść dokument zadrukowaną stroną w dół w narożniku oznaczonym strzałką. przy użyciu szyby skanera korzystanie z automatycznego podajnika dokumentów (ADF) automatyczny podajnik dokumentów korzystanie szyba skanera korzystanie faksowanie korzystanie z automatycznego podajnika dokumentów (ADF) faksowanie przy użyciu szyby skanera"},{"UUID":"669c57c7-ae4f-4158-97cc-3656790fc561","title":"Faksowanie","link":"sending-fax-topic.html","desc":"Wysyłanie faksu upewnij się, że","descFull":"Wysyłanie faksu upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Korzystanie z panelu sterowania Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Na panelu sterowania dotknij opcji  Faks , a następnie wprowadź niezbędne informacje. W razie potrzeby dostosuj ustawienia. Wyślij faks. Przy użyciu komputera Przed rozpoczęciem upewnij się, że sterownik faksu jest zainstalowany. Więcej informacji można znaleźć w sekcji  . Użytkownicy systemu Windows W dokumencie, który próbujesz przefaksować, otwórz okno dialogowe  Drukuj . Wybierz drukarkę i kliknij kolejno  Właściwości ,  Preferencje ,  Opcje  lub  Ustawienia . Kliknij kolejno  Faks Włącz faks Zawsze wyświetlaj ustawienia przed faksowaniem , a następnie wprowadź numer odbiorcy. W razie potrzeby skonfiguruj inne ustawienia faksu. Wyślij faks. Użytkownicy komputerów Macintosh Otwórz dokument i wybierz kolejno:  File  (Plik) Print  (Drukuj). Wybierz drukarkę o nazwie z końcówką  - Fax . Wprowadź numer odbiorcy w polu  Do . W razie potrzeby skonfiguruj inne ustawienia faksu. Wyślij faks. wysyłanie faksu faks wysyłanie"},{"UUID":"18860666-8e5a-40a7-b3cf-53b36aadcbb5","title":"Faksowanie","link":"scheduling-fax-topic.html","desc":"Planowanie faksu Te instrukcje dotyczą","descFull":"Planowanie faksu Te instrukcje dotyczą tylko niektórych modeli drukarek. upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Na ekranie głównym dotknij opcji  Faks Do wprowadź numer faksu Gotowe . Wybierz opcje  Czas wysyłania , aby ustawić datę i godzinę, a następnie wybierz  Gotowe . W razie potrzeby skonfiguruj inne ustawienia faksu. Wyślij faks. planowanie faksu wysyłanie faksu wg planu"},{"UUID":"006e529c-2621-4998-a681-9dcada643ed7","title":"Faksowanie","link":"creating-fax-destination-shortcut-topic.html","desc":"Tworzenie skrótu do miejsca docelowego","descFull":"Tworzenie skrótu do miejsca docelowego dla faksów Do utworzenia skrótu mogą być wymagane uprawnienia administratora. upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . W menu  Typ skrótu  wybierz opcję  Faks , a następnie skonfiguruj ustawienia. Zastosuj zmiany. tworzenie skrótu do miejsca docelowego dla faksów tworzenie skrótu miejsce docelowe faksu miejsce docelowe faksu tworzenie skrótu"},{"UUID":"8bf45243-40e7-467a-ab6c-2a6d2b1816ba","title":"Faksowanie","link":"changing-fax-resolution-topic.html","desc":"Zmiana rozdzielczości faksu upewnij się,","descFull":"Zmiana rozdzielczości faksu upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Faks Rozdzielczość W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz ustawienie. Wyślij faks. zmiana rozdzielczości faksu rozdzielczość faksu zmiana"},{"UUID":"89bcfc70-9511-4967-ac0d-61d8d660a6a1","title":"Faksowanie","link":"adjusting-fax-darkness-topic.html","desc":"Dostosowywanie intensywności faksu upewnij się,","descFull":"Dostosowywanie intensywności faksu upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Faks Intensywność tonera W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz ustawienie. Wyślij faks. dostosowywanie intensywności faksowania przyciemnienie faksu regulacja"},{"UUID":"c11e1fc0-8570-4e15-99c7-87e918bed9d9","title":"Faksowanie","link":"printing-fax-log-topic.html","desc":"Drukowanie dziennika faksów upewnij się,","descFull":"Drukowanie dziennika faksów upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Faks . W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz opcję  Dziennik zadań faksowania  lub  Dziennik wywołań faksu . dziennik faksu drukowanie drukowanie dziennik faksu"},{"UUID":"03882740-d6e6-4e88-a870-259f5c7287ee","title":"Faksowanie","link":"blocking-junk-faxes-topic.html","desc":"Blokowanie niepożądanych faksów upewnij się,","descFull":"Blokowanie niepożądanych faksów upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Z ekranu głównego przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksu Funkcje sterowania administratora W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Dla ustawienia  Blokuj faksy bez nazwy  wybierz opcję  Włącz . niepożądane faksy blokowanie blokowanie niepożądanych faksów"},{"UUID":"fae543de-0d3d-4bf4-b79c-d74773404f02","title":"Faksowanie","link":"holding-faxes-topic.html","desc":"Wstrzymywanie faksów upewnij się, że","descFull":"Wstrzymywanie faksów upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksu Wstrzymywanie faksów W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz tryb. wstrzymywanie faksów faks wstrzymywanie"},{"UUID":"8e99fb06-17af-4ab7-80ee-1b38911dd1d8","title":"Faksowanie","link":"forwarding-fax-topic.html","desc":"Przekazywanie faksów upewnij się, że","descFull":"Przekazywanie faksów upewnij się, że fax jest skonfigurowany. Więcej informacji można znaleźć w sekcji  . Utwórz skrót do miejsca docelowego. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . Wybierz typ skrótu, a następnie skonfiguruj ustawienia. Zanotuj numer skrótu. Zastosuj zmiany. Kliknij opcję  Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksu Funkcje sterowania administratora . W menu  Przekazywanie faksów  wybierz opcję  Przekaż  lub  Drukuj i prześlij dalej . W menu  Przekaż do  wybierz typ miejsca docelowego, a następnie wpisz numer skrótu. Zastosuj zmiany. przekazywanie faksu faks przekazywanie"},{"UUID":"105e91c0-d84f-4c7b-8950-c0bef418b1aa","title":"Skanowanie","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Korzystanie z automatycznego podajnika dokumentów","descFull":"Korzystanie z automatycznego podajnika dokumentów i szyby skanera Ładowanie papieru do automatycznego podajnika dokumentów i na szybę skanera Automatyczny podajnik dokumentów Szyba skanera Automatyczny podajnik dokumentów (ADF) umożliwia obsługę dokumentów wielostronnych lub dwustronnych. Załaduj oryginalny dokument treścią do góry. W przypadku dokumentów wielostronicowych wyrównaj krawędź skierowaną w stronę drukarki przed załadowaniem. Dopasuj prowadnice ADF do szerokości ładowanego papieru. Z szyby skanera należy korzystać w przypadku pojedynczych arkuszy lub stron książek, małych przedmiotów (na przykład pocztówek lub fotografii), folii, papieru fotograficznego lub cienkich nośników (na przykład wycinków z czasopism). Umieść dokument zadrukowaną stroną w dół w narożniku oznaczonym strzałką. przy użyciu szyby skanera korzystanie z automatycznego podajnika dokumentów (ADF) automatyczny podajnik dokumentów korzystanie szyba skanera korzystanie skanowanie korzystanie z automatycznego podajnika dokumentów (ADF) skanowanie przy użyciu szyby skanera"},{"UUID":"e551fc08-49b2-439a-9e52-bfc890c5bf85","title":"Skanowanie","link":"scanning-to-computer-topic.html","desc":"Skanowanie do komputera Zanim rozpoczniesz,","descFull":"Skanowanie do komputera Zanim rozpoczniesz, upewnij się że: Oprogramowanie sprzętowe drukarki zostało zaktualizowane. Więcej informacji można znaleźć w sekcji  . Komputer i drukarka są podłączone do tej samej sieci. Użytkownicy systemu Windows Skanowanie za pomocą narzędzia Lexmark ScanBack Utility Uruchom narzędzie Lexmark Scanback Utility na komputerze, a następnie kliknij przycisk  Dalej . Aby pobrać narzędzie, odwiedź stronę  www.lexmark.com/downloads . Kliknij przycisk  Ustawienia , a następnie dodaj adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. Kliknij opcję  Zamknij Dalej . Wybierz rozmiar oryginalnego dokumentu, a następnie kliknij przycisk  Dalej . Wybierz format pliku i rozdzielczość skanowania, a następnie kliknij przycisk  Dalej . Wpisz unikalną nazwę profilu skanowania, a następnie kliknij przycisk  Dalej . Przejdź do miejsca, w którym chcesz zapisać zeskanowany dokument, podaj nazwę pliku, a następnie kliknij przycisk  Dalej . aby ponownie użyć profilu skanowania, włącz opcję  Utwórz skrót , a następnie wpisz unikatową nazwę skrótu. Kliknij przycisk  Zakończ . Załaduj oryginalny dokument do podajnika automatycznego lub umieść go na szybie skanera. W zależności od modelu drukarki w panel sterowania wykonaj dowolną z poniższych czynności: Dotknij opcji  Skanuj do komputera , a następnie wybierz profil skanowania. Upewnij się, że opcja  Skanowanie do komputera  jest włączona. Z poziomu ekranu głównego dotknij kolejno  Ustawienia Urządzenie Widoczne ikony ekranu głównego . Przejdź do  Skróty Skanuj do komputera , a następnie wybierz profil skanowania. Użytkownicy systemu Windows Skanowanie za pomocą funkcji Faksowanie i skanowanie w systemie Windows upewnij się, że drukarka jest dodana do komputera. Więcej informacji można znaleźć w sekcji  . Załaduj oryginalny dokument do podajnika automatycznego lub umieść go na szybie skanera. Uruchom narzędzie  Faksowanie i skanowanie w systemie Windows  na komputerze. Z menu  Źródło  wybierz źródło skanera. W razie potrzeby zmień ustawienia skanowania. Zeskanuj dokument. Użytkownicy komputerów Macintosh upewnij się, że drukarka jest dodana do komputera. Więcej informacji można znaleźć w sekcji  . Załaduj oryginalny dokument do podajnika automatycznego lub umieść go na szybie skanera. Na komputerze wykonaj jedną z poniższych czynności: Otwórz aplikację  Image Capture . Otwórz  Drukarki i skanery , a następnie wybierz drukarkę. Kliknij opcję  Skanuj Otwórz skaner . Na ekranie  skanera  wykonaj co najmniej jedną z poniższych czynności: Wybierz miejsca, w którym chcesz zapisać zeskanowany dokument. Wybieranie rozmiaru oryginalnego dokumentu. Aby skanować z automatycznego podajnika dokumentów, wybierz opcję  Podajnik dokumentów  z  Menu skanowania  lub włącz opcję  Użyj podajnika dokumentów . Jeśli to konieczne, skonfiguruj ustawienia skanowania. Kliknij pozycję  Scan  (Skanuj). skanowanie do komputera komputer skanowanie do Narzędzie Lexmark ScanBack Utility korzystanie"},{"UUID":"5e72cd76-ed2b-4303-824a-d80eb4905c9e","title":"Skanowanie","link":"scanning-to-flash-drive-topic.html","desc":"Skanowanie na dysk flash Ta","descFull":"Skanowanie na dysk flash Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Włóż dysk flash. Dotknij opcji  Skanuj do USB  i w razie potrzeby dostosuj ustawienia. Aby zapisać zeskanowany dokument w folderze, dotknij opcji  Skanuj do , wybierz folder, a następnie dotknij opcji  Skanuj tutaj . Jeśli nie pojawia się dysk USB, dotknij opcji  Dysk USB  na panelu sterowania. Zeskanuj dokument. Podczas drukowania, odczytu z karty pamięci oraz zapisu na niej nie wolno dotykać napędu flash ani drukarki w pokazanych obszarach, aby uniknąć utraty danych lub uszkodzenia urządzenia. skanowanie do napędu flash napęd flash skanowanie do"},{"UUID":"75637027-12b3-4665-8cd8-56f240443869","title":"Skanowanie","link":"scanning-to-ftp-server-using-shortcut-topic.html","desc":"Skanowanie do serwera FTP Utwórz","descFull":"Skanowanie do serwera FTP Utwórz skrót do serwera FTP. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . W menu  Typ skrótu  wybierz opcję  FTP , a następnie skonfiguruj ustawienia. Zastosuj zmiany. Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Skróty FTP W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz skrót. Zeskanuj dokument. skanowanie do serwera FTP serwer FTP skanowanie do"},{"UUID":"eb3419db-c090-41ba-a9ab-45006467473e","title":"Skanowanie","link":"scanning-network-folder-using-shortcut-topic.html","desc":"Skanowanie do folderu sieciowego Utwórz","descFull":"Skanowanie do folderu sieciowego Utwórz skrót do folderu sieciowego. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Skróty Dodaj skrót . W menu Typ skrótu wybierz opcję  Folder sieciowy , a następnie skonfiguruj ustawienia. Zastosuj zmiany. Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Z ekranu głównego przejdź do opcji: Skróty Folder sieciowy W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz skrót. skanowanie do folderu sieciowego folder sieciowy skanowanie do"},{"UUID":"c064d9af-6e52-4135-b1d6-12abf3bc7b59","title":"Skanowanie","link":"scanning-to-cloud-connector-profile-topic.html","desc":"Skanowanie do profilu  Cloud","descFull":"Skanowanie do profilu  Cloud Connector Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Umieść oryginał na tacy podajnika ADF lub na szybie skanera. Na ekranie głównym dotknij opcji  Cloud Connector . Wybierz dostawcę usług w chmurze, a następnie wybierz profil. Więcej informacji na temat tworzenia profilu Cloud Connector znajduje się w sekcji  . Dotknij opcji  Skanuj , a następnie przypisz nazwę pliku i folder docelowy. Dotknij opcji  Skanuj tutaj . W razie potrzeby zmień ustawienia wydruku. Zeskanuj dokument. skanowanie to a Cloud Connector profile profil Cloud Connector skanowanie do"},{"UUID":"99f45c80-aa85-4690-9d32-4af323f027c9","title":"Używanie menu drukarki","link":"menu-map-mfp-topic.html","desc":"Mapa menu 1  W","descFull":"Mapa menu 1  W niektórych modelach drukarek to menu może być skonfigurowane tylko z wbudowanego serwera WWW. 2  Dostępne wyłącznie w niektórych modelach drukarek. Urządzenie Preferencje Tryb ekologiczny Zdalny panel operatora 1 Powiadomienia Zarządzanie zasilaniem Zbieranie danych anonim. Przywracanie ustawień fabrycznych Przegląd Widoczne ikony na ekranie głównym 2 Drukarka – informacje Drukuj Układ Ustawienia Jakość Plik PDF 2 PostScript 2 PCL Obraz Papier Konfiguracja tacy Konfiguracja nośnika Kopiuj Domyślne ustawienia kopiowania Faks Domyślne ustawienia faksowania E‑mail 1 Konfiguracja poczty e-mail Domyślne ustawienia e‑mail FTP 1 Domyślne ustawienia FTP Napęd USB 2 Skanuj dysk flash Drukuj z dysku flash Sieć/porty Przegląd sieci komputerowej Łączność bezprzewodowa Wi‑Fi Direct Ethernet TCP/IP SNMP IPSec 802.1x Konfiguracja LPD Ustawienia HTTP/FTP USB Ograniczanie zewnętrznego dostępu do sieci komputerowej Bezpieczeństwo 1 Metody logowania Zarządzanie certyfikatami Harmonogram wyłączeń urządzeń USB 2 Ograniczenia logowania Ustawienia druku poufnego Kasuj pliki tymczasowe Różne Cloud Connector 2 Włączanie/wyłączanie złącza Raporty Strona ustawień menu Urządzenie Drukuj Skróty Faks W sieci Rozwiązywanie problemów Drukuj strony testu jakości Czyszczenie skanera menu drukarki"},{"UUID":"6bc79678-0341-4658-adc8-826899d8f240","title":"Urządzenie","link":"preferences-topic.html","desc":"Preferencje Elementy menu  Preferences","descFull":"Preferencje Elementy menu  Preferences  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Język wyświetlany [Lista języków] Umożliwia ustawienie języka tekstu pojawiającego się na wyświetlaczu. Kraj/region [Lista krajów lub regionów] Określenie kraju lub regionu, pod kątem którego skonfigurowano drukarkę do pracy. Uruchom konf. początk. Nie * Tak Uruchamia Kreatora konfiguracji. Klawiatura Typ klawiatury [Lista języków] Wybierz język jako typ klawiatury. Mogą nie pojawić się wszystkie wartości  Keyboard Type  lub mogą wymagać zainstalowania specjalnego sprzętu. Wyświetlane informacje Wyświetlany tekst 1  ( adres IP *) Wyświetlany test 2  ( data/godzina *) Tekst niestandardowy 1 Tekst niestandardowy 2 Określ informacje wyświetlane na ekranie głównym. Data i godzina Konfiguruj Bieżąca data i godzina Ustaw ręcznie datę i godzinę Format daty  (MM‑DD‑RRRR*) Format godziny  (12-godz. A.M./P.M.*) Strefa czasowa Skonfiguruj daty i godziny w drukarce. Data i godzina Protok. ust. czasu siec. Włącz funkcję NTP  ( Wł. *) Serwer NTP Włącz uwierzytelnianie  ( Brak *) Skonfiguruj ustawienia Network Time Protocol (NTP). Gdy element  Enable Authentication  ustawiony jest na  MD5 key , pojawiają się elementy  Key ID  i  Password . Rozmiary papieru U.S. * Metryczne Określa jednostkę miary dla rozmiarów papieru. Wybór kraju lub regionu w kreatorze wstępnej konfiguracji wpływa na wstępne ustawienia rozmiaru papieru. Jasność wyświetlacza 20-100% (100*) Regulacja jasności wyświetlacza. Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Dostęp do pamięci flash Wyłączone Włączone * Włącza dostęp do pamięci flash. Skanowanie jednej strony na skanerze płaskim Włączone Wyłącz * Pozwala na umieszczenie kopii z szyby skanera razem na jednej stronie. Czas oczekiwania ekranu 5-300 (60*) Skonfiguruj czas bezczynności (w sekundach) przed wyświetleniem ekranu głównego lub przed automatycznym wylogowaniem konta użytkownika. menu Preferencje"},{"UUID":"d2dc425a-914b-465d-a860-93fc87bb3fc2","title":"Urządzenie","link":"preferences-topic.html","desc":"Tryb oszczędny Elementy menu ","descFull":"Tryb oszczędny Elementy menu  Tryb oszczędny  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Drukuj Strony Jednostronnie * Dwustronnie Określa sposób drukowania: na jednej lub na obu stronach strony. Drukuj Stron na arkusz Wyłącz * 2 strony na arkusz 3 stron na arkusz 4 stron na arkusz 6 stron na arkusz 9 stron na arkusz 12 stron na arkusz 16 stron na arkusz Pozwala na drukowanie obrazów wielu stron na jednej stronie arkusza. Drukuj Intensywność toneru O małej gramaturze Normalne * Ciemny Określa poziom jasności obrazów lub tekstu. Kopiuj Strony 1-stronny na 1-stronny * 1-stronny na 2-stronny Określa sposób drukowania: po jednej lub po obu stronach arkusza. Kopiuj Stron na arkusz Wyłącz * 2 strony w orientacji pionowej 4 strony w orientacji pionowej 2 strony w orientacji poziomej 4 strony w orientacji poziomej Określa liczbę obrazów stron, które mają być drukowane na jednej stronie arkusza papieru. Kopiuj Intensywność 1-9 (5*) Dostosowuje intensywność zeskanowanego obrazu. menu Tryb ekologiczny"},{"UUID":"0f4c385a-98ca-4f54-ba1f-93eb96b32361","title":"Urządzenie","link":"preferences-topic.html","desc":"Zdalny panel operatora Elementy menu","descFull":"Zdalny panel operatora Elementy menu  Zdalny panel operatora  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Połączenie z zewnętrznym systemem VNC Nie zezwalaj * Zezwalaj Łączenie się z zewnętrznym klientami VNC (Virtual Network Computing) w celu uruchamiania panelu zdalnego sterowania. Typ uwierzytelniania Brak * Standardowe uwierzytelnianie Ustawia typ uwierzytelniania podczas uzyskiwania dostępu do serwera klienckiego VNC. Hasło VNC Określa hasło do połączenia z serwerem klienckim VNC. To menu jest wyświetlane tylko w przypadku, gdy w ustawieniu  Typ uwierzytelniania  wybrano opcję  Standardowe uwierzytelnianie . menu Zdalny panel operatora"},{"UUID":"3e31d3d4-a8a7-4ab3-8a6f-bd8bff3e6da7","title":"Urządzenie","link":"preferences-topic.html","desc":"Powiadomienia Elementy menu  Notifications","descFull":"Powiadomienia Elementy menu  Notifications  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Sygnał dźwiękowy załadowanego podajnika ADF Wyłączone Włącz * Włącza sygnał dźwiękowi podczas ładowania papieru do automatycznego podajnika dokumentów. Sterowanie alarmem Wyłączone Pojedynczy * Ciągły Ustaw liczbę alarmów ogłaszanych, gdy drukarka wymaga interwencji użytkownika. Materiały eksploatacyjne Pokaż szacunkowe czasy eksploatacji materiałów Pokaż szacunki * Nie pokazuj szacunków Wyświetla szacunkowy stan materiałów eksploatacyjnych. Materiały eksploatacyjne Alarm dot. kasety Wyłącz * Pojedynczy Ciągły Ustaw liczbę alarmów ogłaszanych, gdy poziom wkładu jest niski. Materiały eksploatacyjne Niestandardowe powiadomienia o materiałach eksploatacyjnych Konfiguruje ustawienia powiadomień generowanych, gdy drukarka wymaga interwencji użytkownika. To menu jest wyświetlane tylko podczas korzystania z wbudowanego serwera WWW. Ustawienia alarmów e-mail Konfiguracja poczty e-mail Podstawowa brama SMTP Port podstawowej bramy SMTP  (25*) Dodatkowa brama SMTP Port dodatkowej bramy SMTP  (25*) Limit czasu oczekiwania SMTP  (30 sekund*) Adres zwrotny Zawsze używaj domyślnego adresu zwrotnego SMTP  ( Wył. *) Użyj protokołu SSL/TLS  ( Wył. *) Wymagaj zaufanego certyfikatu  ( Włącz *) Uwierzytelnianie serwera SMTP ( Nie wymaga uwierzytelnienia *) Urządzenie – zainicjowany adres e-mail  ( Brak *) Nazwa użytkownika urządzenia Hasło urządzenia Domena NTLM Konfiguracja ustawień poczty e-mail w drukarce. Zapobieganie błędom Pomoc przy zac. Wyłączone Włącz * Umożliwia ustawienie automatycznego wykrywania zacięcia papieru. Zapobieganie błędom Autokontynuacja Wyłączone Włączone * (5 sekund) Czas autokontynuacji Pozwól, aby drukarka automatycznie kontynuowała przetwarzanie lub drukowanie zadania po usunięciu pewnych warunków obsługi. Zapobieganie błędom Automatyczne ponowne uruchomienie Automatyczne ponowne uruchomienie  (Zawsze uruchom ponownie*) Po wystąpieniu błędu drukarka zostanie uruchomiona ponownie. Zapobieganie błędom Automatyczne ponowne uruchomienie Maksymalna liczba automat. ponownych uruchomień  (2*) Określa maksymalną liczbę automatycznych ponownych uruchomień drukarki. Zapobieganie błędom Automatyczne ponowne uruchomienie Okno automatycznego ponownego uruchamiania  (720*) Ustaw liczbę sekund, zanim drukarka wykona automatyczne ponowne uruchomienie. Zapobieganie błędom Automatyczne ponowne uruchomienie Licznik zadań automatycznego ponownego uruchamiania Wyświetlanie informacji tylko do odczytu o liczniku zadań ponownego uruchamiania. Zapobieganie błędom Wyświetlaj błąd krótkiego papieru Włączone Automatyczne czyszczenie * Pozwala drukarce wyświetlać komunikat w przypadku wystąpienia błędu krótkiego papieru. Krótki papier odnosi się do rozmiaru załadowanego papieru. Zapobieganie błędom Ochrona strony Wyłącz * Włączone Pozwala drukarce przetwarzać całą stroną do pamięci przed jej wydrukiem. Przywracanie po zacięciach Zacięcia – ponów Wyłączone Włączone Automatycznie * Drukarka ponownie drukuje zacięte arkusze. Przywracanie po zacięciach Usuwanie zacięć skanera Poziom zadania Poziom strony * Określa sposób ponownego uruchamiania zadania skanowania po rozwiązaniu problemu zacięcia papieru. menu Powiadomienia"},{"UUID":"4228fc9e-bb16-4bc9-aa93-ab81d10de3db","title":"Urządzenie","link":"preferences-topic.html","desc":"Zarządzanie zasilaniem Elementy menu ","descFull":"Zarządzanie zasilaniem Elementy menu  Zarządzanie zasilaniem  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Profil trybu czuwania Drukowanie z trybu uśpienia Po zakończeniu drukowania pozostań w trybie aktywnym Po zakończeniu drukowania przejdź do trybu uśpienia * Umożliwia pozostawienie drukarki w trybie gotowości lub powrót do trybu uśpienia po zakończeniu drukowania. Limity czasu oczekiwania Tryb czuwania 1–120 min (15*) Skonfiguruj czas bezczynności przed włączeniem Trybu uśpienia. Limity czasu oczekiwania Limit czasu hibernacji Wyłączone 1 godzina 2 godziny 3 godziny 6 godziny 1 dzień 2 dni 3 dni * 1 tydzień 2 tygodnie 1 miesiąc Ustaw czas, zanim drukarka zostanie wyłączona. Limity czasu oczekiwania Limit czasu hibernacji przy połączeniu Hibernacja Nie hibernuj * Ustawienie  Limit czasu hibernacji  umożliwia wyłączenie drukarki w przypadku aktywnego połączenia Ethernet. menu Zarządzanie zasilaniem"},{"UUID":"9907ead4-92ae-4994-a328-791389186b7b","title":"Urządzenie","link":"preferences-topic.html","desc":"Zbieranie danych anonim. Elementy menu","descFull":"Zbieranie danych anonim. Elementy menu  Zbieranie danych anonimowych  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Zbieranie danych anonim. Info. dot. wykorzy. i wydaj. Brak * Wyślij do firmy Lexmark informacje dotyczące użytkowania i wydajności drukarki. Wyślij do producenta informacje dotyczące użytkowania i wydajności drukarki. Czas wysłania danych anonimowych  jest wyświetlany tylko wtedy, gdy opcja  Zbieranie danych anonimowych  jest ustawiona na  Wykorzystanie i wydajność urządzenia . Czas wysłania danych anonimowych Godzina rozpoczęcia Godzina zakończenia menu Zbieranie danych anonim."},{"UUID":"d6e6eb30-3a5e-42fe-ba8a-c533baa99ee8","title":"Urządzenie","link":"preferences-topic.html","desc":"Przywróć ustawienia fabryczne Element menu","descFull":"Przywróć ustawienia fabryczne Element menu  Przywróć ustawienia fabryczne  i jego opis Element menu Opis Przywróć ustawienia Przywróć wszystkie ustawienia Przywróć ustawienia drukarki Przywróć ustawienia sieciowe Przywróć ustawienia faksu Przywracanie domyślnych ustawień fabrycznych drukarki. menu Przywróć ustawienia fabryczne"},{"UUID":"0f74ad6f-b3ca-4018-985f-f8b9a1b7db11","title":"Przegląd","link":"preferences-topic.html","desc":"Menu konfiguracji Elementy  Menu","descFull":"Menu konfiguracji Elementy  Menu konfiguracji  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Konfiguracja USB PnP USB 1* 2 Zmień tryb sterownika USB drukarki w celu poprawy jego zgodności z komputerem. Konfiguracja USB Skanowanie USB do lokalnego Włącz * Wyłączone Ustala, czy sterownik urządzenia USB wyszczególniony jest jako proste urządzenie USB (pojedynczy interfejs) czy kompozytowe urządzenie USB (wiele interfejsów). Konfiguracja USB Prędkość USB Pełna Automatycznie * Ustaw port USB do pracy z pełną prędkością i wyłącz funkcje high-speed. Konfiguracja tacy Pokaż komunikat wkładania zasobnika Wyłączone Only for unknown sizes * Zawsze Pokaż komunikat o stanie zasobnika. Konfiguracja tacy Ładow. A5 Krótsza krawędź Long Edge * Określa orientację strony po załadowaniu papieru A5. Konfiguracja tacy Monity papieru Automatycznie * Ręczny podajnik papieru Określa źródło papieru, które zostanie zapełnione przez użytkownika po wyświetleniu monitu o włożenie papieru. Konfiguracja tacy Monity dotyczące kopert Automatycznie * Ręczny kopert Określa źródło papieru, które zostanie zapełnione przez użytkownika po wyświetleniu monitu o włożenie koperty. Konfiguracja tacy Akcja dla monitów Prompt user * Kontynuuj Użyj bieżącej Pozwala drukarce podejmować działania w następstwie monitów związanych z ładowaniem papieru lub kopert. Raporty Strona ustawień menu Dziennik Zdarzeń Podsumowanie dziennika zdarzeń Drukuje raporty obejmujące ustawienia menu i status drukarki oraz dzienniki zdarzeń. Zużycie i liczniki zasobów Wyczyść historię użytych mat. eksploat. Resetuje liczniki stron dla materiałów eksploatacyjnych lub wyświetla całkowitą liczbę wydrukowanych stron. Emulacje drukarki Emulacja PS Wyłącz * Włączone Pozwala drukarce rozpoznać i korzystać ze strumienia danych PS. Ten element menu pojawia się tylko w niektórych modelach drukarek. Emulacje drukarki Zabezpieczenia emulatora Limit czasu strony  (60*) Ustaw limit czasu nieaktywnej strony podczas emulacji. Emulacje drukarki Zabezpieczenia emulatora Zresetuj emulator po pracy  (Wył.*) Zresetuj emulator po ukończeniu zadania drukowania. Emulacje drukarki Zabezpieczenia emulatora Wyłącz dostęp do komunikatów drukarki  (Wł.*) Wyłącz dostęp do komunikatów drukarki podczas emulacji. Konfiguracja faksu Obsł. faksu przy nis. mocy Wyłącz uśpienie Zezwalaj na uśpienie Automatycznie * Określa ustawienie zasilania drukarki w trybie faksu. Konfiguracja drukowania Wyostrzanie czcionki 0-150 (24*) Ustaw wartość punktową rozmiaru tekstu, poniżej której używane będą ekrany wysokiej częstotliwości podczas drukowania danych czcionek. Konfiguracja drukowania Gęstość wydruku Wyłączone 1-5 (3*) Gęstość kopiowania Wyłączone 1-5 (3*) Dostosowuje gęstość tonera podczas drukowania lub kopiowania dokumentów. Działanie urządzenia Tryb cichy Włączone Wyłącz * Ustawia drukarkę tak, aby redukowała poziom hałasu podczas drukowania. Włączenie tego ustawienia spowalnia ogólne działanie drukarki. Działanie urządzenia Menu panelu Włącz * Wyłącz Pozwala drukarce na włączenie dostępu do menu panelu sterowania. To menu jest wyświetlane tylko podczas korzystania z wbudowanego serwera WWW. Działanie urządzenia Wyczyść stan niestandardowy Usuwa wszystkie niestandardowe komunikaty. Działanie urządzenia Wyczyść wszystkie zdalnie utworzone komunikaty Usuń wiadomości zainstalowane zdalnie. Działanie urządzenia Automat. wyśw. ekrany z błędami Włącz * Wyłączone Pokazuj na wyświetlaczu istniejące komunikaty o błędach po dłuższym czasie braku aktywności na ekranie głównym przez czas równy ustawieniu  Screen Timeout . Ten element menu pojawia się tylko w niektórych modelach drukarek. Konfiguracja skanera Ręczna rejestracja skanera Drukuj szybki test Drukuje docelową stronę szybkiego testu. Upewnij się, że marginesy na stronie testowej są jednolite na całej stronie docelowej. Jeśli nie są, konieczne może być zresetowanie marginesów drukarki. Konfiguracja skanera Ręczna rejestracja skanera Rejestracja przedniego automatycznego podajnika dokumentów Rejestracja skanera płaskiego Ręcznie włącza funkcję rejestracji skanera płaskiego i podajnika ADF po wymianie automatycznego podajnika dokumentów, szyby skanera lub płyty sterownika. Konfiguracja skanera Usuwanie krawędzi Usuwanie krawędzi zasobnika ADF 0–6 (3*) Usuwanie krawędzi skanera płaskiego 0–6 (3*) Ustaw w milimetrach wielkość obszaru niedrukowalnego wokół podajnika ADF lub zadania skanowania ze skanera płaskiego. Konfiguracja skanera Wyłącz skaner Włączone * Wyłączone Podajnik ADF wyłączony Wyłącza skaner, jeśli nie pracuje poprawnie. Konfiguracja skanera Kolejność bajtów Tiff Kolejność bajtów CPU * Little Endian Big Endian Ustaw kolejność bajtów w zeskanowanym obrazie w formacie TIFF. Konfiguracja skanera Dokładna liczba wierszy Tiff na pasmo Włącz * Wyłączone Ustawia wartość znacznika RowsPerStrip zeskanowanego obrazu TIFF. menu Menu konfiguracji"},{"UUID":"1db9cb8d-0cf6-4a13-b4da-6fb4dfd12b3d","title":"Przegląd","link":"preferences-topic.html","desc":"Usuwanie po awarii Element menu","descFull":"Usuwanie po awarii Element menu  Usuwanie po awarii  i jego opis Element menu Opis Ostatnie czyszczenie pamięci drukarki Wyczyść wszystkie informacje z pamięci nieulotnej Usuń wszystkie ustawienia drukarki i sieci Usuń wszystkie skróty i ustawienia skrótów Usuń wszystkie ustawienia i skróty przechowywane w pamięci drukarki. Opcja  Usuń wszystkie skróty i ustawienia skrótów  jest dostępna tylko w niektórych modelach drukarek. menu Usuwanie po awarii"},{"UUID":"c0751554-d9c9-4f4d-b721-8653e3ef119c","title":"Urządzenie","link":"preferences-topic.html","desc":"Widoczne ikony na ekranie głównym","descFull":"Widoczne ikony na ekranie głównym Element menu  Widoczne ikony na ekranie głównym  i jego opis Menu Opis Kopiuj E-mail Faks Stan/Materiały eksploatacyjne Kolejka zadań Zmień język Wstrzymane zadania USB Skanowanie do komputera Określa ikony wyświetlane na ekranie głównym. menu Widoczne ikony na ekranie głównym"},{"UUID":"6fb28f96-2626-4d15-b656-2fb6be93ef30","title":"Urządzenie","link":"preferences-topic.html","desc":"Drukarka – informacje Elementy menu","descFull":"Drukarka – informacje Elementy menu  Drukarka – informacje  i ich opisy Element menu Opis * Ten element menu pojawia się tylko w niektórych modelach drukarek. Etykieta inwentaryzacji Opis drukarki. Maksymalna długość to 32 znaki. Lokalizacja drukarki Zidentyfikuj lokalizację drukarki. Maksymalna długość to 63 znaki. Skontaktuj się Spersonalizuj nazwę drukarki. Maksymalna długość to 63 znaki. Eksportuj pliki konfiguracji do USB * Eksportuj pliki konfiguracji na pamięć flash. Eksportuj spakowane dzienniki do USB * Eksportuj skompresowane pliki dziennika na dysk flash. Wyślij dzienniki Anuluj Wyślij Wysyłanie informacji diagnostycznych do firmy Lexmark. menu Drukarka – informacje"},{"UUID":"aeb7a456-2de7-445a-ad6a-ecbbe157a6f6","title":"Drukowanie","link":"layout-topic.html","desc":"Układ Elementy menu Układ i","descFull":"Układ Elementy menu Układ i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Strony 1-stronnie * 2-stronnie Określa sposób drukowania: na jednej lub na obu stronach strony. Styl odwrócenia Long Edge * Krótka krawędź Ustala, wzdłuż której krawędzi (dłuższej, czy krótszej krawędzi) arkusz jest składany w trakcie drukowania dwustronnego. W zależności od wybranej opcji drukarka automatycznie przesuwa każdą wydrukowaną informację ze strony dla prawidłowego zszycia zadania. Puste strony Drukuj Nie drukuj * Wydrukuj puste strony ujęte w zadaniu drukowania. Sortuj Wyłącz [1,1,1,2,2,2] Włącz [1,2,1,2,1,2] * Szczególnie w przypadku drukowania wielu kopii zadania, ta opcja umożliwia układanie stron w wybranej kolejności. Arkusze separujące Brak * Między kopiami Między zadaniami Między stronami Wstaw puste arkusze separujące w czasie drukowania. Źródło arkuszy separujących Zasobnik  [x] ( 1 *) Określanie źródła papieru dla arkusza separującego. Stron na arkusz Wyłącz * 2 strony na arkusz 3 strony na arkusz 4 strony na arkusz 6 stron na arkusz 9 stron na arkusz 12 stron na arkusz 16 stron na arkusz Pozwala na drukowanie obrazów wielu stron na jednej stronie arkusza. Kilka stron na arkuszu – kolejność Poziomo * Odwróć w poziomie Pionowo Odwróć w pionie Określa ustawienie obrazów wielu stron na jednym arkuszu w przypadku użycia opcji Kilka stron na arkuszu. Rozmieszczenie zależy od liczby obrazów stron i ich orientacji. Stron na arkusz wg orientacji Automatycznie * Pozioma Pionowa Określa orientację dokumentu zawierającego wiele stron w przypadku użycia opcji Kilka stron na arkuszu. Kilka stron na arkuszu – obramowanie Brak * Jednolite Powoduje drukowanie obramowania wokół każdego obrazu strony, gdy używana jest opcja Kilka stron na arkuszu. Liczba kopii 1-9999 (1*) Określa liczbę kopii dla każdego zadania drukowania. Obszar wydruku Normalne * Cała strona Określa obszar drukowania na arkuszu papieru. menu Układ"},{"UUID":"770ec56c-bcf3-4083-a218-f66605e8d3cc","title":"Drukowanie","link":"layout-topic.html","desc":"Ustawienia Ustawienia Elementy menu Ustawienia","descFull":"Ustawienia Ustawienia Elementy menu Ustawienia i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Język drukarki Emulacja PCL Emulacja PS Umożliwia ustawienie języka drukarki. Ustawienie konkretnego języka drukarki jako domyślnego nie wyklucza możliwości wysyłania przy użyciu programu zadań drukowania korzystających z innego języka drukarki. Zapis zasobów Włącz Wyłącz * Ustal, co drukarka będzie robić z pobranymi zasobami, takimi jak czcionki i makra, gdy otrzyma zadanie wymagające pamięci w ilości większej niż dostępna. Przy ustawieniu  Wył.  drukarka zachowuje pobrane zasoby tylko do momentu, gdy potrzebna jest dodatkowa pamięć. Zasoby powiązane z językiem nieaktywnej drukarki są usuwane. Przy ustawieniu  Wł.  drukarka zachowuje wszystkie trwałe pobrane zasoby we wszystkich wersjach językowych. W razie konieczności drukarka wyświetla komunikaty o zapełnieniu pamięci zamiast usuwania trwałych zasobów. Kolejność drukowania dla opcji Drukuj wszystko Alfabetycznie * Najpierw najnowsze Najpierw najstarsze Określ kolejność przy wyborze druku zadań wstrzymanych i poufnych. menu Ustawienia"},{"UUID":"1060b671-0be1-4087-9455-9f625d7d7541","title":"Drukowanie","link":"layout-topic.html","desc":"Jakość Elementy menu Jakość i","descFull":"Jakość Elementy menu Jakość i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Rozdzielczość wydruku 300 dpi 600 dpi * 1200 Image Q 2400 Image Q Ustaw rozdzielczość dla tekstu i obrazów na wydruku. Rozdzielczość jest określana w punktach na cal lub w jakości obrazu. Zaciemnienie tonera O małej gramaturze Normalne * Dark (Ciemny) Określa poziom jasności obrazów tekstu. Półtony Normalne * Szczegóły Zwiększ jakość wydruku, aby linie były bardziej płynne i miały wyraźniejsze krawędzie. menu Jakość"},{"UUID":"2846e26f-fa12-4c9f-9b0d-620afb181944","title":"Drukowanie","link":"layout-topic.html","desc":"Plik PDF Elementy menu ","descFull":"Plik PDF Elementy menu  PDF  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Skaluj do rozmiaru Tak Nie * Powoduje dopasowanie zawartości strony do wybranego rozmiaru papieru. Adnotacje Drukowanie Nie drukuj * Określa, czy w pliku PDF zostaną wydrukowane adnotacje. Drukuj błąd PDF Wył. Włącz * Włącza drukowanie błędów PDF. menu Plik PDF"},{"UUID":"2aeccbf9-915c-425b-8e05-0d477fb86078","title":"Drukowanie","link":"layout-topic.html","desc":"PostScript Elementy menu  PostScript","descFull":"PostScript Elementy menu  PostScript  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Drukuj błąd PS Wyłącz * Włącz Drukuje stronę opisującą błąd PostScript®. Gdy wystąpi błąd, przetwarzanie zadania zostaje zatrzymane, drukarka drukuje komunikat o błędzie, a pozostała część zadania drukowania zostaje anulowana. Minimalna szerokość wiersza 1-30 (2*) Ustawia minimalną szerokość linii dla dowolnego zadania drukowania w 1200 dpi. Zablokuj tryb startowy PS Wył. Włącz * Wyłączenie pliku SysStart. Limit czasu oczekiwania Wyłączone Włączone * Po włączeniu drukarka oczekuje na więcej danych, zanim zadanie drukowania zostanie anulowane. Limit czasu oczekiwania 15–65535 (40*) Umożliwia określenie czasu (w sekundach), przez który drukarka oczekuje na dodatkowe dane, zanim zadanie drukowania zostanie anulowane. Ten element menu jest wyświetlany tylko wtedy, gdy włączono opcję  Limit czasu oczekiwania . menu PostScript"},{"UUID":"7ed9a67b-bae6-4579-8811-0f736f9a49b0","title":"Drukowanie","link":"layout-topic.html","desc":"PCL Elementy menu  PCL","descFull":"PCL Elementy menu  PCL  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Nazwa czcionki [Lista dostępnych czcionek] ( Courier *) Wybiera czcionkę z określonego źródła czcionek. Zestaw znaków [Lista dostępnych zestawów symboli] ( 10U PC-8 *) Określenie zestawu znaków dla poszczególnych czcionek. Zestaw znaków to zbiór znaków alfanumerycznych, interpunkcyjnych i symboli specjalnych. Zestawy znaków umożliwiają obsługę poszczególnych języków lub programów, np. symboli matematycznych w tekście naukowym. Wielkość 0,08-100 (10*) Określ wielkość znaków dla czcionek o stałych wymiarach lub o stałej szerokości. Element Wielkość określa liczbę znaków o stałej szerokości przypadających na jeden cal. Orientacja Pionowa * Pozioma Odwróć w pionie Odwrócona w poziomie Określenie orientacji tekstu i grafiki na stronie. Wierszy na stronę 1-255 Określa liczbę wierszy tekstu dla każdej strony wydrukowanej za pomocą  PCL  PCL. Ten element menu aktywuje wychwytywanie pionowe, które powoduje, że wybrana liczba żądanych linii zostaje wydrukowana między domyślnymi marginesami strony. 60 jest ustawieniem domyślne ustawienie fabryczne. Domyślnym międzynarodowym ustawieniem fabrycznym jest 64. Minimalna szerokość wiersza PCL5 1-30 (2*) Ustawia początkową minimalną szerokość linii dla dowolnego zadania drukowania w 1200 dpi. Maksymalna szerokość wiersza PCLXL 1-30 (2*) Szerokość A4 198 mm* 203 mm Ustawia szerokość arkusza logicznego dla papieru formatu A4. Arkusz logiczny to przestrzeń na stronie fizycznej, w której drukowane są dane. Autom. CR po LF Wyłącz * Włączone Po poleceniu przejścia do nowego wiersza (LF) wykonywana jest operacja powrotu karetki (CR). Powrót karetki to mechanizm wysyłający do drukarki polecenie przesunięcia kursora do początkowego położenia w tym samym wierszu. Autom. LF po CR Wyłącz * Włączone Po poleceniu powrotu karetki (CR) wykonywana jest operacja przejścia do nowego wiersza (LF). Oczekiwanie na wydruk Wyłączone Włączone * Umożliwia skonfigurowanie drukarki, by kończyła zadanie drukowania po upływie czasu bezczynności określonego w sekundach. Limit czasu oczekiwania na wydruk 1–255 (90*) Umożliwia ustawienie czasu (w sekundach), aby drukarka kończyła zadanie drukowania po okresie bezczynności. Ten element menu jest wyświetlany tylko wtedy, gdy włączono opcję  Oczekiwanie na wydruk . menu PCL"},{"UUID":"c4c2dc39-8755-4a1c-9112-9899d479799d","title":"Drukowanie","link":"layout-topic.html","desc":"Obraz Elementy menu  Obraz","descFull":"Obraz Elementy menu  Obraz  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Autom. dopasowanie Włącz Wyłącz * Wybiera najlepsze dostępne ustawienia rozmiaru i orientacji dla obrazu. Po ustawieniu na  Włącz  ten element menu zastępuje ustawienia skalowania i orientacji dla obrazu. Odwróć Wyłącz * Włącz Odwraca bitonalne obrazy monochromatyczne. Ten element menu nie ma zastosowania w przypadku obrazów w formacie GIF lub JPEG. Skalowanie U góry z lewej strony Najlepsze dopas.* Na środku Dopasuj wys./szer. Dopasuj wysokość Dopasuj szerokość Dopasowuje obraz do obszaru drukowania. Jeśli opcja  Autom. dopasowanie  jest ustawiona na  Włącz , opcja  Skalowanie  zostaje automatycznie ustawiona na  Najlepsze dopas. . Orientacja Pionowa * Pozioma Odwróć w pionie Odwróć w poziomie Określenie orientacji tekstu i grafiki na stronie. menu Obraz"},{"UUID":"d0567483-de90-4328-9952-e649935ae467","title":"Papier","link":"tray-configuration-topic.html","desc":"Konfiguracja zasobn. Elementy menu Konfiguracja","descFull":"Konfiguracja zasobn. Elementy menu Konfiguracja zasobn. i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Domyślne źródło Zasobnik  [x] ( 1 *) Ręczny podajnik papieru Ręczny kopert Ustawia źródło papieru dla wszystkich zadań drukowania. Rozmiar/typ papieru Zasobnik  [x] ( 1 *) Ręczny podajnik papieru Ręczny kopert Określa rozmiar lub typ papieru załadowanego do każdego źródła. Zastąp rozmiar Wyłącz Letter/A4 Wszystkie wymienione * Pozwala drukarce zastępować określony rozmiar papieru, jeśli pożądany rozmiar nie jest załadowany w żadnym źródle. Ustawienie wartości  Wyłącz  powoduje generowanie monitu o załadowanie papieru o wymaganym rozmiarze. Ustawienie  Letter/A4  drukuje dokumenty w rozmiarze A4 na załadowanym papierze typu Letter oraz dokumenty w rozmiarze Letter na załadowanym papierze A4. Ustawienie  Wszystkie wymienione  zastępuje ustawienie  Letter/A4 . menu Konfiguracja zasobn."},{"UUID":"24cec275-5d3a-4955-8d1d-d9112b58f696","title":"Konfiguracja nośnika","link":"tray-configuration-topic.html","desc":"Konfiguracja uniwersalna Elementy menu Konfiguracja","descFull":"Konfiguracja uniwersalna Elementy menu Konfiguracja uniwersalna i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Jednostki miary Cali Milimetry Określa jednostkę miary dla uniwersalnego rozmiaru papieru. Cale  to w Stanach Zjednoczonych domyślne ustawienie fabryczne. Domyślnym międzynarodowym ustawieniem fabrycznym są  Milimetry . Szerokość w pionie 3,00–14,17 cala (8,50*) 76–360 mm (216*) Ustawia szerokość papieru uniwersalnego rozmiaru ułożonego w orientacji pionowej. Wysokość w pionie 3,00–14,17 cala (14*) 76–360 mm (356*) Ustawia wysokość papieru uniwersalnego rozmiaru ułożonego w orientacji pionowej. Kierunek podawania Krótka krawędź * Długa krawędź Wybiera tryb podawania papieru – wzdłuż krótkiej lub długiej krawędzi. Wartość  Długa krawędź  jest wyświetlana tylko wtedy, gdy najdłuższa krawędź jest krótsza niż maksymalna obsługiwana szerokość. menu Konfiguracja uniwersalna"},{"UUID":"a7a324b5-924d-48e5-8b90-9a8f20a91514","title":"Konfiguracja nośnika","link":"tray-configuration-topic.html","desc":"Custom Scan Sizes (Niestandardowe rozmiary","descFull":"Custom Scan Sizes (Niestandardowe rozmiary skanów) Elementy menu  Niestandardowe rozmiary skanów  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Niestandardowy rozmiar skanu  [x] Nazwa rozmiaru skanu Szerokość 1–8,50 cala (8,50*) 25–216 mm (216*) Wysokość 1–14 cale (11*) 25-356 mm (279*) Orientacja Pionowa * Pozioma 2 skany na stronie Wyłącz * Włącz Przypisuje nazwę do rozmiaru skanowania i konfiguruje ustawienia skanowania. menu Custom Scan Sizes (Niestandardowe rozmiary skanów)"},{"UUID":"90b0e1dd-55b0-4577-84cb-e354c878bb24","title":"Konfiguracja nośnika","link":"tray-configuration-topic.html","desc":"Typy nośników Element menu Typy","descFull":"Typy nośników Element menu Typy nośników i jego opis Element menu Opis Zwykły papier Karty Makulaturowy Etykiety Papier dokumentowy Koperta Papier firmowy Formularze Papier kolorowy O małej gramaturze O dużej gramaturze Określ teksturę, gramaturę i orientację włożonego papieru. menu Typy nośników"},{"UUID":"104563ab-3a62-4760-ad82-e68d4baa6ea2","title":"Kopiowanie","link":"copy-defaults-topic.html","desc":"Domyślne ustawienia kopiowania Elementy menu","descFull":"Domyślne ustawienia kopiowania Elementy menu  Domyślne ustawienia kopiowania  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Typ zawartości Tekst Tekst/fotografia * Fotografia Grafika Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Strony 1-stronny na 1-stronny * 1-stronny na 2-stronny Określa zachowanie skanowania w oparciu o oryginalny dokument. Stron na arkusz Wyłącz * 2 strony w orientacji pionowej 4 strony w orientacji pionowej 2 strony w orientacji poziomej 4 strony w orientacji poziomej Określa liczbę obrazów stron, które mają być drukowane na jednej stronie arkusza papieru. Drukuj obramowanie stron Wyłącz * Włączone Umieszcza obramowanie wokół każdego obrazu podczas drukowania wielu stron na jednym arkuszu. Sortuj Wyłącz [1,1,1,2,2,2] Włącz [1,2,1,2,1,2] * Drukuje wiele kopii po kolei. „Kopiuj z” rozmiaru [Lista rozmiarów papieru] Określa rozmiar papieru oryginalnego dokumentu. Letter  to w Stanach Zjednoczonych domyślne ustawienie fabryczne. Domyślnym międzynarodowym ustawieniem fabrycznym jest  A4 . Źródło „dla kopii” Zasobnik  [x] ( 1 *) Podajnik ręczny Automatyczne dopasowanie rozmiaru Określa źródło papieru dla zadania kopiowania. Intensywność od 1 do 9 (5*) Dostosowuje intensywność zeskanowanego obrazu. Liczba kopii 1-9999 (1*) Określanie liczby kopii. Zaawansowane obrazowanie Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Kontrast Najlepsze dla zawartości * ‑0 ‑1 ‑2 ‑3 ‑4 ‑5 Określa kontrast wydruku. Usuwanie tła Poziom Od ‑4 do 4 (0*) Określa stopień widoczności tła na skanowanym obrazie. Skanuj całą powierzchnię Wyłącz * Włączone Umożliwia skanowanie całej powierzchni oryginalnego dokumentu. menu Domyślne ustawienia kopiowania"},{"UUID":"ec08f91d-465e-4512-bac8-ef493bf65b1a","title":"Domyślne ustawienia faksowania","link":"fax-defaults-subgroup.html","desc":"Tryb faksu Element menu ","descFull":"Tryb faksu Element menu  Tryb faksu  i jego opis Element menu Opis Tryb faksu Faks Serwer faksu Wyłączone Pozwala wybrać rozdzielczość faksowania. Domyślne ustawienie fabryczne może różnić się w zależności od modelu drukarki. Serwer faksu  jest dostępny wyłącznie w wybranych modelach drukarek. menu Tryb faksu"},{"UUID":"8b9b02f7-8d94-4016-b982-ea59df1c0601","title":"Domyślne ustawienia faksowania","link":"fax-defaults-subgroup.html","desc":"Ustawienia faksu Ustawienia ogólne faksu","descFull":"Ustawienia faksu Ustawienia ogólne faksu Elementy menu  Ustawienia ogólne faksu  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Nazwa faksu Identyfikuje nazwę faksu. Numer faksu Identyfikuje numer faksu. Identyfikator faksu Nazwa faksu Numer faksu * Powiadamia odbiorców faksów o nazwie lub numerze urządzenia. Wykorzystanie pamięci W całości na odbieranie W większości na odbieranie Po równo * W większości na wysyłanie W całości na wysyłanie Określa ilość wewnętrznej pamięci drukarki przydzielonej do zadań przesyłania faksów. Ten element menu zapobiega problemom z rozmiarem bufora oraz nieudanym próbom wysyłania faksów. Anuluj faksy Zezwalaj * Nie zezwalaj Anuluje wychodzące faksy przed ich przesłaniem lub anuluje przychodzące faksy przed zakończeniem ich drukowania. Maskowanie numeru faksu Wyłącz * Od lewej Od prawej Określa format maskowania numeru dla faksów wychodzących. Ile cyfr zamaskować 0–58 (0*) Określa liczbę cyfr, które mają zostać zamaskowane w numerze faksu wychodzącego. Włącz wykrywanie podłączenia linii Włącz * Wyłączone Określa, czy linia telefoniczna jest podłączona do drukarki. Wykrywanie odbywa się w momencie włączania drukarki oraz przed każdym połączeniem. Zoptymalizuj zgodność faksu Konfiguruje funkcję faksu pod kątem optymalnej zgodności z innymi faksami. Transport faksu T.38 Analogowy G.711 etherFAX Ustaw metodę transportu faksu. Ten element menu pojawia się tylko wtedy, gdy w drukarce jest zainstalowany pakiet licencji etherFAX lub Fax over IP (FoIP). Domyślne ustawienia fabryczne może różnić się w zależności od modelu drukarki. Ustawienia faksowania HTTPS To menu pojawia się tylko wtedy, gdy opcja  Transport faksu  jest ustawiona na  etherFAX . Elementy menu  Ustawienia faksowania HTTPS  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Adres URL usługi HTTPS Określ adres URL usługi etherFAX. Proxy HTTPS Określ adres URL serwera proxy. Użytkownik proxy HTTPS Określ nazwę użytkownika i hasło serwera proxy. Hasło proxy HTTPS Szyfrowanie wysyłania faksów Wyłączone Włączone * Wymagane Włącz szyfrowanie wychodzących faksów. Szyfrowanie odbierania faksów Wyłączone Włączone * Wymagane Włącz szyfrowanie przychodzących faksów. Stan faksowania HTTPS Wyświetl stan komunikacji etherFAX. Ustawienia wysyłania faksów Elementy menu  Ustawienia wysyłania faksów  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Rozdzielczość Zwykła * Wysoka Bardzo wysoka Najwyższa Ustawia rozdzielczość skanowanego obrazu. Wyższa rozdzielczość wydłuża czas przesyłania faksu i zużycie pamięci. Rozmiar oryginału [Lista rozmiarów papieru] (Rozmiary mieszane*) Wybieranie rozmiaru oryginalnego dokumentu. Orientacja Pionowa * Pozioma Wybieranie orientacji oryginalnego dokumentu. Ten element menu pojawia się tylko w niektórych modelach drukarek. Strony Wyłącz * Krótsza krawędź Dłuższa krawędź Określa orientację oryginalnego dokumentu przy skanowaniu obustronnym. Ten element menu pojawia się tylko w niektórych modelach drukarek. Typ zawartości Tekst * Tekst/fotografia Fotografia Grafika Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Intensywność 1-9 (5*) Dostosowuje intensywność zeskanowanego obrazu. Za PABX Włączone Wyłącz * Pozwala drukarce na wybranie numeru faksu bez konieczności oczekiwania na rozpoznanie sygnału tonowego. PABX (Private Automated Branch Exchange) to centrala telefoniczna zapewniająca pojedynczemu numerowi wiele linii dla dzwoniących z zewnątrz. Tryb wybierania numeru Tonowo * Impulsowo Określa tryb wybierania dla faksów przychodzących lub wychodzących. Zaawansowane obrazowanie Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Równowaga kolorów Cyjan ‑ czerwony od -4 do 4 (0*) Magenta ‑ zielony od -4 do 4 (0*) Żółty ‑ niebieski od -4 do 4 (0*) Dopasowanie intensywności koloru podczas skanowania. Kontrast Najlepsze dla zawartości * 0 1 2 3 4 5 Określa końcowy kontrast. Usuwanie tła Poziom Od ‑4 do 4 (0*) Określa stopień widoczności tła na skanowanym obrazie. Skanuj całą powierzchnię Włączone Wyłącz * Umożliwia skanowanie całej powierzchni oryginalnego dokumentu. Elementy sterujące administratora Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Automatyczne ponowne wybieranie 0–9 (5*) Określa liczbę ponownych prób nawiązania połączenia w oparciu o poziom aktywności faksów odbiorców. Częstotliwość ponownego wybierania 1–200 minut (3*) Wydłuża czas pomiędzy kolejnymi próbami nawiązania połączenia, aby zwiększyć szansę na pomyślne wysłanie faksu. Włącz funkcję ECM Włącz * Wyłączone Włącza tryb korekcji błędów (ECM) dla zadań faksowania. Tryb ECM wykrywa i naprawia błędy w procesie przesyłania faksu, spowodowane zakłóceniami linii telefonicznej i słabą jakością sygnału. Włącz faksowanie ze skanera Włącz * Wyłączone Umożliwia faksowanie dokumentów zeskanowanych na drukarce. Sterownik do faksu Włącz * Wyłączone Umożliwia wysyłanie faksów przez sterownik drukarki. Pozwól na użycie polecenia Zapisz jako skrót Włącz * Wyłączone Umożliwia zapisywanie numerów faksów w drukarce jako skrótów. Maksymalna szybkość 33600 * 14400 9600 4800 2400 Określa maksymalną szybkość wysyłania faksów. Włącz kolorowe faksowanie ze skanera Domyślnie wyłączone * Domyślnie włączone Nigdy nie używaj Zawsze używaj Umożliwia skanowanie w kolorze na potrzeby faksowania. Automatyczna konwersja faksów kolorowych na faksy mono Włącz * Wyłączone Konwertuje wszystkie kolorowe faksy wychodzące do postaci czarno-białej. Potwierdź numer faksu Wyłącz * Włączone Prosi użytkownika o potwierdzenie numeru faksu. Prefiks wybierania Ustawia prefiks wybierania. Ustawienia odbierania faksów Elementy menu  Ustawienia odbierania faksów  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Liczba sygnałów do odebrania 1–25 (3*) Określa liczbę sygnałów dla przychodzących faksów. Autoredukcja Włącz * Wyłączone Zmniejsza przychodzące faksy, aby zmieścić je na stronie. Źródło papieru Zasobnik  [X] Automatycznie * Określa źródło papieru, z którego pobierany jest papier podczas drukowania przychodzących faksów. Strony Włączone Wyłącz * Drukowanie dwustronne. Arkusze separujące Brak * Przed zadaniem Po zadaniu Określa, czy w czasie drukowania mają być wstawiane puste arkusze separujące. Źródło arkuszy separujących Zasobnik   [X] (1*) Określanie źródła papieru dla arkusza separującego. Stopka faksu Włączone Wyłącz * Drukuje informacje dotyczące przesyłania na dole każdej strony odebranego faksu. Sygnatura godziny stopki faksu Odbierz * Drukuj Drukuje czas przesyłania na dole każdej strony odebranego faksu. Elementy sterujące administratora Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Włącz odbieranie faksów Włącz * Wyłączone Ustawia w drukarce funkcję odbierania faksów. Włącz otrzymywanie kolorowych faksów Włącz * Wyłączone Ustawia funkcję odbierania kolorowych faksów przez drukarkę. Włącz identyfikator numeru dzwoniącego Włączone Wyłącz * Wyświetla numer nadawcy przychodzącego faksu. Blokowanie bezimiennych faksów Włączone Wyłącz * Blokuje faksy przychodzące z urządzeń bez określonego identyfikatora stacji lub identyfikatora faksu. Odbieranie po Wszystkie dzwonki * Tylko pojedynczy dzwonek Tylko podwójny dzwonek Tylko potrójny dzwonek Tylko dzwonek pojedynczy lub podwójny Tylko dzwonek pojedynczy lub potrójny Tylko podwójny lub potrójny dzwonek Ustawia charakterystyczny dzwonek dla przychodzących faksów. Automatyczne odbieranie Włącz * Wyłączone Ustawia w drukarce funkcję automatycznego odbierania faksów. Przekazywanie faksów Drukowanie * Wydrukuj i prześlij dalej Przekaż Określa, czy przesłać otrzymany faks. Przekaż do Miejsce docelowe 1 Miejsce docelowe 2 Określa miejsce przesyłania otrzymanego faksu. Ten element menu pojawia się tylko wtedy, gdy opcja  Przekazywanie faksów  jest ustawiona na wartość  Drukuj i prześlij dalej  lub  Prześlij . Maksymalna szybkość 33600* 14400 9600 4800 2400 Określa maksymalną szybkość przesyłania faksów. Ustawienia dziennika faksów Elementy menu  Ustawienia dziennika faksów  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Dziennik transmisji – częstotliwość Zawsze * Nigdy Tylko przy błędzie Określa częstotliwość tworzenia dziennika transmisji przez drukarkę. Dziennik transmisji – działanie Drukuj Wyłączone Włącz * E-mail Wyłącz * Włączone Drukuje lub wysyła w wiadomości e-mail dziennik dla pomyślnej transmisji faksu lub błędu transmisji. Dziennik błędów odbierania Nigdy nie drukuj * Drukuj przy bł. Drukuje dziennik dla nieudanych prób odebrania faksu. Drukuj dzienniki automatycznie Włącz * Wyłączone Drukuje całą aktywność faksu. Źródło papieru dziennika Zasobnik  [x] (1*) Określa źródło papieru do drukowania dzienników. Pokaż w dziennikach Nazwa faksu zdalnego * Wybrany numer Identyfikuje nadawcę według nazwy zdalnego faksu lub numeru faksu. Włącz dziennik zadań Włącz * Wyłączone Wyświetla podsumowanie wszystkich zadań faksowania. Włącz dziennik połączeń Włącz * Wyłączone Wyświetla podsumowanie historii połączeń faksu. Ustawienia głośnika Elementy menu  Ustawienia głośnika  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Tryb głośnika Zawsze wyłączone * Zawsze włączone Włączone aż do podłączenia Włącza tryb głośnika faksu. Głośność głośnika Niska * Wysoka Dostosowuje głośność głośnika faksu. Głośność dzwonka Wyłącz * Włączone Umożliwia włączenie głośności sygnału dzwonka. menu Ustawienia faksu"},{"UUID":"2dc2d0b9-08b2-4190-b70a-a0b2b31b228d","title":"Domyślne ustawienia faksowania","link":"fax-defaults-subgroup.html","desc":"Ustawienia serwera faksów To menu","descFull":"Ustawienia serwera faksów To menu jest dostępne tylko w przypadku wybranych modeli drukarek. Ustawienia ogólne faksu Elementy menu  Ustawienia ogólne faksu  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Format Określa odbiorcę faksu. Aby użyć numeru faksu, wpisz znak numeru (#) przed jego wprowadzeniem. Adres zwrotny Określa adres zwrotny dla wysyłanych faksów. Temat Określa temat i treść wiadomości faksu. Komunikat Włącz odbiór analogowy Wyłącz * Włączone Pozwala drukarce na odbieranie analogowych faksów. Ustawienia e-mail na serwerze faksów Elementy menu  Ustawienia e-mail na serwerze faksów  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Użyj serwera poczty SMTP Włącz * Wyłączone Ustawienia SMTP (Simple mail Transfer Protocol) umożliwiają korzystanie z poczty e-mail podczas odbierania i wysyłania faksów. Gdy ta opcja jest  Wł. , wszystkie pozostałe ustawienia menu  Ustawienia e-mail na serwerze faksów  nie są wyświetlane. Podstawowa brama SMTP Wpisz adres IP lub nazwę hosta głównego serwera SMTP. Port podstawowej bramy SMTP 1–65535 (25*) Wpisz numer portu głównego serwera SMTP. Dodatkowa brama SMTP Wpisz adres IP lub nazwę hosta dodatkowego lub zapasowego serwera SMTP. Port dodatkowej bramy SMTP 1–65535 (25*) Wpisz numer portu serwera dodatkowego lub zapasowego serwera SMTP. Limit czasu oczekiwania SMTP 5-30 (30*) Określa czas przed osiągnięciem limitu czasu odpowiedzi serwera SMTP. Adres zwrotny Określa adres zwrotny dla wysyłanych faksów. Użyj protokołu SSL/TLS Wyłączone * Negocjuj Wymagane Określa, czy faksy mają być wysyłane za pomocą szyfrowanego łącza. Wymagaj zaufanego certyfikatu Wyłączone Włącz * Określa stosowanie zaufanego certyfikatu podczas uzyskiwania dostępu do serwera SMTP. Uwierzytelnianie serwera SMTP Nie wymaga uwierzytelnienia * Login/Zwykły NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Umożliwia ustawienie typu uwierzytelniania dla serwera SMTP. Urządzenie – zainicjowany adres e-mail Brak * Stosuj dane identyfikacyjne SMTP urządzenia Określa, czy dane logowania są wymagane dla wiadomości e-mail zainicjowanych przez urządzenie. Adres e-mail zainicjowany przez użytkownika Brak * Stosuj dane identyfikacyjne SMTP urządzenia Użyj identyfikatora i hasła użytkownika sesji Użyj adresu e-mail i hasła dla sesji Monituj użytkownika Określa, czy dane logowania są wymagane dla wiadomości e-mail zainicjowanych przez użytkownika. Użyj danych id. urz. dla Active Directory Wyłącz * Włączone Pozwala na łączenie z serwerem SMTP za pomocą poświadczeń użytkowników i grup docelowych. Nazwa użytkownika urządzenia Określa identyfikator użytkownika i hasło do połączeń z serwerem SMTP. Hasło urządzenia Dziedzina protokołu Kerberos 5 Określa dziedzinę protokołu uwierzytelniania Kerberos 5. Domena NTLM Określa nazwę domeny dla protokołu zabezpieczeń NTLM. Wyłącz błąd „Nie skonfigurowano serwera SMTP”. Wyłącz* Włączone Ukryj wiadomość o błędzie „Nie skonfigurowano serwera SMTP”. Ustawienia skanowania na serwerze faksów Elementy menu  Ustawienia skanowania na serwerze faksów  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Format obrazu TIFF (.tif) PDF (.pdf) * XPS (.xps) Określa format pliku skanowanego obrazu. Typ zawartości Tekst * Tekst/fotografia Fotografia Grafika Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Źródło zawartości Cz-b drukarka laser. Kolorowy druk laserowy * Do drukarek atramentowych Fotografia/klisza Czasopismo Gazeta Prasa Inny Poprawia końcową jakość w oparciu o źródło oryginalnego dokumentu. Rozdzielczość faksu Zwykła * Wysoka Bardzo wysoka Najwyższa Ustawia rozdzielczość faksu. Strony Wyłącz * Krótsza krawędź Dłuższa krawędź Określa orientację oryginalnego dokumentu przy skanowaniu obustronnym. Intensywność 1-9 (5*) Ustawia intensywność toneru na kopii. Orientacja Pionowa * Pozioma Określenie orientacji tekstu i grafiki na stronie. Rozmiar oryginału [Lista rozmiarów papieru] Określa rozmiar papieru oryginalnego dokumentu. Rozmiary mieszane  w Stanach Zjednoczonych domyślne ustawienie fabryczne. Domyślnym międzynarodowym ustawieniem fabrycznym jest A4. To ustawienie może się różnić w zależności od posiadanego modelu drukarki. Użyj wielostronicowego formatu TIFF Wyłączone Włącz * Umożliwia dokonanie wyboru między jednostronicowymi i wielostronicowymi plikami w formacie TIFF. menu Ustawienia serwera faksów"},{"UUID":"6eb4d7ee-d66e-42b2-9557-4db96f56e475","title":"Wysyłanie wiadomości e-mail","link":"email-setup-topic.html","desc":"Konfiguracja poczty e-mail Elementy menu","descFull":"Konfiguracja poczty e-mail Elementy menu  Konfiguracja poczty e-mail  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Podstawowa brama SMTP Wpisz adres IP lub nazwę hosta głównego serwera SMTP, który odpowiada za wysyłanie wiadomości e-mail. Port podstawowej bramy SMTP 1–65535 (25*) Wpisz numer portu głównego serwera SMTP. Dodatkowa brama SMTP Wpisz adres IP lub nazwę hosta dodatkowego lub zapasowego serwera SMTP. Port dodatkowej bramy SMTP 1–65535 (25*) Wpisz numer portu serwera dodatkowego lub zapasowego serwera SMTP. Limit czasu oczekiwania SMTP 5–30 sekund (30*) Określa czas przed osiągnięciem limitu czasu odpowiedzi serwera SMTP. Adres zwrotny Określa adres zwrotny wiadomości e-mail. Zawsze używaj domyślnego adresu zwrotnego SMTP Włączone Wyłącz * Zawsze używaj domyślnego adresu zwrotnego serwera SMTP. Użyj protokołu SSL/TLS Wyłączone * Negocjuj Wymagane Określa, czy wiadomości e-mail mają być wysyłane za pomocą szyfrowanego łącza. Wymagaj zaufanego certyfikatu Wyłączone Włącz * Określa wymóg stosowania zaufanego certyfikatu podczas uzyskiwania dostępu do serwera SMTP. Uwierzytelnianie serwera SMTP Nie wymaga uwierzytelnienia * Login/Zwykły NTLM CRAM‑MD5 Digest‑MD5 Umożliwia ustawienie typu uwierzytelniania dla serwera SMTP. Urządzenie – zainicjowany adres e-mail Brak * Stosuj dane identyfikacyjne SMTP urządzenia Określa, czy dane logowania są wymagane dla wiadomości e-mail zainicjowanych przez urządzenie. Nazwa użytkownika urządzenia Określa identyfikator użytkownika i hasło do połączeń z serwerem SMTP. Hasło urządzenia Domena NTLM Określa nazwę domeny dla protokołu zabezpieczeń NTLM. menu Konfiguracja poczty e-mail"},{"UUID":"ca3ea4dc-b8dc-4826-937d-101ddd2a7ba6","title":"Wysyłanie wiadomości e-mail","link":"email-setup-topic.html","desc":"Domyślne ustawienia e‑mail Elementy menu","descFull":"Domyślne ustawienia e‑mail Elementy menu  Domyślne ustawienia e‑mail  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Temat Określa temat i treść wiadomości e-mail. Komunikat Nazwa pliku Określa nazwę pliku skanowanego obrazu. Format PDF (.pdf) * TIFF (.tif) JPEG (.jpg) Określa format pliku skanowanego obrazu. Ustawienia PDF Wersja PDF 1.3 1,4 1,5 * 1,6 1,7 Wersja archiwalna A‑1a * A‑1b Bezpieczny Wyłącz * Włączone Archiwalny (PDF/A) Wyłącz * Włączone Ustawia format PDF skanowanego obrazu. Wersja archiwalna  i  Archiwalna (PDF/A)  pojawiają się tylko wtedy, gdy dla ustawienia  Wersja PDF  wybrano wartość 1.4. Typ zawartości Tekst Tekst/fotografia * Fotografia Grafika Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Kolor Czarno-biały Szary Kolorowy * Automatyczny Określa kolor podczas skanowania obrazu. Rozdzielczość 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Ustawia rozdzielczość skanowanego obrazu. Intensywność 1-9 (5*) Dostosowuje intensywność zeskanowanego obrazu. Orientacja Pionowa * Pozioma Wybieranie orientacji oryginalnego dokumentu. Ten element menu pojawia się tylko w niektórych modelach drukarek. Rozmiar oryginału [Lista rozmiarów papieru] Określa rozmiar papieru oryginalnego dokumentu. Domyślnym ustawieniem fabrycznym jest ustawienie  Rozmiary mieszane . Strony Wyłącz * Krótsza krawędź Dłuższa krawędź Określa orientację oryginalnego dokumentu przy skanowaniu obustronnym. Ten element menu pojawia się tylko w niektórych modelach drukarek. Zaawansowane obrazowanie Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Równowaga kolorów Cyjan ‑ czerwony od -4 do 4 (0*) Magenta ‑ zielony od -4 do 4 (0*) Żółty ‑ niebieski od -4 do 4 (0*) Dopasowanie intensywności koloru podczas skanowania. Automatyczne wykrywanie koloru Czułość koloru 1-9 (5*) Czułość obszaru 1-9 (5*) Głębia bitów wiadomości e-mail 1-bitowa * 8-bitowa Minimalna rozdzielczość skanowania 75 dpi 150 dpi 200 dpi 300 dpi * Ustawia intensywność koloru, jaką drukarka wykrywa z oryginalnego dokumentu. Kontrast Najlepszy dla zawartości * 0 1 2 3 4 5 Określa kontrast wydruku. Usuwanie tła Poziom Od ‑4 do 4 (0*) Określa stopień widoczności tła na skanowanym obrazie. Skanuj całą powierzchnię Włączone Wyłącz * Umożliwia skanowanie całej powierzchni oryginalnego dokumentu. Elementy sterujące administratora Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Maks. rozmiar e-maila 0-65535 (0*) Ustawia dopuszczalną wielkość pliku dla każdej wiadomości e-mail. Komunikat o błędzie rozmiaru Określa komunikat o błędzie wysyłany przez drukarkę, gdy wiadomość e-mail przekracza maksymalny rozmiar. Można wprowadzić maksymalnie 1024 znaków. Wyślij do mnie kopię Nigdy niewyświetlane * Domyślnie włączone Domyślnie wyłączone Zawsze włączone Wysyła kopię wiadomości e-mail do nadawcy. Wartość domyślna dla tekstu 5-95 (75*) Ustawia jakość tekstu na skanowanym obrazie. Wartość domyślna dla tekstu/fotografii 5-95 (75*) Ustawia jakość tekstu lub fotografii na skanowanym obrazie. Wartość domyślna dla fotografii 5-95 (50*) Ustawia jakość fotografii na skanowanym obrazie. Dziennik transmisji Drukuj dziennik * Nie drukuj dziennika Drukuj tylko w razie błędu Drukuje dziennik dla pomyślnie przesłanej wiadomości e-mail. Źródło papieru dziennika Zasobnik  [x] (1*) Określa źródło papieru do drukowania dzienników. Pozwól na użycie polecenia Zapisz jako skrót Włącz * Wyłączone Umożliwia zapisywanie adresów e-mail jako skrótów. Gdy wybrane jest ustawienie  Wyłącz , przycisk  Zapisz jako skrót  nie jest wyświetlany na ekranie  Miejsca docelowe  wiadomości e-mail. Zresetuj informacje e-mail po wysłaniu Włącz * Wyłączone Przywróć domyślne informacje e-mail po wysłaniu wiadomości e-mail. menu Domyślne ustawienia e‑mail"},{"UUID":"75453e74-acef-4bf7-b6ec-0e484c817994","title":"FTP","link":"ftp-defaults-topic.html","desc":"Domyślne ustawienia FTP Elementy menu","descFull":"Domyślne ustawienia FTP Elementy menu  Domyślne ustawienia FTP  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Format PDF (.pdf) * TIFF (.tif) JPEG (.jpg) Określa format pliku skanowanego obrazu. Ustawienia PDF Wersja PDF 1.3 1,4 1,5 * 1,6 1,7 Wersja archiwalna A‑1a * A‑1b Bezpieczny Wyłącz * Włączone Archiwalny (PDF/A) Wyłącz * Włączone Ustawia format PDF dla skanowanego obrazu. Wersja archiwalna  i  Archiwalna (PDF/A)  pojawiają się tylko wtedy, gdy dla ustawienia  Wersja PDF  wybrano wartość 1.4. Typ zawartości Tekst Tekst/fotografia * Grafika Fotografia Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Kolor Czarno-biały Szary Kolorowy * Automatyczny Określa kolor podczas skanowania obrazu. Rozdzielczość 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Ustawia rozdzielczość skanowanego obrazu. Intensywność 1-9 (5*) Dostosowuje intensywność zeskanowanego obrazu. Orientacja Pionowa * Pozioma Wybieranie orientacji oryginalnego dokumentu. Ten element menu pojawia się tylko w niektórych modelach drukarek. Rozmiar oryginału [Lista rozmiarów papieru] (Rozmiary mieszane*) Określa rozmiar papieru oryginalnego dokumentu. Strony Wyłącz * Krótsza krawędź Dłuższa krawędź Określa orientację oryginalnego dokumentu przy skanowaniu obustronnym. Ten element menu pojawia się tylko w niektórych modelach drukarek. Nazwa pliku Określa nazwę pliku skanowanego obrazu. Zaawansowane obrazowanie Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Równowaga kolorów Cyjan ‑ czerwony od -4 do 4 (0*) Magenta ‑ zielony od -4 do 4 (0*) Żółty ‑ niebieski od -4 do 4 (0*) Dopasowanie intensywności koloru podczas skanowania. Automatyczne wykrywanie koloru Czułość koloru 1-9 (5*) Czułość obszaru 1-9 (5*) Głębia bitów dla transmisji FTP 1-bitowa * 8-bitowa Minimalna rozdzielczość skanowania 75 dpi 150 dpi 200 dpi 300 dpi * Ustawia intensywność koloru, jaką drukarka wykrywa z oryginalnego dokumentu. Kontrast Najlepszy dla zawartości * 0 1 2 3 4 5 Określa kontrast wydruku. Usuwanie tła Poziom Od ‑4 do 4 (0*) Określa stopień widoczności tła na skanowanym obrazie. Skanuj całą powierzchnię Włączone Wyłącz * Umożliwia skanowanie całej powierzchni oryginalnego dokumentu. Elementy sterujące administratora Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Wartość domyślna dla tekstu 5-95 (75*) Ustawia jakość tekstu na skanowanym obrazie. Wartość domyślna dla tekstu/fotografii 5-95 (75*) Ustawia jakość tekstu lub fotografii na skanowanym obrazie. Wartość domyślna dla fotografii 5-95 (50*) Ustawia jakość fotografii na skanowanym obrazie. Dziennik transmisji Drukuj dziennik * Nie drukuj dziennika Drukuj tylko w razie błędu Drukuje dziennik dla pomyślnego przesłania skanu do lokalizacji FTP. Źródło papieru dziennika Zasobnik  [x] (1*) Określa źródło papieru, z którego pobierany jest papier podczas drukowania dzienników FTP. menu Domyślne ustawienia FTP"},{"UUID":"2686fe69-d49a-4f4e-b40d-23ce43a402b6","title":"Napęd USB","link":"flash-drive-scan-topic.html","desc":"Skanuj dysk flash Elementy menu","descFull":"Skanuj dysk flash Elementy menu  Skanuj dysk flash  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Format PDF (.pdf) * TIFF (.tif) JPEG (.jpg) Określa format pliku skanowanego obrazu. Ustawienia PDF Wersja PDF 1.3 1,4 1,5* 1,6 1,7 Wersja archiwalna A‑1a * A‑1b Bezpieczny Wyłącz * Włączone Archiwalny (PDF/A) Wyłącz * Włączone Ustawia format PDF dla skanowanego obrazu. Wersja archiwalna  i  Archiwalna (PDF/A)  pojawiają się tylko wtedy, gdy dla ustawienia  Wersja PDF  wybrano wartość 1.4. Typ zawartości Tekst Tekst/fotografia * Grafika Fotografia Poprawia końcową jakość w oparciu o zawartość oryginalnego dokumentu. Kolor Czarno-biały Szary Kolorowy * Automatyczny Określa kolor podczas skanowania obrazu. Rozdzielczość 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Ustawia rozdzielczość skanowanego obrazu. Intensywność 1-9 (5*) Dostosowuje intensywność zeskanowanego obrazu. Orientacja Pionowa * Pozioma Wybieranie orientacji oryginalnego dokumentu. Ten element menu pojawia się tylko w niektórych modelach drukarek. Rozmiar oryginału [Lista rozmiarów papieru] (Rozmiary mieszane*) Określa rozmiar papieru oryginalnego dokumentu. Strony Wyłącz * Krótsza krawędź Dłuższa krawędź Określa orientację oryginalnego dokumentu przy skanowaniu obustronnym. Ten element menu pojawia się tylko w niektórych modelach drukarek. Nazwa pliku Określa nazwę pliku skanowanego obrazu. Zaawansowane obrazowanie Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Równowaga kolorów Cyjan – Czerwony od -4 do 4 (0*) Magenta – Zielony od -4 do 4 (0*) Żółty – Niebieski od -4 do 4 (0*) Dopasowanie intensywności koloru podczas skanowania. Automatyczne wykrywanie koloru Czułość koloru 1-9 (5*) Czułość obszaru 1-9 (5*) Głębia bitowa skanowania 1-bitowa * 8-bitowa Minimalna rozdzielczość skanowania 75 dpi 150 dpi 200 dpi 300 dpi * Ustawia intensywność koloru, jaką drukarka wykrywa z oryginalnego dokumentu. Kontrast Najlepszy dla zawartości * 0 1 2 3 4 5 Określa kontrast wydruku. Usuwanie tła Poziom Od ‑4 do 4 (0*) Określa stopień widoczności tła na skanowanym obrazie. Skanuj całą powierzchnię Włączone Wyłącz * Umożliwia skanowanie całej powierzchni oryginalnego dokumentu. Elementy sterujące administratora Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Wartość domyślna dla tekstu 5-95 (75*) Ustawia jakość tekstu na skanowanym obrazie. Wartość domyślna dla tekstu/fotografii 5-95 (75*) Ustawia jakość tekstu lub fotografii na skanowanym obrazie. Wartość domyślna dla fotografii 5-95 (50*) Ustawia jakość fotografii na skanowanym obrazie. menu Skanuj dysk flash"},{"UUID":"ede81248-cb31-4705-a0a8-1b2e987376b4","title":"Napęd USB","link":"flash-drive-scan-topic.html","desc":"Drukuj z dysku flash Elementy","descFull":"Drukuj z dysku flash Elementy menu Drukuj z dysku flash i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Liczba kopii 1-9999 (1*) Ustawianie liczby kopii. Źródło papieru Zasobnik  [x] (1*) Ręczny podajnik papieru Ręczny kopert Wybierz ustawienia źródła papieru dla zadania drukowania. Sortuj (1,1,1) (2,2,2) (1,2,3) (1,2,3)* Drukuje wiele kopii po kolei. Strony Jednostronnie * Dwustronnie Określa sposób drukowania: na jednej lub na obu stronach strony. Styl odwrócenia Long Edge * Krótka krawędź Ustala, wzdłuż której krawędzi (dłuższej, czy krótszej krawędzi) arkusz jest składany w trakcie drukowania dwustronnego. W zależności od wybranej opcji drukarka automatycznie przesuwa każdą wydrukowaną informację ze strony dla prawidłowego zszycia zadania. Stron na arkusz Wyłącz * 2 strony na arkusz 3 stron na arkusz 4 stron na arkusz 6 stron na arkusz 9 stron na arkusz 12 stron na arkusz 16 stron na arkusz Pozwala na drukowanie obrazów wielu stron na jednej stronie arkusza. Kilka stron na arkuszu – kolejność Poziomo * Odwróć w poziomie Odwróć w pionie Pionowo Określa ustawienie obrazów wielu stron na jednym arkuszu w przypadku użycia opcji  Kilka stron na arkuszu . Rozmieszczenie zależy od liczby obrazów stron i ich orientacji. Stron na arkusz wg orientacji Automatycznie * Pozioma Pionowa Określa orientację dokumentu zawierającego wiele stron w przypadku użycia opcji  Kilka stron na arkuszu . Kilka stron na arkuszu – obramowanie Brak * Jednolite Powoduje drukowanie obramowania wokół każdego obrazu strony, gdy używana jest opcja  Kilka stron na arkuszu . Arkusze separujące Wyłącz * Między kopiami Między zadaniami Między stronami Określa, czy w czasie drukowania mają być wstawiane puste arkusze separujące. Źródło arkuszy separujących Zasobnik 1 Określanie źródła papieru dla arkusza separującego. Puste strony Nie drukuj * Drukowanie Określa, czy w zadaniu drukowania mają być puste strony. menu Drukuj z dysku flash"},{"UUID":"0472fcad-8768-401b-8279-3fc4e99f5e82","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Przegląd sieci komputerowej Elementy menu","descFull":"Przegląd sieci komputerowej Elementy menu  Przegląd sieci  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Aktywny adapter Automatycznie * Sieć standardowa Łączność bezprzewodowa Wybieranie typu połączenia sieciowego. Stan sieci Wyświetlanie informacji o stanie połączenia z siecią drukarki. Wyświetlanie informacji o stanie sieci na drukarce Wyłączone Włącz * Wyświetlanie informacji o stanie sieci na wyświetlaczu. Szybkość, dupleks Wyświetlanie informacje o prędkości obecnie aktywnej karty sieciowej. IPv4 Pokaż adres IPv4. Wszystkie adresy IPv6 Pokaż wszystkie adresy IPv6. Resetuj serwer druku Start Resetuje całą aktywną komunikację z drukarką. To ustawienie usuwa wszystkie ustawienia konfiguracji sieciowej. Czas oczekiwania na zadanie sieciowe Wyłączone Włączone * Umożliwia określenie czasu, po którym drukarka anuluje sieciowe zadanie drukowania. Czas oczekiwania na zadanie sieciowe Określ wartość czasu oczekiwania (w sekundach) po włączeniu ustawienia  Czasu oczekiwania na zadania sieciowe . Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Strona tytułowa Wyłącz * Włączone Drukuje stronę tytułową. Zakres portów opcji Skanuj do komputera Określa poprawny zakres portów dla drukarek znajdujących się za zaporą blokującą porty. Włącz połączenia sieciowe Włącz * Wyłącz Włącz lub wyłącz wszystkie połączenia sieciowe. Włącz protokół LLDP Wyłącz * Włączone Włącz protokół Link Layer Discovery (LLDP) w drukarce. menu Przegląd sieci komputerowej"},{"UUID":"b49ed4e1-7b3a-43dd-9194-5ed15a1d2161","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Łączność bezprzewodowa To menu jest","descFull":"Łączność bezprzewodowa To menu jest dostępne tylko w drukarkach podłączonych do sieci bezprzewodowej lub drukarkach z modułem bezprzewodowym. Elementy menu  Sieć bezprzewodowa  i ich opis Element menu Opis Konfiguracja za pomocą aplikacji mobilnej Skonfiguruj połączenie bezprzewodowe za pomocą aplikacji Lexmark Mobile Assistant. Konfiguracja na panelu drukarki Wybierz sieć Dodaj sieć Wi-Fi Nazwa sieci Network Mode (Tryb sieciowy) Tryb zabezpieczeń komunikacji bezprzewodowej Wyłączone * WPA2/WPA - Personal WPA2 - Personal WPA2/WPA3 ‑ Personal WPA3 ‑ Personal Uwierzytelnianie 802.1x — RADIUS Określ sieć bezprzewodową, z którą łączy się drukarka. Ten element menu pojawia się jako  Konfiguracja połączenia bezprzewodowego  podczas korzystania z wbudowanego serwera WWW. konfiguracja bezpiecznego dostępu do sieci Wi-Fi Metoda z przyciskiem Metoda kodu PIN Ustanowienie połączenia bezprzewodowego oraz włączenie zabezpieczeń sieci. Metoda z przyciskiem  umożliwia podłączenie drukarki do sieci bezprzewodowej przez naciśnięcie przycisków na drukarce i na punkcie dostępu (routerze bezprzewodowym) w określonym czasie. Metoda kodu PIN  umożliwia podłączenie drukarki do sieci bezprzewodowej przy użyciu kodu PIN z drukarki, który należy wprowadzić do ustawień sieci bezprzewodowej punktu dostępu. Zgodność 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz / 5 GHz) 802.11a/n/ac (5 GHz) Określa standard sieci bezprzewodowej. 802.11a/b/g/n/ac (2,4 GHz / 5 GHz)  i  802.11a/n/ac (5 GHz)  są widoczne wyłącznie po zainstalowaniu modułu sieci bezprzewodowej. Tryb zabezpieczeń komunikacji bezprzewodowej Wyłączone * WPA2/WPA-Personal WPA2-Personal WPA2/WPA3 ‑ Personal WPA3 ‑ Personal Uwierzytelnianie 802.1x — RADIUS Ustaw typ zabezpieczeń podłączania drukarki do urządzeń bezprzewodowych. WPA2/WPA-Personal AES * Włącz zabezpieczenia sieci bezprzewodowej za pomocą standardu WPA2/WPA. Ten element menu jest wyświetlany tylko po ustawieniu  Trybu zabezpieczeń komunikacji bezprzewodowej  na  WPA2/WPA–Personal . Ustaw PSK Ustaw hasło do bezpiecznego połączenia bezprzewodowego. Ten element menu jest wyświetlany tylko po ustawieniu  Trybu zabezpieczeń komunikacji bezprzewodowej  na  WPA2/WPA-Personal  lub  WPA2-Personal . WPA2-Personal AES * Włącz zabezpieczenia sieci bezprzewodowej za pośrednictwem protokołu WPA2. Ten element menu jest wyświetlany tylko po ustawieniu  Trybu zabezpieczeń komunikacji bezprzewodowej  na  WPA2-Personal . Tryb szyfrowania danych 802.1x WPA+ WPA2 * WPA2 + PMF * Włącz zabezpieczenia sieci bezprzewodowej za pomocą standardu 802.1x. Ten element menu jest wyświetlany tylko po ustawieniu  trybu zabezpieczeń komunikacji bezprzewodowej  na  802.1x — RADIUS . IPv4 Włącz funkcję DHCP Włącz * Wył. Włącza dynamiczny protokół konfiguracji hosta (DHCP, Dynamic Host Configuration Protocol). DHCP to standardowy protokół, który umożliwia serwerowi dynamiczne przypisywanie adresu IP i innych parametrów konfiguracji sieci do każdego urządzenia w danej sieci tak, aby mogło ono komunikować się z innymi sieciami IP. IPv4 Ustaw stały adres IP Adres IP Maska sieci Brama Ustawia statyczny adres IP drukarki. IPv6 Włącz funkcję IPv6 Włącz * Wył. Włącza obsługę protokołu IPv6 w drukarce. IPv6 Włącz funkcję DHCPv6 Włączone Wyłącz * Włącza obsługę protokołu DHCPv6 w drukarce. IPv6 Automatyczna autokonfiguracja bezstanowa Włącz * Wył. Umożliwia zaakceptowanie przez kartę sieciową drukarki automatycznych wpisów konfiguracji adresu IPv6 dostarczonych przez router. IPv6 Adres serwera DNS Określ adres serwera DNS. IPv6 Adres IPv6 przypisany ręcznie Przypisz adres IPv6. Ta pozycja menu jest obsługiwana tylko w niektórych modelach drukarek. IPv6 Router IPv6 przypisany ręcznie Przypisz adres IPv6 routera. Ta pozycja menu jest obsługiwana tylko w niektórych modelach drukarek. IPv6 Prefiks adresu 0-128 (64*) Określ prefiks adresu. IPv6 Wszystkie adresy IPv6 Pokaż wszystkie adresy IPv6. IPv6 Wszystkie adresy routerów IPv6 Pokaż wszystkie adresy IPv6 routera. Adres sieciowy UAA LAA Umożliwia wyświetlenie adresów sieciowych. PCL SmartSwitch Włącz * Wył. Konfiguruje drukarkę tak, aby przełączała się automatycznie na emulację PCL, jeśli zadanie drukowania tego wymaga, bez względu na domyślny język drukarki. Jeśli opcja  PCL SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . PS SmartSwitch Włącz * Wył. Konfiguruje drukarkę tak, aby przełączała się automatycznie na emulację PS, jeśli zadanie drukowania tego wymaga, bez względu na domyślny język drukarki. Ta pozycja menu jest obsługiwana tylko w niektórych modelach drukarek. Jeśli opcja  PS SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . Buforowanie zadań Włączone Wyłącz * Przed rozpoczęciem drukowania zadania drukowania są tymczasowo przechowywane na dysku twardym lub na inteligentnym dysku pamięci (ISD). Ten element menu pojawia się tylko wtedy, gdy zainstalowano ISD. Binary PS (Mac) Automatycznie * Włączone Wył. Konfiguruje drukarkę w celu przetwarzania binarnych zadań drukowania w języku PS.  pochodzących z  komputerów Macintosh. Ta pozycja menu jest obsługiwana tylko w niektórych modelach drukarek. Ustawienie  Wł.  umożliwia przetwarzanie nieprzetworzonych binarnych zadań drukowania w języku PostScript. Ustawienie  Wył.  umożliwia filtrowanie zadań drukowania za pomocą standardowego protokołu. menu Łączność bezprzewodowa"},{"UUID":"071eb43c-6c73-4712-ae95-3ed1323470b7","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Elementy menu ","descFull":"Wi‑Fi Direct Elementy menu  Wi-Fi Direct  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Włącz opcję Wi‑Fi Direct Włączone Wyłącz * Ustaw drukarkę, aby łączyła się bezpośrednio z urządzeniami Wi-Fi. Nazwa sieci Wi‑Fi Direct Określa nazwę sieci Wi-Fi Direct. Hasło sieci Wi‑Fi Direct Ustawianie hasła w celu uwierzytelnienia i weryfikacji użytkowników w przypadku połączenia Wi-Fi. Pokaż hasło na stronie konfiguracji Wyłączone Włącz * Pokaż  hasło sieci Wi‑Fi Direct  na  stronie konfiguracji sieci . Preferowany numer kanału sieci bezprzewodowej 1-11 Automatycznie * Wybieranie preferowanych kanałów sieci Wi-Fi. Adres IP właściciela grupy Określanie adresu IP właściciela grupy. Automatyczna akceptacja żądań przycisku dociskowego Wyłącz * Włączone Automatyczne akceptowanie żądań połączenia z siecią. Automatyczne akceptowanie klientów nie jest zabezpieczone. menu Wi‑Fi Direct"},{"UUID":"08d730b3-8ed4-4242-b8ad-b86a3c04271c","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Ethernet Elementy menu  Ethernet","descFull":"Ethernet Elementy menu  Ethernet  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Szybkość sieci Wyświetla informacje o szybkości aktywnej karty sieciowej. IPv4 Włącz funkcję DHCP Włącz * Wyłączone Włącza dynamiczny protokół konfiguracji hosta (DHCP, Dynamic Host Configuration Protocol). DHCP to standardowy protokół pozwalający serwerowi na dynamiczne dystrybuowanie adresów IP oraz informacji dotyczących konfiguracji do klientów. IPv4 Ustaw stały adres IP Adres IP Maska sieci Brama Ustawia statyczny adres IP drukarki. IPv6 Włącz funkcję IPv6 Włącz * Wyłączone Włącza obsługę protokołu IPv6 w drukarce. IPv6 Włącz funkcję DHCPv6 Wyłącz * Włączone Włącza obsługę protokołu DHCPv6 w drukarce. IPv6 Automatyczna autokonfiguracja bezstanowa Włącz * Wyłączone Umożliwia zaakceptowanie przez kartę sieciową drukarki automatycznych wpisów konfiguracji adresu IPv6 dostarczonych przez router. IPv6 Adres serwera DNS Określ adres serwera DNS. IPv6 Adres IPv6 przypisany ręcznie Określ adres IP serwera DNS IPv6. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. IPv6 Router IPv6 przypisany ręcznie Określ router dla sieci IPv6. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. IPv6 Prefiks adresu 0-128 (64*) Określ prefiks adresu. IPv6 Wszystkie adresy IPv6 Pokaż wszystkie adresy IPv6. IPv6 Wszystkie adresy routerów IPv6 Pokaż wszystkie adresy IPv6 routera. Adres sieciowy UAA LAA Wyświetla adresy MAC (Media Access Control) drukarki: adres LAA (Locally Administered Address) i adres UAA (Universally Administered Address). Adres LAA drukarki można zmienić ręcznie. PCL SmartSwitch Włącz * Wyłączone Konfiguruje drukarkę tak, aby przełączała się automatycznie na emulację PCL, jeśli zadanie drukowania tego wymaga, bez względu na domyślny język drukarki. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Jeśli opcja  PCL SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . PS SmartSwitch Włącz * Wyłączone Konfiguruje drukarkę tak, aby przełączała się automatycznie na emulację PS, jeśli zadanie drukowania tego wymaga, bez względu na domyślny język drukarki. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Jeśli opcja  PS SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . Binary PS (Mac) Automatycznie * Włączone Wyłączone Konfiguruje drukarkę w celu przetwarzania binarnych zadań drukowania w języku PostScript pochodzących z komputerów Macintosh. Ustawienie  Wł.  umożliwia przetwarzanie nieprzetworzonych binarnych zadań drukowania w języku PostScript. Ustawienie  Wył.  umożliwia filtrowanie zadań drukowania za pomocą standardowego protokołu. Energooszczędny Ethernet Automatycznie * Włączone Wyłączone Zmniejszenie zużycia energii, gdy drukarka nie odbiera żadnych danych przez sieć Ethernet. menu Ethernet"},{"UUID":"e8f06f0d-8152-4e71-962e-5dc323397790","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"TCP/IP To menu jest dostępne","descFull":"TCP/IP To menu jest dostępne tylko w drukarkach sieciowych lub drukarkach podłączonych do serwerów druku. Elementy menu  TCP/IP  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Ustaw nazwę hosta Umożliwia ustawienie bieżącej nazwy hosta TCP/IP. Nazwa domeny Umożliwia ustawienie nazwy domeny. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Włącz DHCP/BOOTP w celu aktualizacji serwera NTP Włącz * Wyłączone Zezwala klientom DHCP i BOOTP na aktualizowanie ustawień NTP drukarki. Nazwa konfiguracji zerowej Określa nazwę usługi dla sieci Zero Configuration. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Enable Auto IP (Włącz Auto IP) Włącz * Wyłączone Automatycznie przypisuje adres IP. Adres serwera DNS Określa aktualny adres DNS (Domain Name System) serwera. Zapasowy serwer DNS Określa zapasowe adresy serwera DNS. Zapasowy serwer DNS 2 Zapasowy serwer DNS 3 Kolejność wyszukiwania domen Określa listę nazw domen w celu lokalizowania drukarki i jej zasobów przechowywanych w różnych domenach w obrębie sieci. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Włącz funkcję DDNS Wyłącz * Włączone Aktualizuj ustawienia Dynamic DNS. DDNS TTL Określa aktualne ustawienia DDNS. Domyślny parametr TTL Czas odświeżania DDNS Włącz mDNS Włącz * Wyłączone Aktualizuje ustawienia multicast DNS. Adres WINS Określa adres serwera dla usługi WINS (Windows Internet Name Service). Włącz funkcję BOOTP Wyłącz * Włączone Zezwala BOOTP na przydzielanie drukarce adresu IP. MTU Określa parametr MTU (Maximum Transmission Unit) dla połączeń TCP. Maksymalny limit to 1500. Zastrzeżona lista serwera Określa adres IP dla połączeń TCP. To menu jest wyświetlane tylko podczas korzystania z wbudowanego serwera WWW. Do rozdzielania adresów IP należy użyć przecinka. Na liście adresów IP można umieścić do 50 pozycji. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Opcje zastrzeż. listy serwera Blokuj wszystkie porty * Blokuj tylko drukowanie Blokuj tylko drukowanie i HTTP Określa sposób, w jaki adresy IP z listy mogą uzyskiwać dostęp do funkcji drukarki. To menu jest wyświetlane tylko podczas korzystania z wbudowanego serwera WWW. Ta pozycja menu jest dostępna tylko w niektórych modelach drukarek. Raw Print Port 1-65535 (9100*) Określa numer portu RAW dla drukarek podłączonych do sieci. Maksymalna szybkość ruchu wychodzącego Wyłączone * Włączone Pozwala drukarce na przesył z maksymalną prędkością. Włącz protokół TLSv1.0 Włącz * Wyłączone Włącz protokół TLSv1.0. Włącz protokół TLSv1.1 Włącz * Wyłączone Włącz protokół TLSv1.1. Lista algorytmów szyfrujących SSL Określ algorytmy szyfrowania dla połączeń SSL lub TLS. menu TCP/IP"},{"UUID":"a23d54aa-4750-4a6c-acd7-6493a96f4d71","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"SNMP To menu jest wyświetlane","descFull":"SNMP To menu jest wyświetlane tylko w przypadku drukarek sieciowych i drukarek podłączonych do serwerów druku. Elementy menu  SNMP  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. SNMP wersje 1 i 2c Włączone Wyłączone Włącz * Pozw. na ust. SNMP Wyłączone Włącz * Włącz PPM MIB Wyłączone Włącz * Społeczność SNMP Konfiguruje protokół SNMP (Simple Network Management Protocol) w wersjach 1 i 2c w celu instalacji aplikacji i sterowników drukowania. SNMP wersja 3 Włączone Wyłączone Włącz * Nazwa kontekstowa Ustaw poświadczenia odczytu/zapisu Nazwa użytkownika Hasło uwierzytelniania Hasło prywatności Ustaw tylko poświadczenia odczytu Nazwa użytkownika Hasło uwierzytelniania Hasło prywatności Kod uwierzytelniania MD5 SHA1 * Minimalny poziom uwierzytelniania Brak uwierzytelniania, brak prywatności Uwierzytelnianie, bez prywatności Uwierzytelnianie, prywatność * Algorytm prywatności DES AES‑128 * Konfiguruje protokół SNMP w wersji 3 w celu instalacji i aktualizacji zabezpieczeń drukarki. menu SNMP"},{"UUID":"c1ff1450-33ac-4c8b-97fa-74c39bf5eefa","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"IPSec To menu jest wyświetlane","descFull":"IPSec To menu jest wyświetlane tylko w przypadku drukarek sieciowych i drukarek podłączonych do serwerów druku. Elementy menu  IPSec  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Włącz funkcję IPSec Wyłącz * Włączone Włącza protokół IPSec (Internet Protocol Security). Podstawowa konfiguracja Domyślny * Zgodność Bezpieczny Wykonuje podstawową konfigurację protokołu IPSec. Ten element menu jest wyświetlany tylko gdy protokół  Włącz funkcję IPSec  ustawiony jest jako  Włącz . Proponowana grupa DH (Diffiego-Hellmana) modp2048 (14)* modp3072 (15) modp4096 (16) modp6144 (17) Ustawia uwierzytelnianie IPSec. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Zgodność . Proponowana metoda szyfrowania AES * 3DES Określ metodę szyfrowania. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Zgodność . Proponowana metoda uwierzytelniania SHA256 * SHA512 SHA1 Określ metodę uwierzytelniania. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Zgodność . Czas IKE SA (w godzinach) ‑1 ‑2 ‑4 ‑8 ‑24 Określ termin ważności IKE SA. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Bezpieczna . Czas IPSec SA (w godzinach) ‑1 ‑2 ‑4 ‑8 ‑24 Określ termin ważności IPSec SA. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Bezpieczna . Certyfikat IPSec urządzenia domyślny Określa certyfikat IPSec. Ten element menu jest wyświetlany tylko po ustawieniu opcji  Podstawowa konfiguracja  na  Zgodność  lub  Bezpieczna . Połączenia uwierzytelnione kluczem wstępnym Host  [x] Adres Klucz Konfiguruje uwierzytelnione połączenia drukarki. Te elementy menu są wyświetlane tylko gdy protokół  Włącz funkcję IPSec  ustawiony jest jako  Włącz . Połączenia uwierzytelnione certyfikatem Host  [x] –  Adres [/podsieć] Adres [/podsieć] menu IPSec"},{"UUID":"ed16f673-1900-4d57-8e5f-3bc9cb0f5ff7","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"802.1x To menu jest wyświetlane","descFull":"802.1x To menu jest wyświetlane tylko w przypadku drukarek sieciowych i drukarek podłączonych do serwerów druku. Elementy menu  802.1x  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Aktywna Wyłącz * Włącz Pozwól drukarce korzystać z sieci, które wymagają uwierzytelniania przed przyznaniem dostępu. menu 802.1x"},{"UUID":"2a86a91c-6e2f-4efd-b3c9-a769b70cc707","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Konfiguracja LPD To menu jest","descFull":"Konfiguracja LPD To menu jest wyświetlane tylko w przypadku drukarek sieciowych i drukarek podłączonych do serwerów druku. Elementy menu  Konfiguracja LPD  i ich opis Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Limit czasu oczekiwania LPD 0–65535 sekund (90*) Ustawia czas oczekiwania, aby zapobiec nieskończonemu oczekiwaniu przez serwer LPD (Line Printer Daemon) na zawieszone lub nieprawidłowe zadania drukowania. Strona tytułowa LPD Wyłącz * Włącz Drukuje stronę tytułową dla wszystkich zadań drukowania LPD. Strona tytułowa to pierwsza strona zadania drukowania, używana jako separator zadań oraz służąca do identyfikowania inicjatora żądania. Strona końcowa LPD Wyłącz * Włącz Drukuje stronę końcową dla wszystkich zadań drukowania LPD. Storna końcowa to ostatnia strona zadania drukowania. Konwersja znaku powrotu karetki przez LPD Wyłącz * Włącz Włącza konwersję znaku powrotu karetki. Powrót karetki to mechanizm wysyłający do drukarki polecenie przesunięcia kursora do początkowego położenia w tym samym wierszu. menu Konfiguracja LPD"},{"UUID":"90cbf999-1595-41d9-a327-6f2f65c03676","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Ustawienia HTTP/FTP To menu jest","descFull":"Ustawienia HTTP/FTP To menu jest wyświetlane tylko w przypadku drukarek sieciowych i drukarek podłączonych do serwerów druku. Elementy menu  Ustawienia HTTP/FTP  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Enable HTTP Server (Włącz serwer HTTP) Wyłączone Włącz * Uzyskuje dostęp do wbudowanego serwera WWW w celu monitorowania drukarki i zarządzania nią. Włącz funkcję HTTPS Wyłączone Włącz * Konfiguruje ustawienia protokołu HTTPS (Hypertext Transfer Protocol Secure). Wymuszaj połączenia HTTPS Wyłącz * Włączone Wymusza na drukarce korzystanie z połączeń HTTPS. Włącz funkcję FTP/TFTP Wyłączone Włącz * Wysyła pliki za pomocą protokołu FTP. Adres IP serwera proxy HTTP Konfiguruje ustawienia serwerów HTTP i FTP. Ta funkcja dostępna jest wyłącznie w wybranych modelach drukarek. Adres IP serwera proxy FTP Domyślny port HTTP 1–65535 (80*) Certyfikat HTTPS urządzenia Domyślny port FTP 1–65535 (21*) Limit czasu żądań HTTP/FTP 1-299 (30*) Określa ilość czasu przed zatrzymaniem połączenia z serwerem. Ponawianie żądań HTTP/FTP 1-299 (3*) Ustawia liczbę prób nawiązania połączenia z serwerem HTTP/FTP. menu Ustawienia HTTP/FTP"},{"UUID":"d08f1c80-3f8a-459c-b21a-c19434d3471e","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"USB Elementy menu  USB","descFull":"USB Elementy menu  USB  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. PCL SmartSwitch Wyłączone Włącz * Konfiguruje drukarkę tak, aby przełączała się na emulację PCL, jeśli zadanie drukowania otrzymane przez port USB tego wymaga, bez względu na domyślny język drukarki. Jeśli opcja  PCL SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . PS SmartSwitch Wyłączone Włącz * Konfiguruje drukarkę tak, aby przełączała się na emulację PS, jeśli zadanie drukowania otrzymane przez port USB tego wymaga, bez względu na domyślny język drukarki. Jeśli opcja  PS SmartSwitch  jest wyłączona, drukarka nie analizuje danych przychodzących i korzysta z domyślnego języka drukarki, który został określony w menu  Konfiguracja . Włącz port USB Włącz * Wyłącz Włącza standardowy port USB. Binary PS (Mac) Automatyczny Włącz * Wyłączone Konfiguruje drukarkę w celu przetwarzania binarnych zadań drukowania w języku PostScript pochodzących z komputerów Macintosh. Ten element menu pojawia się tylko w niektórych modelach drukarek. Ustawienie Wł. umożliwia przetwarzanie nieprzetworzonych binarnych zadań drukowania w języku PostScript. Ustawienie Wył. umożliwia filtrowanie zadań drukowania za pomocą standardowego protokołu. menu USB"},{"UUID":"beb6e239-2ffe-4b14-a325-99385a797eeb","title":"Network/Ports (Sieć/Porty)","link":"network-overview-topic.html","desc":"Ograniczanie zewnętrznego dostępu do sieci","descFull":"Ograniczanie zewnętrznego dostępu do sieci komputerowej Elementy menu ustawień  Ogranicz dostęp do sieci zewnętrznej  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Ograniczanie zewnętrznego dostępu do sieci komputerowej Wyłącz * Włącz Ogranicz dostęp do lokacji sieciowych. Zewnętrzny adres sieciowy Określ adresy sieciowe o ograniczonym dostępie. Adres e-mail do powiadomienia Określ adres e-mail, na który wysyłane będą powiadomienia o zdarzeniach logowania. Częstotliwość wysyłania poleceń ping 1–300 (10*) Określ w sekundach przedział czasowy dla zapytań sieciowych. Temat Określ temat i treść powiadomienia e-mail. Komunikat menu Ograniczanie zewnętrznego dostępu do sieci komputerowej"},{"UUID":"bb023edc-eb22-4417-8d10-42d852398195","title":"Metody logowania","link":"login-methods-subgroup.html","desc":"Publiczny To menu można skonfigurować","descFull":"Publiczny To menu można skonfigurować tylko przy użyciu serwera Embedded Web Server. Elementy menu  Publiczny  i ich opisy Element menu Opis Zarządzanie uprawnieniami Dostęp do funkcji Zarządzaj skrótami Utwórz profile Drukuj z dysku flash Skanuj dysk flash Funkcja kopiowania Funkcja e-mail Funkcja faksu Funkcja FTP Wznów wstrzymane faksy Wstrzymane zadania Profile użytkowników Anuluj zadania w urządzeniu Zmień język Internet Printing Protocol (IPP) Zdalne uruchamianie skanowania Druk czarno-biały Folder sieciowy — Skanowanie Steruje dostępem do funkcji drukarki. Opcje  Drukuj z dysku flash  i  Skanuj z dysku flash  są dostępne tylko w niektórych modelach drukarek. Zarządzanie uprawnieniami Menu administracyjne Menu bezpieczeństwa Menu sieci/portów Menu papieru Menu Raporty Menu konfiguracji funkcji Menu materiałów eksploatacyjnych Menu SE Menu urządzenia Steruje dostępem do menu drukarki. Zarządzanie uprawnieniami Zarządzanie urządzeniem Zdalne zarządzanie Aktualizacje oprogramowania sprzętowego Dostęp do wbudowanego serwera WWW Importuj / eksportuj wszystkie ustawienia Usuwanie po awarii Steruje dostępem do opcji zarządzania drukarką. menu Publiczny"},{"UUID":"360bdc8c-54ec-4b8c-81b4-b8b020332e72","title":"Metody logowania","link":"login-methods-subgroup.html","desc":"Konta lokalne Elementy menu ","descFull":"Konta lokalne Elementy menu  Konta lokalne  i ich opis Element menu Opis Dodaj użytkownika Nazwa użytkownika/hasło Nazwa użytkownika Hasło PIN Tworzy lokalne konta w celu zarządzania dostępem do funkcji drukarki. Zarządz. grupami/uprawnieniami Dodaj grupę Importuj funkcje kontroli dostępu Dostęp do funkcji Menu administracyjne Zarządzanie urządzeniem Wszyscy użytkownicy Importuj funkcje kontroli dostępu Dostęp do funkcji Menu administracyjne Zarządzanie urządzeniem Administrator Dostęp do funkcji Menu administracyjne Zarządzanie urządzeniem Steruje dostępem grup lub użytkowników do funkcji, aplikacji i ustawień zabezpieczeń drukarki. menu Konta lokalne"},{"UUID":"40f5ab18-bb77-4e13-a0c5-725148839667","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Zarządzanie certyfikatami Elementy menu ","descFull":"Zarządzanie certyfikatami Elementy menu  Zarządzanie certyfikatami  i ich opisy Element menu Element menu Skonfiguruj domyślne ustawienia certyfikatów Nazwa pospolita Nazwa organizacji Nazwa jednostki Kraj/region Nazwa okręgu Nazwa miasta Alternatywna nazwa podmiotu Ustawia domyślne wartości wygenerowanych certyfikatów. Certyfikaty urządzeń Generuje, usuwa lub wyświetla certyfikaty urządzeń. Zarządzaj certyfikatami CA Ładuje, usuwa lub wyświetla certyfikaty urzędu certyfikacji (CA). menu Zarządzanie certyfikatami"},{"UUID":"9f3e1989-486e-47c7-8aa5-1a18f6931739","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Harmonogram wyłączeń urządzeń USB Element","descFull":"Harmonogram wyłączeń urządzeń USB Element menu  Harmonogram wyłączeń urządzeń USB  i jego opis Element menu Opis Harmonogramy Dodaj nowy harmonogram Dodaje harmonogram dostępu do portu USB z przodu. menu Harmonogram wyłączeń urządzeń USB"},{"UUID":"027aafba-a07a-4ea0-84da-86fc4358e1de","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Ograniczenia logowania Elementy menu ","descFull":"Ograniczenia logowania Elementy menu  Ograniczenia logowania  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Nieudane próby logowania 1–10 (3*) Określa liczbę nieudanych prób logowania przed zablokowaniem użytkownika. Czas wystąpienia błędów 1–60 minut (5*) Określa czas pomiędzy nieudanymi próbami logowania przed zablokowaniem użytkownika. Czas blokady 1–60 minut (5*) Określa czas blokady. Limit czasu logowania w sieci Web 1–120 minut (10*) Określa czas opóźnienia dla zdalnego logowania przed automatycznym wylogowaniem użytkownika. menu Ograniczenia logowania"},{"UUID":"3bfd47eb-da1d-4324-a4f7-448dfa063058","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Ustawienia druku poufnego Elementy menu","descFull":"Ustawienia druku poufnego Elementy menu  Ustawienia druku poufnego  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Maksymalna liczba błędnych numerów PIN 2–10 Ustawia liczbę powtórzeń podczas wprowadzania błędnego numeru PIN. Wartość „0” wyłącza to ustawienie. Po osiągnięciu limitu prób zadania drukowania dla tej nazwy użytkownika i numeru PIN są usuwane. Wygaśnięcie ważności zadania poufnego Wyłącz * 1 godzina 4 godziny 24 godziny 1 tydzień Wyznacz czas wygaśnięcia ważności zadania drukowania poufnego. Jeśli ten element menu zostanie zmieniony, gdy zadania poufne będą znajdować się w pamięci drukarki lub na dysku twardym, wówczas czas wygaśnięcia tych zadań drukowania nie zostanie zaktualizowany do nowej wartości domyślnej. Jeśli drukarka zostanie wyłączona, wówczas wszystkie zadania poufne przechowywane w pamięci drukarki zostaną usunięte. Czas wygaśnięcia powtarzanych zadań Wyłącz * 1 godzina 4 godziny 24 godziny 1 tydzień Ustawia czas wygaśnięcia dla zadań drukowania, które chcesz powtarzać. Czas wygaśnięcia sprawdzania zadań Wyłącz * 1 godzina 4 godziny 24 godziny 1 tydzień Ustawia czas oczekiwania na sprawdzenie wydrukowanej kopii przez użytkownika przed wydrukowaniem kolejnych kopii. Czas wygaśnięcia rezerwacji zadań Wyłącz * 1 godzina 4 godziny 24 godziny 1 tydzień Ustawia czas, przez który drukarka przechowuje zadania drukowania do wydrukowania w późniejszym terminie. Wymagaj wstrzymania wszystkich zadań Wyłącz * Włącz Wstrzymuje wszystkie zadania drukowania. Zachowaj powielone dokumenty Wyłącz * Włącz Ustaw drukarkę pod kątem drukowania różnych dokumentów o tej samej nazwie bez nadpisywania zadań drukowania. menu Ustawienia druku poufnego"},{"UUID":"e63d9cbd-f84f-4424-82ed-308642950b23","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Kasuj pliki tymczasowe Opcje menu","descFull":"Kasuj pliki tymczasowe Opcje menu  Kasuj tymczasowe pliki danych  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Przechowywane w pamięci wbudowanej Wyłącz * Włącz Usuwa wszystkie pliki przechowywane w pamięci drukarki. menu Kasuj pliki tymczasowe"},{"UUID":"55835aee-4704-4685-b516-bdfaaea0eb60","title":"Bezpieczeństwo","link":"login-methods-subgroup.html","desc":"Różne Elementy menu  Różne","descFull":"Różne Elementy menu  Różne  i ich opisy Element menu Opis Gwiazdka (*) umieszczona obok wartości oznacza ustawienie domyślne. Uprawnienia drukowania Wyłącz * Włączone Zezwala użytkownikowi na drukowanie. Domyślny login uprawnień drukowania Wyświetla domyślne uprawnienia używane przez użytkownika do drukowania. To ustawienie jest wyświetlane tylko wtedy, gdy utworzono co najmniej jedną  metodę logowania . Zerowanie ustawień bezpieczeństwa Zezwól na dostęp gościa * Brak efektu Określa dostęp użytkownika do drukarki. Zworka jest umieszczona obok ikony blokady na płycie sterownika. Opcja  Zezwól na dostęp gościa  daje wszystkim osobom dostęp do wszystkich aspektów drukarki. Opcja  Brak efektu  może uniemożliwić dostęp do drukarki, gdy wymagane informacje bezpieczeństwa nie będą dostępne. Minimalna długość hasła 0-32 Określa długość hasła. menu Różne"},{"UUID":"0f0cb763-fa16-4b27-9025-6fa30383f5dd","title":"Używanie menu drukarki","link":"cloud-connector-menu-topic.html","desc":"Cloud Connector Element menu ","descFull":"Cloud Connector Element menu  Cloud Connector  i jego opis Element menu Opis Włączanie/wyłączanie złącza Włącz dostawcę usługi przechowywania w chmurze. menu Cloud Connector"},{"UUID":"d1e3c32f-5b95-4941-a933-95b20faa3b1a","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Strona ustawień menu Element menu","descFull":"Strona ustawień menu Element menu  Strona ustawień menu  i jego opis Element menu Opis Strona ustawień menu Drukuje raport zawierający wszystkie menu drukarki. menu Strona ustawień menu"},{"UUID":"825510a5-0d1a-4442-8435-c6a97fc84861","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Urządzenie Elementy menu  Urządzenie","descFull":"Urządzenie Elementy menu  Urządzenie  i ich opisy Element menu Opis Informacje o urządzeniu Drukuje raport zawierający informacje o drukarce. Statystyki urządzenia Drukuje raport zawierający informacje o wykorzystaniu drukarki i status materiałów eksploatacyjnych. Lista profili Drukuje listę profili przechowywanych na drukarce. Raport inwentaryzacji Drukuje raport zawierający numer seryjny i nazwę modelu drukarki. menu Urządzenie"},{"UUID":"2c5f24e6-177e-4128-b818-27a84f4058ed","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Drukuj Element menu  Drukuj","descFull":"Drukuj Element menu  Drukuj  i jego opis Element menu Opis Drukuj czcionki Czcionki PCL Wydrukuj przykłady oraz informacje o czcionkach dostępnych w każdym języku drukarki. menu Drukuj"},{"UUID":"b353ecdc-d51e-4c94-bca2-d8e3917d0db9","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Skróty Elementy menu  Skróty","descFull":"Skróty Elementy menu  Skróty  i ich opis Element menu Opis Wszystkie skróty Drukuje raport zawierający wykaz wszystkich skrótów przechowywanych w drukarce. Skróty faksu Kopiuj skróty Skróty e-mail Skróty FTP Skrót do folderu sieciowego menu Skróty"},{"UUID":"e16ffc0f-b6c7-498d-8ed2-da07754b1eb7","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Faks To menu pojawia się","descFull":"Faks To menu pojawia się tylko wtedy, gdy faks został skonfigurowany, a opcja  Włącz dziennik zadań  jest  Włączona . Elementy menu  Faks  i ich opisy Element menu Opis Dziennik zadań faksowania Drukuje raport z ostatnich 200 zakończonych zadań faksowania. Dziennik wywołań faksu Drukuje raport z ostatnich 100 wybranych, odebranych i zablokowanych połączeń. menu Faks"},{"UUID":"38092f38-60cc-4206-a0be-83e73eeaa298","title":"Raporty","link":"menu-settings-page-topic.html","desc":"Sieć Element menu  Sieć","descFull":"Sieć Element menu  Sieć  i jego opis Element menu Opis Strona konfiguracji sieci Drukuje stronę zawierającą informacje o skonfigurowanej sieci i ustawieniach łączności bezprzewodowej drukarki. Ten element menu jest wyświetlany tylko w przypadku drukarek sieciowych lub drukarek podłączonych do serwerów druku. Podłączone klienty Wi-Fi Direct Wydrukuj stronę z listą urządzeń, które są podłączone do drukarki przy użyciu opcji Wi-Fi Direct. Ten element menu jest wyświetlany tylko, gdy opcja  Włącz Wi‑Fi Direct  jest ustawiona na  Włącz . menu Sieć"},{"UUID":"621d44cf-23e4-4f3a-a230-b43ca5201f2f","title":"Używanie menu drukarki","link":"troubleshooting-menu-topic.html","desc":"Rozwiązywanie problemów Elementy menu Rozwiązywanie","descFull":"Rozwiązywanie problemów Elementy menu Rozwiązywanie problemów i ich opisy Element menu Opis Drukowanie stron testu jakości Wydrukuj przykładowe strony, aby zidentyfikować i poprawić wady jakości druku. Czyszczenie skanera Wydrukuj instrukcje dotyczące czyszczenia skanera. menu Rozwiązywanie problemów Drukowanie stron testu jakości Czyszczenie skanera"},{"UUID":"d1e97539-9ceb-4991-8e3f-2500a115c332","title":"Konserwacja drukarki","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Sprawdzanie stanu części i materiałów","descFull":"Sprawdzanie stanu części i materiałów eksploatacyjnych Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Urządzenie Statystyki urządzenia W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Sprawdź stan części i materiałów eksploatacyjnych w sekcji Informacje o materiałach eksploatacyjnych na wydrukowanych stronach. sprawdzanie stanu części i materiałów eksploatacyjnych stan materiałów eksploatacyjnych sprawdzanie stan części sprawdzanie"},{"UUID":"6b6b9270-1224-423f-8c42-646c606a297e","title":"Konserwacja drukarki","link":"configuring-supply-notifications-topic.html","desc":"Konfigurowanie powiadomień dotyczących materiałów eksploatacyjnych","descFull":"Konfigurowanie powiadomień dotyczących materiałów eksploatacyjnych Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij opcję  Ustawienia Urządzenie Powiadomienia . W menu Materiały eksploatacyjne kliknij opcję  Niestandardowe powiadomienia o materiałach eksploatacyjnych . Wybierz powiadomienie dla każdego materiału eksploatacyjnego. Zastosuj zmiany. powiadomienia o materiałach eksploatacyjnych konfiguracja konfigurowanie powiadomień dotyczących materiałów eksploatacyjnych"},{"UUID":"ec37d101-b60b-44cd-95c0-ba1aa6fb1915","title":"Konserwacja drukarki","link":"setting-up-e-mail-alert-topic.html","desc":"Konfigurowanie alarmów e-mail Skonfiguruj drukarkę","descFull":"Konfigurowanie alarmów e-mail Skonfiguruj drukarkę do wysyłania alarmów e‑mail w sytuacji, gdy kończą się materiały eksploatacyjne, gdy należy zmienić lub dodać papier lub gdy dojdzie do zacięcia papieru. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym drukarki. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij kolejno opcje  Ustawienia Urządzenie Powiadomienia Konfiguracja alarmów e-mail , a następnie skonfiguruj ustawienia. Aby uzyskać więcej informacji na temat ustawień SMTP, skontaktuj się z dostawcą usług poczty e-mail. Kliknij opcję  Ustaw listy i alarmy e-mail , a następnie skonfiguruj ustawienia. Zastosuj zmiany. alarmy e-mail konfiguracja konfigurowanie alarmów email"},{"UUID":"7ae40896-19dc-4a00-86d2-345889748b78","title":"Konserwacja drukarki","link":"viewing-reports-topic.html","desc":"Oglądanie raportów Przy użyciu panelu","descFull":"Oglądanie raportów Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz raport do wyświetlenia. wyświetlanie raportów raporty drukarki wyświetlanie"},{"UUID":"b4cf58af-0811-4939-ba5f-2dce59d5aa13","title":"Zamawianie części i materiałów eksploatacyjnych","link":"ordering-supplies-group.html","desc":"W Stanach Zjednoczonych informacje na","descFull":"W Stanach Zjednoczonych informacje na temat lokalnych autoryzowanych dostawców materiałów eksploatacyjnych firmy Lexmark można uzyskać, kontaktując się z firmą Lexmark pod numerem telefonu 1-800-539-6275. W innych krajach należy odwiedzić witrynę internetową  www.lexmark.com  lub skontaktować się z punktem sprzedaży, w którym nabyto drukarkę. W celu zamówienia materiałów eksploatacyjnych należy skontaktować się z punktem sprzedaży, w którym nabyto drukarkę. Wszystkie oszacowane czasy eksploatacji materiałów odnoszą się do drukowania na papierze zwykłym w rozmiarze Letter lub A4. Zaniedbanie działań mających na celu zachowanie optymalnej jakości wydruków bądź wymiany części lub materiałów eksploatacyjnych może spowodować uszkodzenie drukarki. oryginalne części i materiały eksploatacyjne"},{"UUID":"8ffd5c65-1873-4316-b31b-4187d48dfc91","title":"Zamawianie części i materiałów eksploatacyjnych","link":"ordering-supplies-group.html","desc":"Używanie oryginalnych części i materiałów","descFull":"Używanie oryginalnych części i materiałów eksploatacyjnych firmy Lexmark. Twoja drukarka Lexmark została zaprojektowana do optymalnej pracy z użyciem oryginalnych materiałów eksploatacyjnych i elementów marki Lexmark. Używanie materiałów i części innych producentów może negatywnie wpłynąć na wydajność, pracę i żywotność drukarki oraz jej części. Może też mieć wpływ na ochronę gwarancyjną. Uszkodzenia spowodowane używaniem części lub materiałów innych producentów nie są naprawiane w ramach gwarancji. Wszelkie wskaźniki materiałów są zaprojektowane tak, by współpracować z częściami i materiałami Lexmark i ich praca może zostać zakłócona, gdy użyte zostaną części lub materiały innych producentów. Użytkowanie materiałów i części związanych z obrazami dłużej niż jest to zalecane może spowodować uszkodzenie drukarki Lexmark i jej podzespołów. Materiały eksploatacyjne i części nieobjęte umową programu zwrotów mogą zostać wyzerowane i poddane regeneracji. Należy jednak pamiętać, że gwarancja producenta nie obejmuje uszkodzeń spowodowanych wykorzystaniem nieoryginalnych materiałów eksploatacyjnych lub części. Zerowanie liczników materiałów eksploatacyjnych lub części bez przeprowadzenia odpowiedniej regeneracji może spowodować uszkodzenie drukarki. Po wyzerowaniu licznika materiałów eksploatacyjnych lub części drukarka może wyświetlić komunikat o błędzie, wskazując obecność wyzerowanego elementu. używanie oryginalnych części i materiałów eksploatacyjnych firmy Lexmark oryginalne części i materiały eksploatacyjne firmy Lexmark"},{"UUID":"0e8ea61b-ac94-49c1-9143-217156380b00","title":"Zamawianie części i materiałów eksploatacyjnych","link":"ordering-supplies-group.html","desc":"Zamawianie kasety z tonerem Szacunkowa","descFull":"Zamawianie kasety z tonerem Szacunkowa wydajność kasety jest zgodna z normą ISO/IEC 19752. Stosowanie bardzo niskiego pokrycia wydruku przez dłuższy czas może pogorszyć rzeczywistą wydajność. W celu zamówienia kasety z tonerem należy skontaktować się z punktem zakupu drukarki. Kasetę z tonerem można zamówić w punkcie zakupu drukarki lub na stronie  www.dell.com/supplies . Zwrotne kasety z tonerem Element USA i Kanada Europejski Obszar Gospodarczy Region Azji i Pacyfiku Ameryka Łacińska Pozostała część Europy, Bliski Wschód i Afryka Australia i Nowa Zelandia Kasety z tonerem objęte programem zwrotu B221000 B222000 B223000 B224000 B225000 B226000 Zwrotna kaseta z tonerem o wysokiej wydajności B221H00 B222H00 B223H00 B224H00 B225H00 B226H00 Zwrotna kaseta z tonerem o bardzo wysokiej wydajności B221X00 B222X00 B223X00 B224X00 B225X00 B226X00 Normalna kaseta z tonerem: Element Cały świat Kaseta z tonerem o bardzo wysokiej wydajności B220XA0 kaseta z tonerem zamawianie zamawianie materiałów eksploatacyjnych kaseta z tonerem"},{"UUID":"d142a97b-eebd-4ba6-8186-42b2052469e4","title":"Zamawianie części i materiałów eksploatacyjnych","link":"ordering-supplies-group.html","desc":"Zamawianie zestawu obrazującego Stosowanie bardzo","descFull":"Zamawianie zestawu obrazującego Stosowanie bardzo niskiego pokrycia wydruku przez dłuższy czas może doprowadzić do niesprawności części składowych zespołu obrazującego przed wyczerpaniem się toneru. W celu zamówienia zestawu obrazującego należy skontaktować się z punktem sprzedaży, w którym nabyto drukarkę. Zestaw obrazujący można zamówić w punkcie zakupu drukarki lub na stronie  www.dell.com/supplies . Numer katalogowy materiału eksploatacyjnego drukarki Element Numer katalogowy Zestaw obrazujący B220Z00 moduł obrazujący zamawianie zamawianie materiałów eksploatacyjnych moduł obrazujący"},{"UUID":"abff08e5-f9f2-44de-b7db-f51f78b6df7e","title":"Wymiana części i materiałów eksploatacyjnych","link":"replacing-toner-cartridge-topic.html","desc":"Wymiana kasety z tonerem Otwórz","descFull":"Wymiana kasety z tonerem Otwórz przednie drzwiczki. Aby zapobiec uszkodzeniu na skutek wyładowania elektrostatycznego, dotknij dowolnego, odsłoniętego metalowego elementu korpusu drukarki zanim dotkniesz wewnętrznych elementów drukarki lub będziesz mieć kontakt z nimi. Wyjmij zestaw obrazujący. Wyjmij zużytą kasetę z tonerem z zespołu obrazującego. Rozpakuj nową kasetę z tonerem. Potrząśnij kasetą, aby rozprowadzić toner. Usuń zabezpieczenie i zdejmij pokrywę. Włóż nową kasetę z tonerem do zestawu obrazującego. Włóż zestaw obrazujący. Zamknij drzwiczki. kaseta z tonerem wymiana wymiana materiałów eksploatacyjnych kaseta z tonerem"},{"UUID":"5bce6289-2bcb-48b2-adf6-c3be600e8359","title":"Wymiana części i materiałów eksploatacyjnych","link":"replacing-toner-cartridge-topic.html","desc":"Wymiana modułu obrazującego Otwórz przednie","descFull":"Wymiana modułu obrazującego Otwórz przednie drzwiczki. Aby zapobiec uszkodzeniu na skutek wyładowania elektrostatycznego, dotknij dowolnego, odsłoniętego metalowego elementu korpusu drukarki zanim dotkniesz wewnętrznych elementów drukarki lub będziesz mieć kontakt z nimi. Wyjmij zużyty moduł obrazujący. Wyjmij kasetę z tonerem, a następnie wyjmij moduł obrazujący. Rozpakuj moduł obrazujący, a następnie włóż do niego kasetę z tonerem. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie wolno dotykać bębna światłoczułego. Może to wpłynąć na jakość kolejnych zadań drukowania. Włóż nowy moduł obrazujący. Zamknij drzwiczki. moduł obrazujący wymiana wymiana materiałów eksploatacyjnych moduł obrazujący"},{"UUID":"40c16cd7-e38d-4955-83d3-1f4bdc18acca","title":"Wymiana części i materiałów eksploatacyjnych","link":"replacing-toner-cartridge-topic.html","desc":"Wymiana modułu dupleksu Wyjmij zużyty","descFull":"Wymiana modułu dupleksu Wyjmij zużyty moduł dupleksu. Rozpakuj nowy moduł dupleksu. Włóż nowy moduł dupleksu. moduł dupleksu wymiana wymiana części moduł dupleksu"},{"UUID":"3f12bba1-a3c1-4148-a3f6-11dcef4debad","title":"Wymiana części i materiałów eksploatacyjnych","link":"replacing-toner-cartridge-topic.html","desc":"Wymiana zasobnika. Wyjmij zużyty zasobnik.","descFull":"Wymiana zasobnika. Wyjmij zużyty zasobnik. Rozpakuj nowy zasobnik. Włóż nowy zasobnik. zasobniki wymiana wymiana części zasobnik"},{"UUID":"04a2f4c1-0e3a-451f-ab88-fa40f32f4919","title":"Wymiana części i materiałów eksploatacyjnych","link":"replacing-toner-cartridge-topic.html","desc":"Zerowanie liczników zużycia materiałów eksploatacyjnych","descFull":"Zerowanie liczników zużycia materiałów eksploatacyjnych Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Konserwacja Menu konfiguracji Zużycie materiałów eksploatacyjnych i liczniki W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz licznik materiałów eksploatacyjnych, który ma zostać wyzerowany. Materiały eksploatacyjne i części nieobjęte umową programu zwrotów mogą zostać wyzerowane i poddane regeneracji. Należy jednak pamiętać, że gwarancja producenta nie obejmuje uszkodzeń spowodowanych wykorzystaniem nieoryginalnych materiałów eksploatacyjnych lub części. Zerowanie liczników materiałów eksploatacyjnych lub części bez przeprowadzenia odpowiedniej regeneracji może spowodować uszkodzenie drukarki. Po wyzerowaniu licznika materiałów eksploatacyjnych lub części drukarka może wyświetlić komunikat o błędzie, wskazując obecność wyzerowanego elementu. liczniki zużycia materiałów eksploatacyjnych przywracanie zerowanie liczników zużycia materiałów eksploatacyjnych"},{"UUID":"383c467c-5b96-4bed-b8a5-71b29f9d3664","title":"Czyszczenie części drukarki","link":"cleaning-printer-topic.html","desc":"Czyszczenie drukarki Aby uniknąć porażenia","descFull":"Czyszczenie drukarki Aby uniknąć porażenia prądem elektrycznym podczas czyszczenia zewnętrznej powierzchni drukarki, należy najpierw wyjąć przewód zasilający z gniazdka elektrycznego, a następnie odłączyć wszystkie kable prowadzące do urządzenia. Czynność tę należy wykonywać raz na kilka miesięcy. Uszkodzenia drukarki spowodowane niewłaściwą obsługą nie podlegają gwarancji. Wyłącz drukarkę, a następnie wyjmij przewód zasilający z gniazdka elektrycznego. Wyjmij papier z odbiornika standardowego. Przy pomocy miękkiej szczoteczki lub odkurzacza usuń kurz i kawałki papieru znajdujące się dookoła drukarki. Przetrzyj zewnętrzne powierzchnie drukarki za pomocą wilgotnej, miękkiej, niestrzępiącej się szmatki. Nie należy używać środków czyszczących ani detergentów stosowanych w gospodarstwie domowym, gdyż mogą one uszkodzić wykończenie drukarki. Upewnij się, że po czyszczeniu wszystkie powierzchnie drukarki są suche. Podłącz przewód zasilający do gniazdka elektrycznego, a następnie włącz drukarkę. Aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach, znajdującego się w pobliżu urządzenia. czyszczenie drukarki drukarka, elementy czyszczenie"},{"UUID":"94ddc72a-e60a-4733-a89d-998359e62e68","title":"Czyszczenie części drukarki","link":"cleaning-printer-topic.html","desc":"Czyszczenie skanera Otwórz pokrywę skanera.","descFull":"Czyszczenie skanera Otwórz pokrywę skanera. Za pomocą miękkiej, wilgotnej, niestrzępiącej się szmatki przetrzyj następujące miejsca: szyba podajnika ADF podkładka szyby podajnika ADF szyba skanera podkładka szyby skanera Zamknij pokrywę skanera. skaner czyszczenie czyszczenie skanera"},{"UUID":"72199eed-bd1f-4db9-a762-5e40ee7f8572","title":"Czyszczenie części drukarki","link":"cleaning-printer-topic.html","desc":"Czyszczenie ekranu dotykowego Aby uniknąć","descFull":"Czyszczenie ekranu dotykowego Aby uniknąć porażenia prądem elektrycznym podczas czyszczenia zewnętrznej powierzchni drukarki, należy najpierw wyjąć przewód zasilający z gniazdka elektrycznego, a następnie odłączyć wszystkie kable prowadzące do urządzenia. Wyłącz drukarkę, a następnie wyjmij przewód zasilający z gniazdka elektrycznego. Zwilż miękką, niestrzępiąca się szmatkę i przetrzyj nią ekran dotykowy. Nie należy używać środków czyszczących ani detergentów stosowanych w gospodarstwie domowym, gdyż mogą one uszkodzić ekran dotykowy. Po wyczyszczeniu ekranu dotykowego upewnij się, że jest on suchy. Podłącz przewód zasilający do gniazdka elektrycznego, a następnie włącz drukarkę. aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach, znajdującego się w pobliżu urządzenia. ekran dotykowy czyszczenie czyszczenie ekranu dotykowego"},{"UUID":"2c084933-3d74-4dc8-ae25-37810d6f147b","title":"Oszczędzanie energii i papieru","link":"configuring-power-save-mode-settings-topic.html","desc":"Konfigurowanie ustawień trybu oszczędzania energii","descFull":"Konfigurowanie ustawień trybu oszczędzania energii tryb czuwania Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Zarządzanie energią Limity czasu oczekiwania Tryb czuwania W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Określ czas bezczynności, po upływie którego drukarka przechodzi w Tryb czuwania. trybu hibernacji Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Zarządzanie energią Limity czasu oczekiwania Limit czasu hibernacji W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wybierz ilość czasu, po którym drukarka przechodzi w Tryb hibernacji. Przed wysłaniem zadania drukowania należy upewnić się, że drukarka nie działa już w trybie hibernacji. Aby wybudzić drukarkę z trybu hibernacji, naciśnij przycisk zasilania. Gdy drukarka działa w trybie Hibernacja, wbudowany serwer WWW jest wyłączony. Tryb ekologiczny ustawianie tryb czuwania ustawianie trybu hibernacji ustawianie ustawienia środowiskowe tryby funkcji oszczędzania energii ustawianie"},{"UUID":"78b64c27-9409-4cc3-baeb-6f7927b6959e","title":"Oszczędzanie energii i papieru","link":"configuring-power-save-mode-settings-topic.html","desc":"Regulacja jasności wyświetlacza To ustawienie","descFull":"Regulacja jasności wyświetlacza To ustawienie dostępne jest wyłącznie w wybranych modelach drukarek. Na ekranie głównym dotknij kolejno opcji  Ustawienia Urządzenie Preferencje . W menu  Jasność ekranu  dostosuj ustawienie. regulacja jasności wyświetlacz drukarki jasność wyświetlacza dostosowywanie"},{"UUID":"1ea11fa2-e151-4e9f-9444-7c0a7ff3830b","title":"Oszczędzanie energii i papieru","link":"configuring-power-save-mode-settings-topic.html","desc":"Zmniejszanie zużycia materiałów eksploatacyjnych Drukowanie","descFull":"Zmniejszanie zużycia materiałów eksploatacyjnych Drukowanie dwustronne. Domyślnym ustawieniem sterownika drukarki jest druk dwustronny. Drukowanie wielu stron na jednej stronie arkusza papieru. Korzystanie z funkcji podglądu, aby zobaczyć dokument przed jego wydrukowaniem. Wydrukuj jeden egzemplarz dokumentu, aby sprawdzić poprawność jego zawartości i formatu. zmniejszanie zużycia materiałów eksploatacyjnych materiały eksploatacyjne zmniejszanie zużycia"},{"UUID":"2538734f-3d09-41dc-a5fa-f6e5d6850f01","title":"Konserwacja drukarki","link":"moving-printer-topic.html","desc":"Przenoszenie drukarki w inne miejsce","descFull":"Przenoszenie drukarki w inne miejsce Przenoszenie drukarki w inne miejsce jeśli waga drukarki jest większa niż 20 kg (44 funty), do bezpiecznego przeniesienia potrzeba co najmniej dwóch osób. w celu uniknięcia ryzyka pożaru lub porażenia prądem należy korzystać wyłącznie z przewodu zasilającego dołączonego do tego produktu lub z części zamiennych autoryzowanych przez producenta. zastosowanie się do poniższych wskazówek pozwoli uniknąć obrażeń ciała oraz uszkodzenia drukarki podczas jej przenoszenia: Upewnij się, że wszystkie drzwiczki i tace są zamknięte. Wyłącz drukarkę, a następnie wyjmij przewód zasilający z gniazdka elektrycznego. Odłącz wszystkie przewody i kable. Jeżeli do drukarki są podłączone oddzielne, opcjonalne tace podłogowe lub opcje wyjściowe, odłącz je przed przeniesieniem drukarki. Jeśli drukarka jest wyposażona w podstawę na kółkach, przesuń drukarkę ostrożnie na nowe miejsce. Zachowaj ostrożność przy przechodzeniu przez progi i uważaj na przerwy w podłodze. Jeżeli drukarka nie jest wyposażona w podstawę na kółkach, ale jest skonfigurowana do obsługi opcjonalnych tac lub opcji wyjściowych, odłącz opcje wyjściowe i podnieś drukarkę z tac. Drukarki ani wyposażenia opcjonalnego nie wolno podnosić jednocześnie. Przy podnoszeniu drukarki zawsze używaj uchwytów. Jeśli drukarka jest przewożona na wózku, musi on mieć na tyle dużą powierzchnię, aby mieściła się na nim cała podstawa drukarki. Jeśli wyposażenie opcjonalne jest przewożone na wózku, musi on mieć na tyle dużą powierzchnię, aby w pełni mieściły się na nim opcjonalne elementy wyposażenia. Drukarka musi pozostawać w pozycji pionowej. Unikaj gwałtownych wstrząsów. Podczas ustawiania drukarki zachowaj ostrożność, aby nie przycisnąć sobie palców. Upewnij się, że wokół drukarki jest wystarczająco dużo wolnego miejsca. uszkodzenie drukarki spowodowane jej nieprawidłowym przenoszeniem nie jest objęte gwarancją. przenoszenie drukarki"},{"UUID":"1ffd99b8-8bf5-48cd-b1ea-d75a7bf4d58b","title":"Konserwacja drukarki","link":"shipping-printer-topic.html","desc":"Transport drukarki Instrukcje wysyłania drukarki","descFull":"Transport drukarki Instrukcje wysyłania drukarki można uzyskać na stronie  http://support.lexmark.com  lub w pomocy technicznej. Na czas transportu należy umieścić drukarkę w oryginalnym opakowaniu lub skontaktować się z punktem zakupu drukarki. drukarka transport transport drukarki"},{"UUID":"906be3c8-6b95-4621-a07f-6f98405d3de2","title":"Rozwiązywanie problemu","link":"print-quality-problems-topic.html","desc":"Problemy z jakością wydruku Wybierz","descFull":"Problemy z jakością wydruku Wybierz obraz, który najlepiej oddaje Twoje problemy z drukowaniem, a następnie kliknij odnośnik znajdujący się pod nim, aby poznać rozwiązanie. problemy z jakością druku rozwiązywanie problemów problemy z jakością druku jakość druku, rozwiązywanie problemów problemy z jakością druku"},{"UUID":"e1053485-43ae-4e6a-b00c-81a100febd59","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Puste lub białe strony Przed","descFull":"Puste lub białe strony Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy drukarka drukuje puste lub białe strony? Problem został rozwiązany. Wyjmij zestaw obrazujący. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Sprawdź zespół obrazujący pod kątem oznak uszkodzenia. Sprawdź, czy połączenie bębna fotoprzewodnika znajduje się na właściwym miejscu i czy nie jest wygięte. Mocno potrząśnij modułem obrazującym, aby rozprowadzić toner. Włóż zestaw obrazujący. Wydrukuj dokument. Czy drukarka drukuje puste lub białe strony? Problem został rozwiązany. Wymień kasetę z tonerem. Czy drukarka drukuje puste lub białe strony? Problem został rozwiązany. Wymień zestaw obrazujący. Czy drukarka drukuje puste lub białe strony? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. rozwiązywanie problemów, jakość wydruku puste lub białe strony jakość wydruku, rozwiązywanie problemów puste lub białe strony puste strony białe strony"},{"UUID":"19d180ab-b86d-4371-bafb-c61c7a3638da","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Zbyt ciemny wydruk Przed rozwiązaniem","descFull":"Zbyt ciemny wydruk Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. Wyłącz drukarkę, odczekaj około 10 sekund, a następnie włącz drukarkę. Zmniejsz ustawienie intensywności tonera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukowanie Jakość Intensywność tonera Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. Sprawdź, czy papier jest szorstki lub ma fakturę. Czy drukujesz na szorstkim papierze lub papierze z fakturą? Przejdź do punktu 6. Wymień papier z fakturą na papier zwykły. Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. Załaduj papier z nowego opakowania. Papier wchłonął wilgoć z powodu wysokiej wilgotności powietrza. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy wydruk jest ciemny? Problem został rozwiązany. Wymień zestaw obrazujący. Wydrukuj dokument. Czy wydruk jest ciemny? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. zbyt ciemny wydruk rozwiązywanie problemów, jakość druku zbyt ciemny wydruk jakość druku, rozwiązywanie problemów zbyt ciemny wydruk"},{"UUID":"1eb502e8-40e5-4f53-ab49-79702658f2c2","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Cienkie linie są drukowane nieprawidłowo","descFull":"Cienkie linie są drukowane nieprawidłowo Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy cienkie linie są drukowane nieprawidłowo? Problem został rozwiązany. Zwiększ intensywności tonera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukowanie Jakość Intensywność tonera Wydrukuj dokument. Czy cienkie linie są drukowane nieprawidłowo? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość druku cienkie linie są drukowane nieprawidłowo jakość druku, rozwiązywanie problemów cienkie linie są drukowane nieprawidłowo cienkie linie są drukowane nieprawidłowo"},{"UUID":"225eac18-dbf8-4c4f-be65-a372efb90c88","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Zagięty lub pomarszczony papier Przed","descFull":"Zagięty lub pomarszczony papier Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy papier jest zagięty lub pomarszczony? Problem został rozwiązany. Załaduj papier z nowego opakowania. Papier wchłonął wilgoć z powodu wysokiej wilgotności powietrza. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Wydrukuj dokument. Czy papier jest zagięty lub pomarszczony? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy papier jest zagięty lub pomarszczony? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość druku zagięty lub pomarszczony papier jakość druku, rozwiązywanie problemów zagięty lub pomarszczony papier zagięty papier pomarszczony papier"},{"UUID":"06705804-817b-4caa-a39b-96b684d43cdb","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Szare tło Przed rozwiązaniem tego","descFull":"Szare tło Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Wyłącz drukarkę, odczekaj 10 sekund, a następnie włącz drukarkę. Zmniejsz intensywności tonera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukowanie Jakość Intensywność tonera Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Problem został rozwiązany. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Problem został rozwiązany. Aktualizowanie oprogramowania sprzętowego drukarki. Więcej informacji można znaleźć w sekcji  . Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Problem został rozwiązany. Wymień zestaw obrazujący. Wydrukuj dokument. Czy na wydrukach pojawia się szare tło? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. szare tło na wydrukach rozwiązywanie problemów, jakość wydruku szare tło na wydrukach jakość wydruku, rozwiązywanie problemów szare tło na wydrukach"},{"UUID":"d33b25c9-5b2b-4746-a03e-e53dca56789e","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Nieprawidłowe marginesy Kroki prowadzące do","descFull":"Nieprawidłowe marginesy Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Ustaw prowadnice papieru zgodnie z załadowanym papierem. Wydrukuj dokument. Czy marginesy są prawidłowe? Problem został rozwiązany. Ustaw rozmiar papieru. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru Wydrukuj dokument. Czy marginesy są prawidłowe? Problem został rozwiązany. W zależności od używanego systemu operacyjnego rozmiar papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Wydrukuj dokument. Czy marginesy są prawidłowe? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . nieprawidłowe marginesy drukowanie, rozwiązywanie problemów nieprawidłowe marginesy rozwiązywanie problemów, drukowanie nieprawidłowe marginesy"},{"UUID":"9765d5f7-348d-4e46-9e1c-61b3d58961f0","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Jasny wydruk Przed rozwiązaniem tego","descFull":"Jasny wydruk Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy wydruk jest jasny? Problem został rozwiązany. Wyłącz drukarkę, odczekaj około 10 sekund, a następnie włącz drukarkę. Zwiększ intensywności tonera. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukowanie Jakość Intensywność tonera Wydrukuj dokument. Czy wydruk jest jasny? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy wydruk jest jasny? Problem został rozwiązany. W zależności od używanego systemu operacyjnego rozdzielczość wydruku można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Ustaw rozdzielczość na  600 dpi . Wydrukuj dokument. Czy wydruk jest jasny? Problem został rozwiązany. Wyjmij zestaw obrazujący. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Mocno potrząśnij modułem obrazującym, aby rozprowadzić toner. Włóż zestaw obrazujący. Wyłącz drukarkę, odczekaj 10 sekund, a następnie włącz drukarkę. Wydrukuj dokument. Czy wydruk jest jasny? Problem został rozwiązany. Sprawdź stan kasety z tonerem. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Urządzenie Statystyki urządzenia Sprawdź stan kasety z tonerem w sekcji Informacje o materiałach eksploatacyjnych na wydrukowanych stronach. Czy kaseta z tonerem jest bliska zużycia? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Wymień kasetę z tonerem. Wydrukuj dokument. Czy wydruk jest jasny? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. jasny wydruk rozwiązywanie problemów, jakość wydruku jasny wydruk jakość wydruku, rozwiązywanie problemów jasny wydruk"},{"UUID":"8f8205dd-ddfc-48b8-8280-3f1598cb6b1c","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Cętkowany wydruk i plamki Przed","descFull":"Cętkowany wydruk i plamki Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy wydruk jest cętkowany? Problem został rozwiązany. Sprawdź drukarkę pod kątem zanieczyszczenia wyciekłym tonerem. Czy drukarka jest wolna od wyciekłego toneru? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Sprawdź stan modułu obrazującego. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Urządzenie Statystyki urządzenia Sprawdź stan części i materiałów eksploatacyjnych w sekcji  Informacje o materiałach eksploatacyjnych  na wydrukowanych stronach. Czy moduł obrazujący jest bliski zużycia? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Wymień zestaw obrazujący. Wydrukuj dokument. Czy wydruk jest cętkowany? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość druku cętkowany wydruk i plamki jakość druku, rozwiązywanie problemów cętkowany wydruk i plamki cętkowany wydruk plamki na wydruku"},{"UUID":"cfb165cd-ba0b-435a-9a55-7829c0de961e","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Zwijanie się papieru Kroki prowadzące","descFull":"Zwijanie się papieru Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że załadowany papier jest obsługiwany. Jeżeli załadowany papier nie jest obsługiwany, załaduj obsługiwany papier. Wydrukuj dokument. Czy papier jest zwinięty? Problem został rozwiązany. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy papier jest zwinięty? Problem został rozwiązany. Ustaw prowadnice w zasobniku w prawidłowej pozycji dla załadowanego papieru. Wydrukuj dokument. Czy papier jest zwinięty? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ i rozmiar papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawiony typ papieru jest taki sam jak typ załadowanego papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wydrukuj dokument. Czy papier jest zwinięty? Problem został rozwiązany. Wyjmij papier, obróć go i włóż ponownie. Wydrukuj dokument. Czy papier jest zwinięty? Problem został rozwiązany. Załaduj papier z nowego opakowania. Papier wchłonął wilgoć z powodu wysokiej wilgotności powietrza. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Wydrukuj dokument. Czy papier jest zwinięty? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. zwijanie się papieru rozwiązywanie problemów z jakością druku zwijanie się papieru jakość druku, rozwiązywanie problemów zwijanie się papieru"},{"UUID":"49ddf6b7-bbdb-4c17-976d-f24e2401f986","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Zniekształcone lub przekrzywione wydruki Przed","descFull":"Zniekształcone lub przekrzywione wydruki Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Ustaw prowadnice w zasobniku w prawidłowej pozycji dla załadowanego papieru. Wydrukuj dokument. Czy wydruki są zniekształcone lub przekrzywione? Problem został rozwiązany. Załaduj papier z nowego opakowania. Papier wchłonął wilgoć z powodu wysokiej wilgotności powietrza. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Wydrukuj dokument. Czy wydruki są zniekształcone lub przekrzywione? Problem został rozwiązany. Upewnij się, że załadowany papier jest obsługiwany. Jeżeli załadowany papier nie jest obsługiwany, załaduj obsługiwany papier. Wydrukuj dokument. Czy wydruki są zniekształcone lub przekrzywione? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. W przypadku drukowania dwustronnego należy sprawdzić, czy rozmiar papieru w module druku dwustronnego jest prawidłowo ustawiony. Ustawienie Letter, Legal, Oficio lub Folio musi być ustawione na wartość Letter. Wydrukuj dokument. Czy wydruki są zniekształcone lub przekrzywione? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. rozwiązywanie problemów, jakość wydruku krzywy wydruk jakość wydruku, rozwiązywanie problemów krzywy wydruk rozwiązywanie problemów, jakość wydruku zniekształcony wydruk jakość wydruku, rozwiązywanie problemów zniekształcony wydruk zniekształcony wydruk krzywy wydruk"},{"UUID":"782b01e2-9a29-4c0f-b027-6f4054a0361f","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Strony jednolicie czarne Przed rozwiązaniem","descFull":"Strony jednolicie czarne Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy drukarka drukuje strony jednolicie czarne? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy drukarka drukuje strony jednolicie czarne? Problem został rozwiązany. Sprawdź zespół obrazujący pod kątem oznak uszkodzenia. Sprawdź, czy połączenie bębna fotoprzewodnika znajduje się na właściwym miejscu i czy nie jest wygięte. Czy zespół obrazujący jest wolny od uszkodzeń? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Wymień zestaw obrazujący. Wydrukuj dokument. Czy drukarka drukuje strony jednolicie czarne? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. strony jednolicie czarne rozwiązywanie problemów, jakość druku strony jednolicie czarne jakość druku, rozwiązywanie problemów strony jednolicie czarne"},{"UUID":"f87d1a7b-e221-4e43-94a9-a6dc533c04fe","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Obcięty tekst lub obraz Przed","descFull":"Obcięty tekst lub obraz Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy tekst lub obraz są obcięte? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy tekst lub obraz są obcięte? Problem został rozwiązany. Wymień zestaw obrazujący. Wydrukuj dokument. Czy tekst lub obraz są obcięte? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość druku obcięty tekst lub obraz jakość druku, rozwiązywanie problemów obcięty tekst lub obraz odcięty obraz obcięty tekst obcięte teksty odcięte obrazy"},{"UUID":"c8ef375a-0100-4166-8796-984cecf3d61f","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Toner łatwo się ściera Przed","descFull":"Toner łatwo się ściera Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy toner łatwo się ściera? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy toner łatwo się ściera? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. toner łatwo się ściera rozwiązywanie problemów, jakość druku toner łatwo się ściera jakość druku, rozwiązywanie problemów toner łatwo się ściera"},{"UUID":"8cac9a6c-96f2-49d7-86c1-e21f48c0da40","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Poziome jasne pasy Przed rozwiązaniem","descFull":"Poziome jasne pasy Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawiają się jasne poziome pasy? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy na wydrukach pojawiają się jasne poziome pasy? Problem został rozwiązany. Wymień zestaw obrazujący. Wydrukuj dokument. Czy na wydrukach pojawiają się jasne poziome pasy? Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość wydruku poziome jasne pasy jakość wydruku, rozwiązywanie problemów poziome jasne pasy poziome jasne pasy"},{"UUID":"3d7e1b64-6c4c-40e1-a035-0089999cf714","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Pionowe jasne pasy Przed rozwiązaniem","descFull":"Pionowe jasne pasy Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawiają się pionowe jasne pasy? Problem został rozwiązany. Sprawdź stan kasety z tonerem. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Urządzenie Statystyki urządzenia Sprawdź stan kasety z tonerem w sekcji Informacje o materiałach eksploatacyjnych na wydrukowanych stronach. Czy na wydrukach pojawiają się pionowe jasne pasy? Problem został rozwiązany. Wymień kasetę z tonerem. Wydrukuj dokument. Czy na wydrukach pojawiają się pionowe jasne pasy? Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, jakość wydruku pionowe jasne pasy jakość wydruku, rozwiązywanie problemów pionowe jasne pasy pionowe jasne pasy"},{"UUID":"1f9408a4-b3b3-48f5-885a-df3847d5d060","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Pionowe białe linie Przed rozwiązaniem","descFull":"Pionowe białe linie Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawiają się białe pionowe linie? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . Wydrukuj dokument. Czy na wydrukach pojawiają się białe pionowe linie? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. pionowe białe linie rozwiązywanie problemów, jakość druku pionowe białe linie jakość druku, rozwiązywanie problemów pionowe białe linie białe linie"},{"UUID":"31db9c5d-fb7d-47dd-9aed-f9f40efd8f92","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Pionowe ciemne pasy Przed rozwiązaniem","descFull":"Pionowe ciemne pasy Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawiają się pionowe ciemne pasy? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy na wydrukach pojawiają się pionowe ciemne pasy? Problem został rozwiązany. Sprawdź, czy jasne światło nie pada na prawą stronę drukarki. W razie potrzeby przenieś drukarkę w inne miejsce. Wydrukuj dokument. Czy na wydrukach pojawiają się pionowe ciemne pasy? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. pionowe ciemne pasy rozwiązywanie problemów, jakość druku pionowe ciemne pasy jakość druku, rozwiązywanie problemów pionowe ciemne pasy"},{"UUID":"db24099a-a160-46e2-b17c-1e8161343791","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Ciemne pionowe linie lub smugi","descFull":"Ciemne pionowe linie lub smugi Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości wydruku . W drukarkach bez ekranu dotykowego naciśnij przycisk   , aby poruszać się po ustawieniach. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy drukarka korzysta z oryginalnej kasety z tonerem obsługiwanej przez urządzenia firmy Lexmark. Sprawdź, czy drukarka korzysta z oryginalnej kasety z tonerem, odpowiedniej dla danego urządzenia. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach pojawiają się ciemne pionowe linie lub smugi? Problem został rozwiązany. Wyjmij zespół obrazujący, a następnie zainstaluj go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod modułem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy na wydrukach pojawiają się ciemne pionowe linie lub smugi? Problem został rozwiązany. Wymień moduł obrazujący. Wydrukuj dokument. Czy na wydrukach pojawiają się ciemne pionowe linie lub smugi? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomoc techniczna . Problem został rozwiązany. rozwiązywanie problemów z jakością druku ciemne pionowe linie lub smugi jakość druku, rozwiązywanie problemów ciemne pionowe linie lub smugi ciemne pionowe linie na wydrukach pionowe smugi na wydrukach"},{"UUID":"7da89847-88b1-4484-869c-9525876a4d77","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Ciemne pionowe smugi i brakujące","descFull":"Ciemne pionowe smugi i brakujące elementy wydruku Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Wyjmij zespół obrazujący, a następnie włóż go ponownie. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie dotykaj bębna fotoprzewodnika pod zestawem obrazującym. Może to wpłynąć na jakość kolejnych zadań drukowania. Wydrukuj dokument. Czy na wydrukach brakuje niektórych elementów i pojawiają się na nich ciemne pionowe smugi? Problem został rozwiązany. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem firmy Lexmark. Sprawdź, czy w drukarce jest używana oryginalna i obsługiwana kaseta z tonerem. Jeżeli dana kaseta z tonerem nie jest obsługiwana, zainstaluj obsługiwaną kasetę. Wydrukuj dokument. Czy na wydrukach brakuje niektórych elementów i pojawiają się na nich ciemne pionowe smugi? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. ciemne pionowe smugi brakujący druk rozwiązywanie problemów, jakość druku ciemne pionowe smugi i brakujące elementy wydruku jakość druku, rozwiązywanie problemów ciemne pionowe smugi i brakujące elementy wydruku"},{"UUID":"f8bb8bd1-8c34-4394-a7a1-84c0196a57f6","title":"Jakość druku jest niska","link":"print-quality-is-poor-subgroup.html","desc":"Powtarzające się błędy wydruku Przed","descFull":"Powtarzające się błędy wydruku Przed rozwiązaniem tego problemu wydrukuj strony testu jakości wydruku. Na panelu sterowania przejdź do menu  Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Korzystając ze stron testu jakości wydruku, sprawdź czy odległość między powtarzającymi się defektami na stronie jest równa jednej z poniższych: Zestaw obrazujący 75,40 mm (2,97 cala) 34,70 mm (1,37 cala) 23,9 mm (0,94 cala) Kaseta z tonerem 35,70 mm (1,41 cala) 36,80 mm (1,45 cala) Wałek przenoszący 44 mm (1,73 cala) Nagrzewnica 78,1 mm (3,07 cala) 75,4 mm (2,97 cala) Czy odległość między powtarzającymi się defektami na stronie jest równa jednej z wymienionych wartości? Zapisz odległość, a następnie skontaktuj się z  wsparcie klienta . Zapisz odległość, a następnie skontaktuj się z  pomocą techniczną . Wymień materiał eksploatacyjny, który odpowiada odległości między powtarzającymi się defektami. Jeśli materiał eksploatacyjny to wałek przenoszący lub nagrzewnica, skontaktuj się ze  Wsparciem klienta . Jeśli materiał eksploatacyjny to wałek przenoszący lub nagrzewnica, skontaktuj się ze  Wsparciem technicznym . Wydrukuj dokument. Czy na wydruku pojawiają się powtarzające się defekty? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. jakość wydruku, rozwiązywanie problemów powtarzające się błędy wydruku rozwiązywanie problemów, jakość wydruku powtarzające się błędy wydruku powtarzające się defekty na wydrukach"},{"UUID":"7becce8f-9cba-435c-ab6a-e339d6f70e54","title":"Problemy z drukowaniem","link":"print-quality-is-poor-subgroup.html","desc":"Zadania drukowania nie są drukowane","descFull":"Zadania drukowania nie są drukowane Kroki prowadzące do rozwiązania problemu Działanie Tak Nie W dokumencie, który próbujesz wydrukować, otwórz okno dialogowe Drukuj i sprawdź, czy została wybrana odpowiednia drukarka. Wydrukuj dokument. Czy dokument został wydrukowany? Problem został rozwiązany. Upewnij się, że drukarka jest włączona. Rozwiąż wszelkie problemy zgłaszane w komunikatach o błędach pojawiających się na wyświetlaczu. Wydrukuj dokument. Czy dokument został wydrukowany? Problem został rozwiązany. Sprawdź, czy porty działają oraz czy kable są prawidłowo podłączone do komputera i drukarki. Więcej informacji na ten temat można znaleźć w dokumentacji instalacyjnej dostarczonej z drukarką. Wydrukuj dokument. Czy dokument został wydrukowany? Problem został rozwiązany. Wyłącz drukarkę, odczekaj około 10 sekund, a następnie włącz drukarkę. Wydrukuj dokument. Czy dokument został wydrukowany? Problem został rozwiązany. Odinstaluj, a następnie ponownie zainstaluj sterownik drukarki. Wydrukuj dokument. Czy dokument został wydrukowany? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . rozwiązywanie problemów, drukowanie zadania drukowania nie są drukowane drukowanie, rozwiązywanie problemów zadania drukowania nie są drukowane zadania drukowania nie są drukowane"},{"UUID":"7b7c5bdf-f753-4b7f-9fb7-684a760063de","title":"Problemy z drukowaniem","link":"print-quality-is-poor-subgroup.html","desc":"Nie można drukować poufnych dokumentów","descFull":"Nie można drukować poufnych dokumentów i innych wstrzymanych dokumentów Kroki prowadzące do rozwiązania problemu Działanie Tak Nie W panelu sterowania sprawdź, czy dokumenty widoczne są na liście  Wstrzymane zadania . Jeśli dokumenty nie są wyświetlane, wydrukuj je, korzystając z opcji Drukowanie ze wstrzymaniem. Wydrukuj dokumenty. Czy dokumenty zostały wydrukowane? Problem został rozwiązany. Zadanie drukowania może zawierać błąd formatowania lub nieprawidłowe dane. Usuń zadanie drukowania, a następnie wyślij je ponownie. Czy dokumenty zostały wydrukowane? Problem został rozwiązany. W przypadku drukowania z Internetu drukarka może interpretować nazwy zadań jako duplikaty. Użytkownicy systemu Windows Otwórz okno dialogowe Preferencje drukowania. Z zakładki Drukuj i Zatrzymaj, kliknij  Użyj drukowania z zatrzymaniem , a następnie kliknij  Zachowaj powielone dokumenty . Wprowadź kod PIN i zapisz zmiany. Wyślij zadanie drukowania. Użytkownicy komputerów Macintosh Zapisz i nadaj unikalną nazwę każdemu zadaniu. Wyślij zadania pojedynczo. Czy dokumenty zostały wydrukowane? Problem został rozwiązany. Usuń niektóre wstrzymane zadania, aby zwolnić pamięć drukarki. Wydrukuj dokumenty. Czy dokumenty zostały wydrukowane? Problem został rozwiązany. Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . rozwiązywanie problemów, drukowanie nie można drukować poufnych dokumentów i innych wstrzymanych dokumentów rozwiązywanie problemów z drukowaniem nie można drukować poufnych dokumentów i innych wstrzymanych dokumentów dokumenty poufne nie są drukowane wstrzymane dokumenty nie są drukowane"},{"UUID":"838012e9-2ce2-4eb5-ab09-028242bbf8b9","title":"Problemy z drukowaniem","link":"print-quality-is-poor-subgroup.html","desc":"Wydruk zadania wykonywany jest na papierze","descFull":"Wydruk zadania wykonywany jest na papierze pochodzącym z niewłaściwego zasobnika lub na niewłaściwym papierze Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy drukujesz na właściwym papierze. Wydrukuj dokument. Czy dokument jest drukowany na właściwym papierze? Włóż papier prawidłowego typu i rozmiaru. W zależności od używanego systemu operacyjnego typ i rozmiar papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Możesz także zmienić te ustawienia za pomocą panelu sterowania drukarki. Przejdź do opcji: Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Sprawdź, czy ustawiony typ papieru jest taki sam jak typ załadowanego papieru. Wydrukuj dokument. Czy dokument jest drukowany na właściwym papierze? Problem został rozwiązany. Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . rozwiązywanie problemów z drukowaniem wydruk zadania z niewłaściwej tacy rozwiązywanie problemów z drukowaniem wydruk zadania na niewłaściwym papierze rozwiązywanie problemów, drukowanie wydruk zadania z niewłaściwej tacy rozwiązywanie problemów, drukowanie wydruk zadania na niewłaściwym papierze wydruk zadania na niewłaściwym papierze wydruk zadania z niewłaściwej tacy"},{"UUID":"4ef816ac-02b2-447f-ba1a-dc5384946106","title":"Problemy z drukowaniem","link":"print-quality-is-poor-subgroup.html","desc":"Powolne drukowanie Kroki prowadzące do","descFull":"Powolne drukowanie Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że kabel drukarki jest prawidłowo podłączony do drukarki i komputera, serwera druku lub innego urządzenia sieciowego. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. Upewnij się, że drukarka nie pracuje w Trybie cichym. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Konserwacja Menu konfiguracji Działanie urządzenia Tryb cichy W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. W zależności od używanego systemu operacyjnego rozdzielczość wydruku można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Ustaw rozdzielczość na  600 dpi . Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Druk Jakość Rozdzielczość wydruku W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Ustaw rozdzielczość na  600 dpi . Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. W zależności od używanego systemu operacyjnego typ papieru można ustawić za pomocą okna dialogowego Preferencje drukowania lub Drukowanie. Sprawdź, czy ustawienie jest zgodne z załadowanym typem papieru. Możesz także zmienić to ustawienie za pomocą panelu sterowania drukarki. Przejdź kolejno do  Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru . W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Drukowanie na papierze o większej gramaturze trwa dłużej. Drukowanie na papierze węższym niż papier w formacie Letter, A4 i Legal może trwać dłużej. Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. Upewnij się, że ustawienia drukarki dla tekstury i gramatury pasują do rodzaju załadowanego papieru. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja nośnika Typy nośników W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Drukowanie na papierze o szorstkiej teksturze i na papierze o dużej gramaturze może trwać dłużej. Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. Usuń wstrzymane zadania. Czy drukarka drukuje zbyt wolno? Problem został rozwiązany. Upewnij się, że drukarka się nie przegrzewa. Pozwól drukarce trochę ostygnąć po każdym długim zadaniu drukowania. Sprawdź temperaturę otoczenia zalecaną dla drukarki. Więcej informacji można znaleźć w sekcji  . Wydrukuj dokument. Czy drukarka drukuje zbyt wolno? Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. powolne drukowanie rozwiązywanie problemów z drukowaniem powolne drukowanie rozwiązywanie problemów, drukowanie powolne drukowanie"},{"UUID":"2f8404b6-a87a-4933-bc3a-b1f0d065568d","title":"Rozwiązywanie problemu","link":"trb-printer-not-responding-topic.html","desc":"Drukarka nie odpowiada Kroki prowadzące","descFull":"Drukarka nie odpowiada Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy kabel zasilający drukarki jest podłączony do gniazdka eklektycznego. Aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach znajdującego się w pobliżu urządzenia. Czy drukarka odpowiada? Problem został rozwiązany. Czy gniazdo elektryczne jest wyłączone za pomocą wyłącznika albo bezpiecznika? Czy gniazdo elektryczne jest wyłączone za pomocą wyłącznika albo bezpiecznika? Włącz zasilanie wyłącznikiem lub zresetuj bezpiecznik. Upewnij się, że drukarka jest włączona. Czy drukarka jest włączona? Włącz drukarkę. Sprawdź, czy drukarka działa w trybie czuwania lub hibernacji. Czy drukarka działa w trybie czuwania lub hibernacji? Naciśnij przycisk zasilania, aby wybudzić drukarkę. Sprawdź, czy kable łączące drukarkę i komputer są włożone do właściwych portów. Czy kable są włożone do właściwych portów? Podłącz kable do właściwych portów. Zainstaluj odpowiedni sterownik drukarki. Czy drukarka odpowiada? Problem został rozwiązany. Wyłącz drukarkę, odczekaj około 10 sekund, a następnie włącz drukarkę. Czy drukarka odpowiada? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . rozwiązywanie problemów drukarka nie odpowiada drukarka nie odpowiada"},{"UUID":"9fc5d3f0-a85f-4596-b0e1-582990ccd68e","title":"Rozwiązywanie problemu","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Nie można odczytać napędu flash","descFull":"Nie można odczytać napędu flash Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy drukarka nie jest zajęta przetwarzaniem innego zadania drukowania, kopiowania, skanowania lub faksowania. Czy drukarka jest gotowa? Zaczekaj, aż drukarka zakończy przetwarzanie innego zadania. Upewnij się, że napęd flash jest obsługiwany. Więcej informacji można znaleźć w sekcji  . Czy napęd flash jest obsługiwany? Włóż obsługiwany napęd flash. Wyjmij napęd flash i włóż go ponownie. Czy drukarka rozpoznaje napęd flash? Problem został rozwiązany. Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . nie można odczytać napędu flash rozwiązywanie problemów, drukowanie rozwiązywanie problemów z drukowaniem nie można odczytać napędu flash"},{"UUID":"22400244-4596-4cfb-8603-bf8996bed268","title":"Rozwiązywanie problemu","link":"enabling-usb-port-topic.html","desc":"Włączanie portu USB Przy użyciu","descFull":"Włączanie portu USB Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/Porty USB Włącz port USB W drukarkach bez ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Port USB włączanie włączanie portu USB"},{"UUID":"14a42c21-d3c9-4789-8e36-48ffe748fdf9","title":"Problemy z połączeniem sieciowym","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nie można uzyskać połączenia z","descFull":"Nie można uzyskać połączenia z wbudowanym serwerem WWW Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że drukarka jest włączona. Czy drukarka jest włączona? Włącz drukarkę. Upewnij się, że adres IP drukarki jest poprawny. Wyświetl adres IP na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami, na przykład 123.123.123.123. Czy adres IP drukarki jest prawidłowy? W pasku adresu należy wpisać prawidłowy adres IP drukarki sieciowej. Sprawdź, czy korzystasz z obsługiwanej przeglądarki: Internet Explorer w wersji 11 lub nowszej Microsoft Edge Safari w wersji 6 lub nowszej Google Chrome  w wersji 32 lub nowszej Mozilla Firefox w wersji 24 lub nowszej Czy wykorzystywana przeglądarka jest obsługiwana? Zainstaluj obsługiwaną przeglądarkę. Sprawdź, czy połączenie sieciowe działa. Czy połączenie sieciowe działa? Skontaktuj się ze swoim administratorem. Sprawdź podłączenie kabli do drukarki i do serwera druku, aby upewnić się, że są one prawidłowo zamocowane. Więcej informacji na ten temat można znaleźć w dokumentacji dostarczonej z drukarką. Czy kable są podłączone prawidłowo? Sprawdź połączenia kabli. Sprawdź, czy serwery proxy są wyłączone. Czy serwery proxy są wyłączone? Skontaktuj się ze swoim administratorem. Uzyskaj dostęp do wbudowanego serwera WWW. Czy uzyskano dostęp do wbudowanego serwera WWW? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . nie można uzyskać połączenia z wbudowanym serwerem WWW rozwiązywanie problemów nie można uzyskać połączenia z wbudowanym serwerem WWW"},{"UUID":"6bd5dca2-5766-4ac0-8374-c95b9d59d499","title":"Problemy z połączeniem sieciowym","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nie można połączyć drukarki z","descFull":"Nie można połączyć drukarki z siecią Wi-Fi Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy dla funkcji  Aktywny adapter  wybrano wartość  Automatyczne . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Przegląd sieci Aktywny adapter Automatyczne W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Czy można połączyć drukarkę z siecią Wi-Fi? Problem został rozwiązany. Sprawdź, czy wybrano właściwą sieć Wi-Fi. Niektóre routery mogą mieć ten sam domyślny identyfikator SSID. Czy próbujesz połączyć z właściwą siecią Wi-Fi? Przejdź do punktu 4. Połącz z właściwą siecią Wi-Fi. Więcej informacji można znaleźć w sekcji  . Czy można połączyć drukarkę z siecią Wi-Fi? Problem został rozwiązany. Sprawdź tryb zabezpieczeń sieci bezprzewodowej. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Sieć/porty Sieć bezprzewodowa Tryb zabezpieczeń sieci bezprzewodowej W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Czy wybrano prawidłowy tryb zabezpieczeń sieci bezprzewodowej? Przejdź do punktu 6. Wybierz prawidłowy tryb zabezpieczeń sieci bezprzewodowej. Czy można połączyć drukarkę z siecią Wi-Fi? Problem został rozwiązany. Upewnij się, że wprowadzone hasło jest prawidłowe. Zwróć uwagę na spacje, cyfry i wielkie litery w haśle. Czy można połączyć drukarkę z siecią Wi-Fi? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . nie można połączyć drukarki z siecią Wi-Fi rozwiązywanie problemów nie można połączyć drukarki z siecią Wi-Fi"},{"UUID":"d9da3cd8-3d5b-44d2-94bf-2b61ba0320cc","title":"Problemy z materiałami eksploatacyjnymi","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Wymień kasetę, niedopasowanie regionu drukarki","descFull":"Wymień kasetę, niedopasowanie regionu drukarki Aby rozwiązać ten problem, kup kasetę z odpowiednim regionem (odpowiadającym regionowi drukarki) lub kasetę w wersji międzynarodowej. Pierwsza cyfra po wartości „42” w treści komunikatu określa region drukarki. Druga cyfra po wartości „42” w treści komunikatu określa region kasety. Zainstaluj poprawną kasetę z tonerem. Lista regionów drukarek i kaset z tonerem Region Kod numeryczny Wersja międzynarodowa lub niezdefiniowana 0 Ameryka Północna (Stany Zjednoczone, Kanada) 1 Europejski Obszar Gospodarczy, Europa Zachodnia, kraje skandynawskie, Szwajcaria 2 Region Azji i Pacyfiku 3 Ameryka Łacińska 4 Pozostała część Europy, Bliski Wschód i Afryka 5 Australia, Nowa Zelandia 6 Nieprawidłowy region 9 Aby odszukać ustawienia regionu drukarki i kasety z tonerem, wydrukuj strony testu jakości. Przy użyciu panelu sterowania drukarki przejdź do opcji:  Ustawienia Rozwiązywanie problemów Strony testy jakości druku . komunikaty drukarki Wymień kasetę, niedopasowanie regionu drukarki Wymień kasetę, niedopasowanie regionu drukarki"},{"UUID":"7037b4f7-c85c-4148-9079-2eeaebbb2973","title":"Problemy z materiałami eksploatacyjnymi","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Materiały eksploatacyjne producenta innego niż","descFull":"Materiały eksploatacyjne producenta innego niż Lexmark Materiały eksploatacyjne producenta innego niż Dell Materiały eksploatacyjne producenta innego niż producent drukarki System wykrył, że zainstalowano materiał lub część producenta innego niż Lexmark. System wykrył, że zainstalowano materiał lub część producenta innego niż Dell. System drukarki wykrył, że zainstalowano materiał lub część nieznanego producenta. Drukarka Lexmark działa najlepiej z oryginalnymi materiałami i częściami firmy Lexmark. Używanie materiałów i części innych producentów może negatywnie wpłynąć na wydajność, pracę i żywotność drukarki oraz jej części. Drukarka Dell działa najlepiej z oryginalnymi częściami i materiałami eksploatacyjnymi firmy Dell. Używanie materiałów i części innych producentów może negatywnie wpłynąć na wydajność, pracę i żywotność drukarki oraz jej części. Drukarka działa najlepiej z oryginalnymi częściami i materiałami eksploatacyjnymi producenta. Używanie materiałów i części innych producentów może negatywnie wpłynąć na wydajność, pracę i żywotność drukarki oraz jej części. Wszelkie wskaźniki materiałów są zaprojektowane tak, aby współpracować z materiałami i częściami firmy Lexmark. Ich praca może zostać zakłócona, gdy użyte zostaną materiały lub części innych producentów. Użytkowanie materiałów i części związanych z obrazami dłużej, niż jest to zalecane, może spowodować uszkodzenie drukarki Lexmark i jej komponentów. Wszelkie wskaźniki materiałów są zaprojektowane tak, aby współpracować z materiałami i częściami firmy Dell. Ich praca może zostać zakłócona, gdy użyte zostaną materiały lub części innych producentów. Użytkowanie materiałów i części związanych z obrazami dłużej, niż jest to zalecane, może spowodować uszkodzenie drukarki Dell i jej komponentów. Wszystkie wskaźniki materiałów są zaprojektowane tak, aby współpracować z materiałami i częściami producenta drukarki. Ich praca może zostać zakłócona, gdy zostaną użyte materiały lub części innych producentów. Użytkowanie elementów związanych z obrazowaniem dłużej, niż jest to zalecane, może spowodować uszkodzenie drukarki i jej komponentów. Używanie materiałów lub części innych producentów może spowodować utratę gwarancji. Uszkodzenia spowodowane używaniem materiałów lub części innych producentów nie będą naprawiane w ramach gwarancji. Aby zaakceptować powyższe informacje dotyczące ryzyka i korzystać z materiałów i części innych producentów, wykonaj jedną z następujących czynności: W przypadku modeli drukarek z ekranem dotykowym naciśnij dwukrotnie przycisk  , a następnie naciśnij dwukrotnie przycisk  . W przypadku modeli drukarek bez ekranu dotykowego naciśnij przycisk  X  oraz   i przytrzymaj oba przyciski przez 15 sekund. Jeśli nie chcesz zaakceptować powyższych informacji, wyjmij materiały lub części innych producentów z drukarki i zainstaluj oryginalne materiały lub części Lexmark. Więcej informacji można znaleźć w sekcji  . Jeśli nie chcesz zaakceptować powyższych informacji, wyjmij materiały lub części innych producentów z drukarki i zainstaluj oryginalne materiały lub części Dell. Jeśli nie chcesz zaakceptować powyższych informacji, wyjmij materiały lub części innych producentów z drukarki i zainstaluj oryginalne materiały lub części producenta drukarki. W przypadku modeli drukarek z ekranem dotykowym, jeśli drukarka nie drukuje po dwukrotnym naciśnięciu przycisku  , a następnie dwukrotnym naciśnięciu przycisku  , zresetuj licznik zużycia materiałów eksploatacyjnych. W przypadku modeli drukarek bez ekranu dotykowego, jeśli drukarka nie będzie drukować po naciśnięciu przycisków  X  oraz   i przytrzymaniu ich przez 15 sekund, zresetuj licznik zużycia materiałów eksploatacyjnych. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Przegląd Menu konfiguracji Zużycie materiałów eksploatacyjnych i liczniki W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wybierz część lub materiał eksploatacyjny, które chcesz wyzerować. Aby usunąć wiadomość, wykonaj jedną z następujących czynności: W przypadku modeli drukarek z ekranem dotykowym naciśnij dwukrotnie przycisk  , a następnie naciśnij dwukrotnie przycisk  . W przypadku modeli drukarek bez ekranu dotykowego naciśnij przycisk  X  oraz   i przytrzymaj oba przyciski przez 15 sekund. Jeśli nie jesteś w stanie zresetować liczników zużycia materiałów eksploatacyjnych, zwróć produkt sprzedawcy. komunikaty drukarki Materiały eksploatacyjne producenta innego niż Lexmark Materiały eksploatacyjne producenta innego niż Lexmark komunikaty drukarki Materiały eksploatacyjne producenta innego niż Dell Materiały eksploatacyjne producenta innego niż Dell komunikaty drukarki Materiały eksploatacyjne producenta innego niż producent drukarki Materiały eksploatacyjne producenta innego niż producent drukarki resetowanie liczniki zużycia materiałów eksploatacyjnych liczniki zużycia materiałów eksploatacyjnych resetowanie"},{"UUID":"2bd2d75e-fb03-44a7-b173-021d1cb0b891","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zapobieganie zacięciom Prawidłowo załaduj papier","descFull":"Zapobieganie zacięciom Prawidłowo załaduj papier Upewnij się, że papier w zasobniku leży płasko. Prawidłowe i nieprawidłowe ładowanie papieru Prawidłowe ładowanie papieru Nieprawidłowe ładowanie papieru Nie należy ładować zasobnika w trakcie drukowania. Nie należy ładować zbyt dużej ilości papieru naraz. Upewnij się, że wysokość stosu nie wykracza poza wskaźnik maksymalnego wypełnienia papierem. Nie należy wsuwać papieru do zasobnika. Załaduj papier tak jak przedstawiono na rysunku. Upewnij się, że prowadnice papieru zostały prawidłowo umieszczone i nie obejmują zbyt ciasno papieru lub kopert. W przypadku drukowania dwustronnego na papierze formatu A4 upewnij się, że rozmiar papieru w module dupleksu jest ustawiony na A4. W przypadku drukowania dwustronnego na papierze formatu Letter, Legal, Oficio oraz Folio należy upewnić się, że ustawienie rozmiaru papieru w module dupleksu jest ustawione na wartość Letter. Po załadowaniu papieru zasobnik należy mocno dopchnąć do drukarki. Korzystaj z zalecanego rodzaju papieru Należy stosować wyłącznie zalecany papier i nośniki specjalne. Nie należy ładować pomarszczonego, pogiętego, wilgotnego, zgiętego lub zwiniętego papieru. Przed załadowaniem papier należy wygiąć, przekartkować i wyrównać. Nie należy używać papieru wyciętego lub przyciętego ręcznie. Nie należy jednocześnie umieszczać papieru o różnych rozmiarach, różnej gramaturze ani różnego typu w tym samym zasobniku. Upewnij się, że rozmiar i typ papieru są ustawione prawidłowo w komputerze lub na panelu sterowania drukarki. Papier należy przechowywać zgodnie z zaleceniami producenta. zacięcia zapobieganie zacięcia papieru zapobieganie zapobieganie zacięciom papieru"},{"UUID":"e048452f-10cc-4b4e-90f9-442e9003aadd","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Ustalanie miejsca wystąpienia zacięcia Gdy","descFull":"Ustalanie miejsca wystąpienia zacięcia Gdy funkcja  Pomoc przy zac.  jest ustawiona na  Włącz , drukarka po usunięciu zaciętego arkusza usuwa także niezadrukowane lub częściowo niezadrukowane strony. Sprawdź, czy na wydruku znajdują się puste strony. Gdy funkcja  Zacięcia – ponów  jest ustawiona na  Włącz  lub  Auto , drukarka ponownie drukuje zacięte arkusze. Miejsca zacięcia Miejsca zacięcia 1 Automatyczny podajnik dokumentów 2 Odbiornik standardowy 3 Przednie drzwiczki 4 Podajnik ręczny 5 Zasobnik 6 Tylne drzwiczki 7 Moduł dupleksu ustalanie miejsca wystąpienia zacięcia lokalizacja obszarów zacięć zacięcia papieru miejsce"},{"UUID":"c7b03959-321c-4de6-bc74-4f63ff878a8a","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru wewnątrz tacy Zdejmij","descFull":"Zacięcie papieru wewnątrz tacy Zdejmij zasobnik. Wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Włóż zasobnik. usuwanie zablokowanego papieru w podajniku zacięcie, usuwanie w podajniku zacięcie papieru wewnątrz tacy"},{"UUID":"d986562a-5f54-418b-9b9f-daf055c61e44","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w przednich drzwiczkach","descFull":"Zacięcie papieru w przednich drzwiczkach Otwórz przednie drzwiczki. Aby zapobiec uszkodzeniu na skutek wyładowania elektrostatycznego, dotknij dowolnego, odsłoniętego metalowego elementu korpusu drukarki zanim dotkniesz wewnętrznych elementów drukarki lub będziesz mieć kontakt z nimi. Wyjmij zestaw obrazujący. Nie wystawiaj zestawu obrazującego na działanie światła słonecznego przez dłużej niż 10 minut. Długotrwałe działanie światła może negatywnie wpłynąć na jakość wydruku. Nie wolno dotykać bębna światłoczułego. Może to wpłynąć na jakość kolejnych zadań drukowania. Wyjmij zacięty papier. Wewnętrzne elementy drukarki mogą być gorące. W celu zmniejszenia ryzyka oparzenia, przed dotknięciem danej części należy odczekać, aż ostygnie. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Włóż zestaw obrazujący. Zamknij drzwiczki. usuwanie zablokowanego papieru w przednich drzwiczkach usuwanie zaciętego papieru. w przednich drzwiczkach zacięcie papieru w przednich drzwiczkach"},{"UUID":"07fad4df-ad47-4902-bfd2-010ccd5daaff","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w obszarze tylnych","descFull":"Zacięcie papieru w obszarze tylnych drzwiczek Otwórz tylne drzwiczki. Wewnętrzne elementy drukarki mogą być gorące. W celu zmniejszenia ryzyka oparzenia, przed dotknięciem danej części należy odczekać, aż ostygnie. Otwórz drzwiczki dostępu do nagrzewnicy. Wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Zamknij drzwiczki dostępu do nagrzewnicy. Zamknij tylne drzwiczki. zacięcia, usuwanie za tylnymi drzwiczkami zacięcie papieru, usuwanie za tylnymi drzwiczkami zacięcie papieru w obszarze tylnych drzwiczek"},{"UUID":"3f1dd761-23fc-4fd3-a1e0-5d65710c6891","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w module dupleksu","descFull":"Zacięcie papieru w module dupleksu Wyciągnij moduł dupleksu i wyjmij zacięty papier. Aby zapobiec uszkodzeniu na skutek wyładowania elektrostatycznego, dotknij dowolnego, odsłoniętego metalowego elementu korpusu drukarki zanim dotkniesz wewnętrznych elementów drukarki lub będziesz mieć kontakt z nimi. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Zainstaluj moduł dupleksu. usuwanie zablokowanego papieru w module druku dwustronnego usuwanie zaciętego papieru w module druku dwustronnego zacięcie papieru w module druku dwustronnego"},{"UUID":"5d4ff9f6-080a-4470-bad5-2c9637ffe378","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w pojemniku standardowym","descFull":"Zacięcie papieru w pojemniku standardowym Podnieś skaner, a następnie wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Opuść skaner. usuwanie zablokowanego papieru w odbiorniku standardowym zacięcie papieru, usuwanie w odbiorniku standardowym zacięcie papieru w pojemniku standardowym"},{"UUID":"6411318d-8dba-4b62-9a58-8b1d023a9af1","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w podajniku ręcznym","descFull":"Zacięcie papieru w podajniku ręcznym Wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. usuwanie zablokowanego papieru w ręcznym podajniku usuwanie zaciętego papieru. w ręcznym podajniku komunikaty w ręcznym podajniku"},{"UUID":"ea2c28f9-94e8-4e4d-89bc-40fe617e31e2","title":"Usuwanie zacięć","link":"clearing-jams.html","desc":"Zacięcie papieru w automatycznym podajniku","descFull":"Zacięcie papieru w automatycznym podajniku dokumentów Wyjmij wszystkie oryginalne dokumenty z zasobnika ADF. Otwórz pokrywę podajnika ADF. Aby zapobiec uszkodzeniu na skutek wyładowania elektrostatycznego, dotknij dowolnego, odsłoniętego metalowego elementu korpusu drukarki zanim dotkniesz wewnętrznych elementów drukarki lub będziesz mieć kontakt z nimi. Wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Zamknij pokrywę podajnika ADF. Otwórz pokrywę skanera. Wyjmij zacięty papier. Upewnij się, że wszystkie kawałki papieru zostały usunięte. Zamknij pokrywę skanera. zacięcia, usuwanie w automatycznym podajniku dokumentów zacięcie papieru, usuwanie w automatycznym podajniku dokumentów zacięcie papieru w automatycznym podajniku dokumentów"},{"UUID":"38992e56-b1fe-4fa6-a8df-7f36e646575f","title":"Problemy z podawaniem papieru","link":"solving-printer-problems.html","desc":"Koperta skleja się podczas drukowania","descFull":"Koperta skleja się podczas drukowania Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Używaj kopert przechowywanych w suchym otoczeniu. Drukowanie na wilgotnych kopertach może powodować sklejanie się skrzydełek. Wyślij zadanie drukowania. Czy koperta skleja się podczas drukowania? Problem został rozwiązany. Sprawdź, czy jako typ papieru ustawiono opcję  Koperta . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja zasobnika Rozmiar/typ papieru W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wyślij zadanie drukowania. Czy koperta skleja się podczas drukowania? Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . Problem został rozwiązany. rozwiązywanie problemów, drukowanie koperta skleja się podczas drukowania rozwiązywanie problemów z drukowaniem koperta skleja się podczas drukowania koperta skleja się podczas drukowania"},{"UUID":"32dbb823-7040-450d-831b-e1b039d5c7b6","title":"Problemy z podawaniem papieru","link":"solving-printer-problems.html","desc":"Drukowanie z sortowaniem nie działa","descFull":"Drukowanie z sortowaniem nie działa Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Drukuj Układ Sortuj W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Wybierz opcję  Wł. [1,2,1,2,1,2] . Wydrukuj dokument. Czy dokument jest posortowany prawidłowo? Problem został rozwiązany. Przejdź do dokumentu, który chcesz wydrukować, i otwórz okno dialogowe Drukuj, a następnie wybierz opcję  Sortuj . Wydrukuj dokument. Czy dokument jest posortowany prawidłowo? Problem został rozwiązany. Zmniejsz liczbę stron do wydrukowania. Wydrukuj dokument. Czy strony zostały prawidłowo posortowane? Problem został rozwiązany. Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . rozwiązywanie problemów z drukowaniem niedziałające drukowanie z sortowaniem rozwiązywanie problemów, drukowanie niedziałające drukowanie z sortowaniem niedziałające drukowanie z sortowaniem"},{"UUID":"2c7fc523-6042-4fe5-a69f-44568a069e72","title":"Problemy z podawaniem papieru","link":"solving-printer-problems.html","desc":"Papier często się zacina Kroki","descFull":"Papier często się zacina Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Zdejmij zasobnik. Sprawdź, czy poprawnie załadowano papier. Upewnij się, że prowadnice papieru zostały poprawnie umieszczone. Upewnij się, że wysokość stosu nie wykracza poza wskaźnik maksymalnego wypełnienia papierem. Pamiętaj o drukowaniu na papierze o zalecanym typie i rozmiarze. Włóż zasobnik. Wydrukuj dokument. Czy papier często się zacina? Problem został rozwiązany. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Papier Konfiguracja tacy Rozmiar/typ papieru W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. Ustaw prawidłowy rozmiar i typ papieru. Wydrukuj dokument. Czy papier często się zacina? Problem został rozwiązany. Załaduj papier z nowego opakowania. Papier wchłonął wilgoć z powodu wysokiej wilgotności powietrza. Do chwili użycia papier należy przechowywać w oryginalnym opakowaniu. Wydrukuj dokument. Czy papier często się zacina? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. rozwiązywanie problemów, drukowanie papier często się zacina drukowanie, rozwiązywanie problemów papier często się zacina"},{"UUID":"bd625c88-d39d-4962-b7f3-d4aa49aa95cf","title":"Problemy z podawaniem papieru","link":"solving-printer-problems.html","desc":"Zacięte strony nie są drukowane","descFull":"Zacięte strony nie są drukowane ponownie Krok prowadzący do rozwiązania problemu Działanie Tak Nie Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Powiadomienia Odzyskiwanie zawartości po zacięciu W przypadku drukarek niewyposażonych w ekran dotykowy naciśnij przycisk  , aby przechodzić między ustawieniami. W menu  Zacięcia – ponów  wybierz opcję  Włącz  lub  Automatyczny . Wydrukuj dokument. Czy zacięte strony są drukowane ponownie? Problem został rozwiązany. Skontaktuj się ze  Wsparciem klienta . Skontaktuj się ze  Wsparciem technicznym . rozwiązywanie problemów, drukowanie zacięte strony nie są drukowane ponownie rozwiązywanie problemów z drukowaniem zacięte strony nie są drukowane ponownie zacięte strony nie są drukowane ponownie"},{"UUID":"dc29986b-55ea-4dbf-80ad-29d5afbbc5d9","title":"problemy z wysyłaniem wiadomości e-mail","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Wyłączanie wiadomości o błędzie „Nie","descFull":"Wyłączanie wiadomości o błędzie „Nie skonfigurowano serwera SMTP” W zależności od modelu drukarki w panel sterowania wykonaj dowolną z poniższych czynności: Dotknij kolejno  Ustawienia E‑mail Konfiguracja poczty e-mail Wyłącz błąd „Nie skonfigurowano serwera SMTP” Wł. . Przejdź do opcji  E-mail Konfiguracja poczty e-mail Wyłącz błąd „Nie skonfigurowano serwera SMTP” Wł. . Aby błąd nie był wyświetlany ponownie, wykonaj jedną z następujących czynności: Zaktualizuj oprogramowanie sprzętowe. Więcej informacji można znaleźć w sekcji  . Skonfiguruj ustawienia SMTP poczty e-mail. Więcej informacji można znaleźć w sekcji  . Błąd „Nie skonfigurowano serwera SMTP” wyłączanie rozwiązywanie problemów Błąd „Nie skonfigurowano serwera SMTP” wyłączanie błędu „Nie skonfigurowano serwera SMTP”"},{"UUID":"4b59e315-102d-43e1-bacd-b49a41356bc1","title":"problemy z wysyłaniem wiadomości e-mail","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nie można wysłać wiadomości e-mail","descFull":"Nie można wysłać wiadomości e-mail Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że ustawienia SMTP poczty e-mail są skonfigurowane poprawnie. Więcej informacji można znaleźć w sekcji  . Czy możesz wysyłać wiadomości e-mail? Problem został rozwiązany. Upewnij się, że używasz właściwego hasła. W zależności od dostawcy usług poczty e-mail użyj hasła konta, hasła aplikacji lub hasła uwierzytelniania. Więcej informacji można znaleźć w sekcji  . Czy możesz wysyłać wiadomości e-mail? Problem został rozwiązany. Upewnij się, że drukarka jest podłączona do sieci i że sieć jest podłączona do Internetu. Czy możesz wysyłać wiadomości e-mail? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . rozwiązywanie problemów z pocztą e-mail nie można wysłać wiadomości e-mail rozwiązywanie problemów, e-mail nie można wysłać wiadomości e-mail nie można wysłać wiadomości e-mail"},{"UUID":"ae737d3b-ecf1-4ae9-a929-d201345217db","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Brak identyfikatora numeru dzwoniącego Niniejsze","descFull":"Brak identyfikatora numeru dzwoniącego Niniejsze instrukcje dotyczą tylko drukarek, które obsługują faks analogowy. Więcej informacji można znaleźć w sekcji  . Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Włącz identyfikator numeru dzwoniącego. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksu Funkcje sterowania administratora Włącz identyfikator numeru dzwoniącego W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Czy pojawia się identyfikator numeru dzwoniącego? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . rozwiązywanie problemów z faksem identyfikator numeru dzwoniącego nie jest wyświetlany faks, rozwiązywanie problemów identyfikator numeru dzwoniącego nie jest wyświetlany"},{"UUID":"28be8e99-af43-4c60-8dc4-e354dffbc47a","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Nie można skonfigurować etherFAX Kroki","descFull":"Nie można skonfigurować etherFAX Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź połączenie drukarki. Wydrukuj  stronę konfiguracji sieci . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Sieć Strona konfiguracji sieci W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Sprawdź stan sieci. Czy drukarka jest podłączona do sieci? Przejdź do punktu 3. Upewnij się, że drukarka jest podłączona do sieci i że sieć jest podłączona do Internetu. Czy można skonfigurować etherFAX? Problem został rozwiązany. Upewnij się, że etherFAX jest prawidłowo skonfigurowany: Więcej informacji można znaleźć w sekcji  . Czy można skonfigurować etherFAX? Problem został rozwiązany. Przejdź na stronę  https://www.etherfax.net/lexmark . faks, rozwiązywanie problemów nie można skonfigurować etherFAX rozwiązywanie problemów z faksem nie można skonfigurować etherFAX"},{"UUID":"94ddece7-2677-4e87-864e-ddc66457b5f4","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Nie można wysyłać ani odbierać","descFull":"Nie można wysyłać ani odbierać faksów za pomocą etherFAX Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że drukarka jest podłączona do sieci i że sieć jest podłączona do Internetu. Czy można wysyłać lub odbierać faksy za pomocą etherFAX? Problem został rozwiązany. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia ogólne faksu . W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Upewnij się, że posiadany numer faksu jest poprawny. Upewnij się, że opcja  Transport faksu  jest ustawiona na  etherFAX . Czy można wysyłać lub odbierać faksy za pomocą etherFAX? Problem został rozwiązany. Podziel duże dokumenty na mniejsze pliki. Czy można wysyłać lub odbierać faksy za pomocą etherFAX? Problem został rozwiązany. Przejdź na stronę  https://www.etherfax.net/lexmark . faks, rozwiązywanie problemów nie można wysyłać ani odbierać faksów za pomocą etherFAX rozwiązywanie problemów z faksem nie można wysyłać ani odbierać faksów za pomocą etherFAX nie można wysyłać ani odbierać faksów za pomocą etherFAX"},{"UUID":"cf8cdfad-b927-46c1-8e09-0c7cae6e9aca","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Nie można wysyłać ani odbierać","descFull":"Nie można wysyłać ani odbierać faksów za pomocą faksu analogowego Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Rozwiąż wszelkie problemy zgłaszane w komunikatach o błędach pojawiających się na wyświetlaczu. Czy można wysłać lub odebrać faks? Problem został rozwiązany. Upewnij się, że połączenia kablowe z poniższym wyposażeniem są prawidłowe: Telefon Słuchawka Automatyczna sekretarka Czy można wysłać lub odebrać faks? Problem został rozwiązany. Sprawdź, czy słychać sygnał wybierania. Zadzwoń pod numer faksu, aby sprawdzić, czy działa on poprawnie. Jeśli korzystasz z funkcji On Hook Dial (Wybieranie numeru przy odłożonej słuchawce), zwiększ głośność, aby sprawdzić, czy słychać sygnał wybierania. Czy słychać sygnał wybierania? Przejdź do punktu 5. Sprawdź gniazdko telefoniczne. Podłącz telefon analogowy bezpośrednio do gniazdka w ścianie. Sprawdź, czy słychać sygnał wybierania. Jeżeli nie słychać tonu wybierania, zastosuj inny kabel telefoniczny. Jeśli nie słychać sygnału wybierania, podłącz telefon analogowy do innego gniazdka. Jeśli słychać sygnał wybierania, drukarkę należy podłączyć do tego gniazdka. Czy można wysłać lub odebrać faks? Problem został rozwiązany. Sprawdź, czy drukarka jest podłączona do analogowej linii telefonicznej lub prawidłowego złącza cyfrowego. Jeżeli korzystasz z usługi telefonicznej ISDN (Integrated Services Digital Network), podłącz drukarkę do analogowego portu telefonicznego w adapterze terminala ISDN. Więcej informacji na ten temat można uzyskać u dostawcy usługi ISDN. W przypadku korzystania z cyfrowej linii telefonicznej DSL (Digital Subscriber Line) podłącz filtr DSL lub router umożliwiający korzystanie z linii urządzeniom analogowym. Więcej informacji na ten temat można uzyskać u dostawcy usługi DSL. Jeśli korzystasz z systemu telefonicznego PBX (Private Branch Exchange), upewnij się, że nawiązywane jest połączenie analogowe. Jeśli nie ma takiego złącza, należy rozważyć zainstalowanie analogowej linii telefonicznej na potrzeby faksu. Czy można wysłać lub odebrać faks? Problem został rozwiązany. Tymczasowo odłącz inne wyposażenie i wyłącz pozostałe usługi telefoniczne. Odłącz inne wyposażenie (np. automatyczne sekretarki, komputery, modemy lub rozgałęziacze linii telefonicznych) znajdujące się między drukarką a linią telefoniczną. Wyłącz funkcje połączeń oczekujących oraz poczty głosowej. Aby uzyskać więcej informacji, skontaktuj się z firmą telekomunikacyjną. Czy można wysłać lub odebrać faks? Problem został rozwiązany. Zeskanuj oryginalny dokument po jednej stronie. Wybierz numer faksu. Zeskanuj dokument. Czy można wysłać lub odebrać faks? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów nie można wysyłać ani odbierać faksów za pomocą faksu analogowego rozwiązywanie problemów z faksem nie można wysyłać ani odbierać faksów za pomocą faksu analogowego nie można wysyłać ani odbierać faksów za pomocą faksu analogowego"},{"UUID":"ca6c9e60-cbfa-4d94-a191-4149fd00d146","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Można odbierać, ale nie wysyłać","descFull":"Można odbierać, ale nie wysyłać faksów za pomocą faksu analogowego Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Załaduj oryginalny dokument do automatycznego podajnika dokumentów lub umieść go na szybie skanera. Czy można wysłać faksy? Problem został rozwiązany. Ustaw prawidłowo numer skrótu. Sprawdź, czy numer skrótu przyporządkowano numerowi telefonu, który chcesz wybrać. Ręcznie wybierz numer telefonu. Czy można wysłać faksy? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Ustaw prawidłowo numer skrótu. Sprawdź, czy numer skrótu przyporządkowano numerowi telefonu, który chcesz wybrać. Ręcznie wybierz numer telefonu. Czy można wysłać faksy? Problem został rozwiązany. Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów nie można wysyłać faksów za pomocą faksu analogowego rozwiązywanie problemów z faksem nie można wysyłać faksów za pomocą faksu analogowego"},{"UUID":"b4e883e8-7c8e-4578-bc98-fdfa72aada9b","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Można wysyłać, ale nie można","descFull":"Można wysyłać, ale nie można odbierać faksów za pomocą faksu analogowego Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że źródło papieru nie jest puste. Nie można odbierać faksów Problem został rozwiązany. Sprawdź ustawienia opóźnienia dzwonka. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu Ustawienia odbierania faksów Ilość dzwonków do odebrania W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Nie można odbierać faksów Problem został rozwiązany. Jeśli drukarka drukuje puste strony, sprawdź temat  . Nie można odbierać faksów Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów nie można odbierać faksów za pomocą faksu analogowego nie można odbierać faksów za pomocą faksu analogowego faks analogowy nie można odbierać faksów"},{"UUID":"2140e094-6c5b-4df4-82f7-d33d0db93b95","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Niska jakość wydruku faksu Kroki","descFull":"Niska jakość wydruku faksu Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy jakość wydruku jest odpowiednia. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Rozwiązywanie problemów Wydrukuj strony testu jakości W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Popraw niedoskonałości wydruku. Więcej informacji można znaleźć w sekcji  . Czy jakość wydruku faksu jest zadowalająca? Problem został rozwiązany. Zmniejsz szybkość transmisji dla odbieranych faksów. Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Faks Ustawienia faksu  Ustawienia odbierania faksu Funkcje sterowania administratora Maksymalna szybkość W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Wybierz mniejszą szybkość transmisji. Czy jakość wydruku faksu jest zadowalająca? Problem został rozwiązany. Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów niska jakość wydruku faksu niska jakość wydruku faksu"},{"UUID":"db8ae9ae-87c7-4793-a073-be40c63f70b4","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Brak informacji na stronie tytułowej","descFull":"Brak informacji na stronie tytułowej faksu Kroki prowadzące do rozwiązania problemu Działanie Nie Tak Wyłącz drukarkę, odczekaj około 10 sekund, a następnie włącz drukarkę. Wyślij lub odbierz faks. Czy na stronie tytułowej faksu brakuje informacji? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów brak informacji na stronie tytułowej faksu rozwiązywanie problemów z faksem brak informacji na stronie tytułowej faksu brak informacji na stronie tytułowej faksu"},{"UUID":"1854134f-3076-4e00-a32e-9e25451c8944","title":"Problemy z faksowaniem","link":"trb-caller-id-not-shown-topic.html","desc":"Nie można wysłać strony tytułowej","descFull":"Nie można wysłać strony tytułowej faksu z komputera Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy sterownik druku jest aktualny. Więcej informacji można znaleźć w sekcji  . Wyślij faks. Czy można wysłać stronę tytułową faksu? Problem został rozwiązany. W dokumencie, który próbujesz przefaksować, otwórz okno dialogowe  Drukuj . Wybierz drukarkę i kliknij kolejno  Właściwości ,  Preferencje ,  Opcje  lub  Ustawienia . Kliknij opcję  Faks , a następnie wyczyść ustawienie  Zawsze wyświetlaj ustawienia przed faksowaniem . Wyślij faks. Czy można wysłać stronę tytułową faksu? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . faks, rozwiązywanie problemów nie można wysłać strony tytułowej faksu z komputera rozwiązywanie problemów z faksem nie można wysłać strony tytułowej faksu z komputera nie można wysłać strony tytułowej faksu z komputera"},{"UUID":"2af9fda6-647e-4446-b352-08bcecea0d06","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nie można skanować do komputera","descFull":"Nie można skanować do komputera Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Wykonaj zadanie kopiowania. Czy zadanie kopiowania powiodło się? Przejdź do punktu 3. Wyłącz drukarkę, zaczekaj około 10 sekund, a następnie włącz ją ponownie. Zeskanuj dokument. Czy możesz zeskanować dokument do komputera? Problem został rozwiązany. Sprawdź połączenie drukarki. Wydrukuj  stronę konfiguracji sieci . Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Raporty Sieć Strona konfiguracji sieci . Sprawdź stan sieci. Czy drukarka jest podłączona do sieci? Przejdź do punktu 5. Podłącz drukarkę do sieci. Zeskanuj dokument. Czy możesz zeskanować dokument do komputera? Problem został rozwiązany. Sprawdź, czy drukarka i komputer są podłączone do tej samej sieci. Zeskanuj dokument. Czy możesz zeskanować dokument do komputera? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . rozwiązywanie problemów ze skanowaniem nie można skanować do komputera skanowanie, rozwiązywanie problemów nie można skanować do komputera"},{"UUID":"e4a6903e-b855-433a-9fbd-1fe6f42cb1f9","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nie można skanować do folderu","descFull":"Nie można skanować do folderu sieciowego Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Utwórz skrót do folderu sieciowego. Zeskanuj dokument za pomocą skrótu. Więcej informacji można znaleźć w sekcji  . Czy możesz zeskanować dokument i zapisać go w folderze sieciowym? Problem został rozwiązany. Upewnij się, że ścieżka i format folderu sieciowego są prawidłowe. Na przykład  // nazwa_hosta_serwera /nazwa_folderu/sciezka , gdzie  nazwa_hosta_serwera  jest w pełni kwalifikowaną nazwą domeny (FQDN) lub adresem IP. Czy ścieżka i format folderu sieciowego są prawidłowe? Przejdź do punktu 4. Upewnij się, że masz uprawnienia do zapisu w folderze sieciowym. Czy możesz zeskanować dokument i zapisać go w folderze sieciowym? Problem został rozwiązany. Zaktualizuj skrót folderu sieciowego. Uruchom przeglądarkę, a następnie w polu adresu wpisz adres IP drukarki. Wyświetl adres IP drukarki na ekranie głównym. Adres IP ma postać czterech liczb oddzielonych kropkami. Na przykład 123.123.123.123. W przypadku używania serwera proxy wyłącz go tymczasowo, aby prawidłowo załadować stronę. Kliknij opcję  Skróty , a następnie wybierz skrót. Jeśli dostępnych jest wiele typów skrótów, wybierz  Folder sieciowy . W polu  Ścieżka udziału  wpisz ścieżkę folderu sieciowego. Jeśli ścieżka udziału to  \\\\nazwa_hosta_serwera\\nazwa_folderu\\sciezka , wpisz  //nazwa_hosta_serwera/nazwa_folderu/sciezka . Podczas wpisywania ścieżki udziału upewni się, że użyto ukośników. W menu  Uwierzytelnianie  zaznacz metodę uwierzytelniania. Jeśli wybrana metoda  uwierzytelniania  to „ Użyj przypisanej nazwy użytkownika i hasła ”, w polach  Nazwa użytkownika  i  Hasło  wpisz swoje poświadczenia. Kliknij przycisk  Zapisz . Czy możesz zeskanować dokument i zapisać go w folderze sieciowym? Problem został rozwiązany. Upewnij się, że drukarka i folder sieciowy są podłączone do tej samej sieci Czy możesz zeskanować dokument i zapisać go w folderze sieciowym? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . nie można skanować do folderu sieciowego skanowanie, rozwiązywanie problemów nie można skanować do folderu sieciowego rozwiązywanie problemów ze skanowaniem nie można skanować do folderu sieciowego"},{"UUID":"425308d6-db8b-47d9-ac60-9b5da91393ba","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Niepełne kopie dokumentów lub zdjęć","descFull":"Niepełne kopie dokumentów lub zdjęć Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Upewnij się, że dokument lub zdjęcie jest umieszczone w prawym dolnym rogu szyby skanera, stroną z wydrukiem skierowaną w dół. Skopiuj dokument lub zdjęcie. Czy dokument lub fotografia zostały skopiowane prawidłowo? Problem został rozwiązany. Dostosuj ustawienie rozmiaru papieru do papieru załadowanego do zasobnika. Skopiuj dokument lub zdjęcie. Czy dokument lub fotografia zostały skopiowane prawidłowo? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Dostosuj ustawienie rozmiaru papieru do papieru załadowanego do zasobnika. Skopiuj dokument lub zdjęcie. Czy dokument lub fotografia zostały skopiowane prawidłowo? Problem został rozwiązany. Skontaktuj się  pomoc techniczna . kopiowanie, rozwiązywanie problemów niepełne kopie dokumentów lub zdjęć rozwiązywanie problemów z kopiowaniem niepełne kopie dokumentów lub zdjęć skanowanie, rozwiązywanie problemów niepełne kopie dokumentów lub zdjęć rozwiązywanie problemów ze skanowaniem niepełne kopie dokumentów lub zdjęć"},{"UUID":"f3e491ee-7e49-407b-8e5b-9db36c84e4c5","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Zadanie skanowania nie powiodło się","descFull":"Zadanie skanowania nie powiodło się Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź połączenia kabli. Upewnij się, że kabel sieciowy lub kabel USB jest prawidłowo podłączony do komputera i drukarki. Ponownie wyślij zadanie skanowania. Czy skanowanie powiodło się? Problem został rozwiązany. Sprawdź plik, do którego chcesz wykonać skan. Upewnij się, że nazwa pliku nie jest już używana w folderze docelowym. Upewnij się, że dokument lub zdjęcie, do którego chcesz wykonać skan nie są otwarte w innej aplikacji. Ponownie wyślij zadanie skanowania. Czy skanowanie powiodło się? Problem został rozwiązany. Sprawdź, czy w ustawieniach konfiguracyjnych miejsca docelowego zaznaczono pole wyboru  Dołączaj sygnaturę czasu  lub  Zastępuj istniejący plik . Ponownie wyślij zadanie skanowania. Czy skanowanie powiodło się? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Sprawdź, czy w ustawieniach konfiguracyjnych miejsca docelowego zaznaczono pole wyboru  Dołączaj sygnaturę czasu  lub  Zastępuj istniejący plik . Ponownie wyślij zadanie skanowania. Czy skanowanie powiodło się? Problem został rozwiązany. Skontaktuj się  pomoc techniczna . rozwiązywanie problemów ze skanowaniem zadanie skanowania nie powiodło się skanowanie, rozwiązywanie problemów zadanie skanowania nie powiodło się"},{"UUID":"8d049de8-a436-44d7-ac77-4eff7a2b7697","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Niska jakość kopii Kroki prowadzące","descFull":"Niska jakość kopii Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Przetrzyj szklane powierzchnię skanera oraz automatycznego podajnika dokumentów za pomocą miękkiej, wilgotnej, niestrzępiącej się szmatki. Jeśli drukarka jest wyposażona w drugą szybę automatycznego podajnika dokumentów wewnątrz automatycznego podajnika dokumentów, wyczyść również tę szybę. Więcej informacji można znaleźć w sekcji  . Upewnij się, że dokument lub zdjęcie jest umieszczone w prawym dolnym rogu szyby skanera, stroną z wydrukiem skierowaną w dół. Skopiuj dokument lub zdjęcie. Czy jakość kopii jest zadowalająca? Problem został rozwiązany. Sprawdź jakość oryginalnego dokumentu lub zdjęcia. Dostosuj ustawienia jakości skanowania. Skopiuj dokument lub zdjęcie. Czy jakość kopii jest zadowalająca? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Sprawdź jakość oryginalnego dokumentu lub zdjęcia. Dostosuj ustawienia jakości skanowania. Skopiuj dokument lub zdjęcie. Czy jakość kopii jest zadowalająca? Problem został rozwiązany. Skontaktuj się  pomocą techniczną . rozwiązywanie problemów z kopiowaniem niska jakość kopii kopiowanie, rozwiązywanie problemów niska jakość kopii rozwiązywanie problemów ze skanowaniem niska jakość kopii skanowanie, rozwiązywanie problemów niska jakość kopii"},{"UUID":"583fef9d-97b7-43c7-8b33-dfe42486135a","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Postrzępiony obraz lub tekst podczas","descFull":"Postrzępiony obraz lub tekst podczas skanowania z automatycznego podajnika dokumentów Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Do automatycznego podajnika dokumentów załaduj 50 arkuszy czystego, zwykłego papieru. Zwykły papier pomaga usunąć kurz i inne formy nalotu z rolek automatycznego podajnika dokumentów. Naciśnij przycisk   na panelu operacyjnym. Załaduj oryginalny dokument do automatycznego podajnika dokumentów. Zeskanuj dokument. Czy na wydruku pojawiają się postrzępione obrazy lub tekst? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomocą techniczną . Problem został rozwiązany. skanowanie, rozwiązywanie problemów postrzępiony obraz podczas skanowania z automatycznego podajnika dokumentów skanowanie, rozwiązywanie problemów postrzępiony tekst podczas skanowania z automatycznego podajnika dokumentów rozwiązywanie problemów ze skanowaniem postrzępiony obraz podczas skanowania z automatycznego podajnika dokumentów rozwiązywanie problemów ze skanowaniem postrzępiony tekst podczas skanowania z automatycznego podajnika dokumentów postrzępiony obraz skanowanie z automatycznego podajnika dokumentów postrzępiony tekst skanowanie z automatycznego podajnika dokumentów skanowanie z automatycznego podajnika dokumentów postrzępiony obraz skanowanie z automatycznego podajnika dokumentów postrzępiony tekst"},{"UUID":"038d64c1-3e26-468c-b86d-01cdfa6423ea","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skaner nie domyka się Krok","descFull":"Skaner nie domyka się Krok prowadzący do rozwiązania problemu Działanie Tak Nie Usuń przeszkody uniemożliwiające zamknięcie pokrywy skanera. Czy pokrywa skanera domyka się prawidłowo? Problem został rozwiązany. Skontaktuj się  wsparcie klienta . Skontaktuj się  pomocą techniczną . kopiowanie, rozwiązywanie problemów skaner nie domyka się skanowanie, rozwiązywanie problemów skaner nie domyka się skaner nie domyka się"},{"UUID":"28e6a68a-2302-4a82-9457-19dedd4e867e","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skanowanie trwa za długo lub","descFull":"Skanowanie trwa za długo lub zawiesza komputer Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Zamknij wszystkie aplikacje, które zakłócają skanowanie. Czy skanowanie trwa zbyt długo lub powoduje zawieszanie się komputera? Skontaktuj się  z obsługą klienta . Skontaktuj się  pomoc techniczna . Problem został rozwiązany. rozwiązywanie problemów ze skanowaniem skanowanie trwa zbyt długo rozwiązywanie problemów ze skanowaniem skanowanie zawiesza komputer"},{"UUID":"216134db-a354-4633-89b6-c6b19ca3ae6a","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skaner nie reaguje Kroki prowadzące","descFull":"Skaner nie reaguje Kroki prowadzące do rozwiązania problemu Działanie Tak Nie Sprawdź, czy przewód zasilający jest prawidłowo podłączony do drukarki i gniazdka elektrycznego. Aby uniknąć ryzyka pożaru lub porażenia prądem elektrycznym, podłącz przewód zasilający do prawidłowo uziemionego, łatwo dostępnego gniazdka elektrycznego o odpowiednich parametrach znajdującego się w pobliżu urządzenia. Skopiuj lub zeskanuj dokument. Czy skaner odpowiada? Problem został rozwiązany. Upewnij się, że drukarka jest włączona. Rozwiąż wszelkie problemy zgłaszane w komunikatach o błędach pojawiających się na wyświetlaczu. Skopiuj lub zeskanuj dokument. Czy skaner odpowiada? Problem został rozwiązany. Wyłącz drukarkę, a następnie odczekaj około 10 sekund, po czym włącz ją ponownie. Skopiuj lub zeskanuj dokument. Czy skaner odpowiada? Problem został rozwiązany. Skontaktuj się  z obsługą klienta . Wyłącz drukarkę, a następnie odczekaj około 10 sekund, po czym włącz ją ponownie. Skopiuj lub zeskanuj dokument. Czy skaner odpowiada? Problem został rozwiązany. Skontaktuj się  pomocą techniczną . kopiowanie, rozwiązywanie problemów skaner nie reaguje rozwiązywanie problemów z kopiowaniem skaner nie reaguje skanowanie, rozwiązywanie problemów skaner nie reaguje rozwiązywanie problemów ze skanowaniem skaner nie reaguje"},{"UUID":"45716fb7-a568-4921-add1-b0b87800281f","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Regulacja rejestracji skanera Przy użyciu","descFull":"Regulacja rejestracji skanera Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Konserwacja Menu konfiguracji Konfiguracja skanera Ręczna rejestracja skanera Drukuj szybki test W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Umieść  wydrukowaną stronę szybkiego testu  na szybie skanera, a następnie dotknij opcji  Rejestracja skanera płaskiego . Wybierz opcję  Kopiuj szybki test . Porównaj stronę  Kopiuj szybki test  z oryginałem. Jeżeli marginesy strony testowej są inne niż marginesy oryginału, musisz wyregulować  Lewy margines  i  Margines górny . Powtarzaj krok   i   do momentu, gdy marginesy na stronie  Kopiuj szybki test  będą odpowiadały marginesom w oryginale. rejestracja skanera dostosowywanie dostosowywanie rejestracji skanera"},{"UUID":"caa9eb2b-3faa-4e2f-b02a-cef29f41e1b9","title":"Problemy ze skanowaniem","link":"trb-cannot-scan-to-computer-topic.html","desc":"Regulacja rejestracji automatycznego podajnika dokumentów","descFull":"Regulacja rejestracji automatycznego podajnika dokumentów Przy użyciu panelu sterowania drukarki przejdź do opcji: Ustawienia Urządzenie Konserwacja Menu konfiguracji Konfiguracja skanera Ręczna rejestracja skanera Drukuj szybki test W przypadku drukarki niemającej ekranu dotykowego naciśnij przycisk  , aby poruszać się między ustawieniami. Umieść  wydrukowaną stronę szybkiego testu  na tacy automatycznego podajnika dokumentów, a następnie wybierz opcję  Rejestracja przedniego automatycznego podajnika dokumentów . Aby skalibrować Rejestrację przedniego automatycznego podajnika dokumentów, umieść stronę szybkiego testu nadrukiem do góry, krótszą krawędzią do automatycznego podajnika dokumentów. Wybierz opcję  Kopiuj szybki test . Porównaj stronę  Kopiuj szybki test  z oryginałem. Jeżeli marginesy strony testowej są inne niż marginesy oryginału, musisz wyregulować  Dopasowanie poziome  i  Margines górny . Powtarzaj krok   i   do momentu, gdy marginesy na stronie  Kopiuj szybki test  będą odpowiadały marginesom w oryginale. rejestracja ADF dostosowywanie regulacja rejestracji automatycznego podajnika dokumentów"},{"UUID":"5c469160-c703-40cd-b4f6-0058c8eced11","title":"Rozwiązywanie problemu","link":"trb-contacting-customer-support-topic.html","desc":"Kontakt z obsługą klienta Przed","descFull":"Kontakt z obsługą klienta Przed skontaktowaniem się z obsługą klienta upewnij się, że masz następujące informacje: Problem z drukarką Komunikat o błędzie Typ modelu drukarki i numer seryjny Przejdź pod adres  http://support.lexmark.com , aby otrzymać wsparcie za pośrednictwem wiadomości e-mail lub czatu albo przejrzeć bibliotekę podręczników, dokumentacji wsparcia, sterowników i pozostałych plików do pobrania. Dostępne jest również telefoniczne wsparcie techniczne. W Stanach Zjednoczonych lub Kanadzie można się kontaktować pod numerem telefonu 1‑-800‑-539‑-6275. Jeśli przebywasz w innym kraju lub regionie, przejdź pod adres  http://support.lexmark.com . Odwiedź placówkę, w której zakupiono drukarkę. kontakt z obsługą klienta z obsługą klienta kontakt"},{"UUID":"03440268-f39f-45ad-bfdd-ad3070e179eb","title":"Rozwiązywanie problemu","link":"troubleshooting-chapter.html","desc":"Uzyskiwanie pomocy technicznej Gdy kontaktujesz","descFull":"Uzyskiwanie pomocy technicznej Gdy kontaktujesz się z działem pomocy technicznej, opisz swój problem, podaj komunikat widoczny na wyświetlaczu drukarki oraz poinformuj o podjętych korkach rozwiązywania problemów. Odszukaj etykietę znajdującą się po wewnętrznej stronie przedniej pokrywy lub z tyłu drukarki, a następnie zanotuj poniższe informacje: Model drukarki Numer znacznika serwisowego lub kod obsługi ekspresowej Więcej informacji można znaleźć na stronie  www.dell.com/support . rozwiązywanie problemów uzyskiwanie pomocy technicznej uzyskiwanie pomocy technicznej"},{"UUID":"63c61e7c-f3ae-4eeb-ab76-a5998c678702","title":"Recykling i utylizacja","link":"recycling-lexmark-products-topic.html","desc":"Recykling produktów Lexmark Aby zwrócić","descFull":"Recykling produktów Lexmark Aby zwrócić produkty firmy Lexmark w celu recyklingu: Odwiedź stronę  www.lexmark.com/recycle . Wybierz produkt, który chcesz poddać recyklingowi. Materiały eksploatacyjne i sprzęt nieobjęte programem recyklingu firmy Lexmark można poddać recyklingowi w lokalnym centrum recyklingu. recykling produkty Lexmark"},{"UUID":"c317f81d-bd60-4306-85f7-720a81825e48","title":"Recykling i utylizacja","link":"recycling-lexmark-packaging-topic.html","desc":"Recykling opakowań firmy Lexmark Firma","descFull":"Recykling opakowań firmy Lexmark Firma Lexmark nieustannie dąży do maksymalnego ograniczenia rozmiaru opakowań. Mniejszy rozmiar opakowań pomaga zagwarantować, że drukarki firmy Lexmark są transportowane w możliwie najbardziej wydajny i przyjazny dla środowiska sposób oraz że pozostaje mniej materiałów opakowaniowych do utylizacji. Takie podejście umożliwia ograniczenie emisji gazów cieplarnianych oraz oszczędność energii i zasobów naturalnych. W niektórych krajach i regionach firma Lexmark oferuje również recykling elementów opakowań. Aby uzyskać więcej informacji, przejdź na stronę  www.lexmark.com/recycle , a następnie wybierz swój kraj lub region. Informacje dotyczące dostępnych programów recyklingu opakowań są dołączone do informacji dotyczących utylizacji produktu. Kartony firmy Lexmark nadają się w 100% do recyklingu na obszarach, na których istnieją zakłady zajmujące się recyklingiem tektury falistej. Takich zakładów może nie być w miejscu zamieszkania użytkownika. Pianka używana w opakowaniach firmy Lexmark nadaje się do recyklingu na obszarach, na których istnieją zakłady zajmujące się recyklingiem takiej pianki. Takich zakładów może nie być w miejscu zamieszkania użytkownika.  W przypadku zwrotu wkładu drukującego do firmy Lexmark można ponownie użyć pudełka, w którym został on sprzedany. Firma Lexmark zajmie się recyklingiem pudełka. recykling opakowania Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"MFP MB2236"}},[_vm._v("\n    MFP MB2236\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_pt","title":"Informa&ccedil;&otilde;es sobre seguran&ccedil;a"}},[_vm._v("\n    Informações sobre segurança\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Conven&ccedil;&otilde;es"}},[_vm._v("\n     Convenções\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e42","title":"Declara&ccedil;&otilde;es de produtos"}},[_vm._v("\n     Declarações de produtos\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_pt","title":"Informa&ccedil;&otilde;es sobre a impressora"}},[_vm._v("\n    Informações sobre a impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e172"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_pt","title":"Localizando informa&ccedil;&otilde;es sobre a impressora"}},[_vm._v("\n     Localizando informações sobre a impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_pt","title":"Localiza&ccedil;&atilde;o do n&uacute;mero de s&eacute;rie da impressora"}},[_vm._v("\n     Localização do número de série da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configured-model-topic.html#configured-model_pt","title":"Configura&ccedil;&atilde;o da impressora"}},[_vm._v("\n     Configuração da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-group.html#d0e379","title":"Uso do painel de controle"}},[_vm._v("\n     Uso do painel de controle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"customizing-home-screen-topic.html#customizing-home-screen_pt","title":"Personaliza&ccedil;&atilde;o da tela inicial"}},[_vm._v("\n     Personalização da tela inicial\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_pt","title":"Alterar o idioma do teclado no monitor"}},[_vm._v("\n     Alterar o idioma do teclado no monitor\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pt","title":"No&ccedil;&otilde;es b&aacute;sicas sobre o status do bot&atilde;o liga/desliga e da luz indicadora"}},[_vm._v("\n     Noções básicas sobre o status do botão liga/desliga e da luz indicadora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e759","title":"Como selecionar o papel"}},[_vm._v("\n     Como selecionar o papel\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_pt","title":"Instala&ccedil;&atilde;o e configura&ccedil;&atilde;o"}},[_vm._v("\n    Instalação e configuração\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1623"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-m-topic.html#selecting-location-printer-m_pt","title":"Selecionando um local para a impressora"}},[_vm._v("\n     Selecionando um local para a impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_pt","title":"Conectando os cabos"}},[_vm._v("\n     Conectando os cabos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e1818","title":"Configurando a impressora para enviar fax"}},[_vm._v("\n     Configurando a impressora para enviar fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_pt","title":"Como configurar o SMTP de e-mail"}},[_vm._v("\n     Como configurar o SMTP de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-paper-and-specialty-media-group.html#d0e3751","title":"Carregamento de papel e m&iacute;dia especial"}},[_vm._v("\n     Carregamento de papel e mídia especial\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e3884","title":"Como instalar e atualizar software, drivers e firmware"}},[_vm._v("\n     Como instalar e atualizar software, drivers e firmware\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"connecting-printer-to-wireless-network-topic.html#d0e4117","title":"Colocando em rede"}},[_vm._v("\n     Colocando em rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_pt","title":"Criando um perfil do Cloud Connector"}},[_vm._v("\n     Criando um perfil do Cloud Connector\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_pt","title":"Impress&atilde;o da P&aacute;gina de configura&ccedil;&otilde;es de menu"}},[_vm._v("\n     Impressão da Página de configurações de menu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_pt","title":"Prote&ccedil;&atilde;o da impressora"}},[_vm._v("\n    Proteção da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4635"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_pt","title":"Apagando a mem&oacute;ria da impressora"}},[_vm._v("\n     Apagando a memória da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pt","title":"Restaurando &agrave;s configura&ccedil;&otilde;es padr&atilde;o de f&aacute;brica"}},[_vm._v("\n     Restaurando às configurações padrão de fábrica\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_pt","title":"Declara&ccedil;&atilde;o de volatilidade"}},[_vm._v("\n     Declaração de volatilidade\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_pt","title":"Print"}},[_vm._v("\n    Print\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4757"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_pt","title":"Impress&atilde;o de um computador"}},[_vm._v("\n     Impressão de um computador\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e4783","title":"Impress&atilde;o a partir de um dispositivo m&oacute;vel"}},[_vm._v("\n     Impressão a partir de um dispositivo móvel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_pt","title":"Impress&atilde;o a partir de uma unidade flash"}},[_vm._v("\n     Impressão a partir de uma unidade flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pt","title":"Unidades flash e tipos de arquivo suportados"}},[_vm._v("\n     Unidades flash e tipos de arquivo suportados\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pt","title":"Configurar trabalhos confidenciais"}},[_vm._v("\n     Configurar trabalhos confidenciais\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pt","title":"Como imprimir trabalhos confidenciais e outros trabalhos suspensos"}},[_vm._v("\n     Como imprimir trabalhos confidenciais e outros trabalhos suspensos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_pt","title":"Imprimindo a partir de um perfil do Cloud Connector"}},[_vm._v("\n     Imprimindo a partir de um perfil do Cloud Connector\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-topic.html#printing-font-sample-lis_pt","title":"Como imprimir uma lista de amostras de fontes"}},[_vm._v("\n     Como imprimir uma lista de amostras de fontes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_pt","title":"Folhas separadoras entre as c&oacute;pias"}},[_vm._v("\n     Folhas separadoras entre as cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_pt","title":"Cancelamento de um trabalho de impress&atilde;o"}},[_vm._v("\n     Cancelamento de um trabalho de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_pt","title":"Ajustando a tonalidade do toner"}},[_vm._v("\n     Ajustando a tonalidade do toner\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_pt","title":"C&oacute;pia"}},[_vm._v("\n    Cópia\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5379"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_pt","title":"C&oacute;pias"}},[_vm._v("\n     Cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_pt","title":"C&oacute;pia de fotos"}},[_vm._v("\n     Cópia de fotos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-letterhead-topic.html#copying-letterhead_pt","title":"Copiando em papel timbrado"}},[_vm._v("\n     Copiando em papel timbrado\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_pt","title":"C&oacute;pia nos dois lados do papel"}},[_vm._v("\n     Cópia nos dois lados do papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_pt","title":"Redu&ccedil;&atilde;o ou amplia&ccedil;&atilde;o de c&oacute;pias"}},[_vm._v("\n     Redução ou ampliação de cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_pt","title":"Para copiar v&aacute;rias p&aacute;ginas em uma &uacute;nica folha"}},[_vm._v("\n     Para copiar várias páginas em uma única folha\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_pt","title":"Agrupamento de c&oacute;pias"}},[_vm._v("\n     Agrupamento de cópias\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_pt","title":"C&oacute;pia de cart&otilde;es"}},[_vm._v("\n     Cópia de cartões\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_pt","title":"Criando um atalho de c&oacute;pia"}},[_vm._v("\n     Criando um atalho de cópia\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"e-mailing-chapter.html#e-mailing-chapter_pt","title":"E-mail"}},[_vm._v("\n    E-mail\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5709"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_pt","title":"Como enviar e- mail"}},[_vm._v("\n     Como enviar e- mail\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_pt","title":"Fax"}},[_vm._v("\n    Fax\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5824"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_pt","title":"Como enviar um fax"}},[_vm._v("\n     Como enviar um fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#sending-fax-scheduled-time_pt","title":"Agendando o envio de um fax"}},[_vm._v("\n     Agendando o envio de um fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_pt","title":"Criando um atalho de destino de fax"}},[_vm._v("\n     Criando um atalho de destino de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_pt","title":"Como alterar a resolu&ccedil;&atilde;o do fax"}},[_vm._v("\n     Como alterar a resolução do fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_pt","title":"Como ajustar a tonalidade do fax"}},[_vm._v("\n     Como ajustar a tonalidade do fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_pt","title":"Impress&atilde;o de um log de fax"}},[_vm._v("\n     Impressão de um log de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_pt","title":"Como bloquear faxes indesejados"}},[_vm._v("\n     Como bloquear faxes indesejados\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_pt","title":"Como reter fax"}},[_vm._v("\n     Como reter fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_pt","title":"Como encaminhar fax"}},[_vm._v("\n     Como encaminhar fax\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_pt","title":"Digitaliza&ccedil;&atilde;o"}},[_vm._v("\n    Digitalização\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6218"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_pt","title":"Usando o alimentador autom&aacute;tico de documentos e o vidro do scanner"}},[_vm._v("\n     Usando o alimentador automático de documentos e o vidro do scanner\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_pt","title":"Como digitalizar para um computador"}},[_vm._v("\n     Como digitalizar para um computador\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_pt","title":"Como digitalizar para uma unidade flash"}},[_vm._v("\n     Como digitalizar para uma unidade flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_pt","title":"Como digitalizar para um servidor FTP"}},[_vm._v("\n     Como digitalizar para um servidor FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_pt","title":"Como digitalizar para uma pasta de rede"}},[_vm._v("\n     Como digitalizar para uma pasta de rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_pt","title":"Digitaliza&ccedil;&atilde;o para um perfil do Cloud Connector"}},[_vm._v("\n     Digitalização para um perfil do Cloud Connector\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_pt","title":"Uso dos menus da impressora"}},[_vm._v("\n    Uso dos menus da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6565"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menus-map-mfp_pt","title":"Mapa de menus"}},[_vm._v("\n     Mapa de menus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e6913","title":"Dispositivo"}},[_vm._v("\n     Dispositivo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e8549","title":"Print"}},[_vm._v("\n     Print\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e9342","title":"Papel"}},[_vm._v("\n     Papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e9643","title":"C&oacute;pia"}},[_vm._v("\n     Cópia\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e9865","title":"Fax"}},[_vm._v("\n     Fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e11487","title":"E-mail"}},[_vm._v("\n     E-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e12170","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e12602","title":"Unidade USB"}},[_vm._v("\n     Unidade USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e13207","title":"Rede/portas"}},[_vm._v("\n     Rede/portas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e15222","title":"Seguran&ccedil;a"}},[_vm._v("\n     Segurança\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-connector-menu-topic.html#cloud-connector-menu_pt","title":"Cloud Connector"}},[_vm._v("\n     Cloud Connector\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e15936","title":"Relat&oacute;rios"}},[_vm._v("\n     Relatórios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_pt","title":"Solu&ccedil;&atilde;o de problemas"}},[_vm._v("\n     Solução de problemas\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_pt","title":"Manuten&ccedil;&atilde;o da impressora"}},[_vm._v("\n    Manutenção da impressora\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16228"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_pt","title":"Verificando o status de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Verificando o status de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_pt","title":"Configura&ccedil;&atilde;o de notifica&ccedil;&otilde;es de suprimento"}},[_vm._v("\n     Configuração de notificações de suprimento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pt","title":"Configurando os alertas de e-mail"}},[_vm._v("\n     Configurando os alertas de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_pt","title":"Exibindo relat&oacute;rios"}},[_vm._v("\n     Exibindo relatórios\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-supplies-group.html#ordering-supplies-group_pt","title":"Solicita&ccedil;&atilde;o de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Solicitação de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e16501","title":"Troca de pe&ccedil;as e suprimentos"}},[_vm._v("\n     Troca de peças e suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e16646","title":"Como limpar pe&ccedil;as da impressora"}},[_vm._v("\n     Como limpar peças da impressora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e16734","title":"Como economizar energia e papel"}},[_vm._v("\n     Como economizar energia e papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_pt","title":"Para mover a impressora para outro local"}},[_vm._v("\n     Para mover a impressora para outro local\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_pt","title":"Transporte da impressora"}},[_vm._v("\n     Transporte da impressora\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_pt","title":"Solu&ccedil;&atilde;o de problemas"}},[_vm._v("\n    Solução de problemas\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e16895"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_pt","title":"Problemas de qualidade de impress&atilde;o"}},[_vm._v("\n     Problemas de qualidade de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-is-poor-subgroup.html#d0e17006","title":"Problemas de impress&atilde;o"}},[_vm._v("\n     Problemas de impressão\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_pt","title":"A impressora n&atilde;o est&aacute; respondendo"}},[_vm._v("\n     A impressora não está respondendo\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_pt","title":"N&atilde;o foi poss&iacute;vel ler unidade flash"}},[_vm._v("\n     Não foi possível ler unidade flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_pt","title":"Ativando a porta USB"}},[_vm._v("\n     Ativando a porta USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e19613","title":"Problemas de conex&atilde;o de rede"}},[_vm._v("\n     Problemas de conexão de rede\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e19831","title":"Problemas com suprimentos"}},[_vm._v("\n     Problemas com suprimentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_pt","title":"Limpeza de atolamentos"}},[_vm._v("\n     Limpeza de atolamentos\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printer-problems.html#solving-printer-problems_pt","title":"Problemas na bandeja de papel"}},[_vm._v("\n     Problemas na bandeja de papel\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e20609","title":"Problemas de envio de e-mail"}},[_vm._v("\n     Problemas de envio de e-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e20728","title":"Problemas de envio de fax"}},[_vm._v("\n     Problemas de envio de fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e21383","title":"Problemas de digitaliza&ccedil;&atilde;o"}},[_vm._v("\n     Problemas de digitalização\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pt","title":"Entrando em contato com o suporte ao cliente"}},[_vm._v("\n     Entrando em contato com o suporte ao cliente\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_pt","title":"Reciclagem e descarte"}},[_vm._v("\n    Reciclagem e descarte\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e22138"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_pt","title":"Reciclagem de produtos da Lexmark"}},[_vm._v("\n     Reciclagem de produtos da Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_pt","title":"Reciclagem de embalagens da Lexmark"}},[_vm._v("\n     Reciclagem de embalagens da Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_pt","title":"Avisos"}},[_vm._v("\n    Avisos\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e22173"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22176","title":"Informa&ccedil;&otilde;es sobre o produto"}},[_vm._v("\n     Informações sobre o produto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22193","title":"Aviso de edi&ccedil;&atilde;o"}},[_vm._v("\n     Aviso de edição\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_pt","title":"Marcas comerciais"}},[_vm._v("\n     Marcas comerciais\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_pt","title":"Avisos de licenciamento"}},[_vm._v("\n     Avisos de licenciamento\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_pt","title":"N&iacute;veis de emiss&atilde;o de ru&iacute;do"}},[_vm._v("\n     Níveis de emissão de ruído\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_pt","title":"Diretiva de res&iacute;duos de equipamentos el&eacute;tricos e eletr&ocirc;nicos (WEEE, Waste from Electrical and Electronic Equipment)"}},[_vm._v("\n     Diretiva de resíduos de equipamentos elétricos e eletrônicos (WEEE, Waste from Electrical and Electronic Equipment)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22299","title":"Bateria recarreg&aacute;vel de &iacute;ons de l&iacute;tio"}},[_vm._v("\n     Bateria recarregável de íons de lítio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_pt","title":"Norma (UE) 2023/1542"}},[_vm._v("\n     Norma (UE) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22337","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_pt","title":"Descarte do produto"}},[_vm._v("\n     Descarte do produto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pt","title":"A devolu&ccedil;&atilde;o de cartuchos Lexmark para reutiliza&ccedil;&atilde;o ou reciclagem"}},[_vm._v("\n     A devolução de cartuchos Lexmark para reutilização ou reciclagem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_pt","title":"Aviso de sensibilidade &agrave; est&aacute;tica"}},[_vm._v("\n     Aviso de sensibilidade à estática\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_pt","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_pt","title":"Informa&ccedil;&otilde;es sobre temperatura"}},[_vm._v("\n     Informações sobre temperatura\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_pt","title":"Aviso sobre laser"}},[_vm._v("\n     Aviso sobre laser\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_pt","title":"Consumo de energia"}},[_vm._v("\n     Consumo de energia\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#notice-to-users-of-products-in-brazil_pt","title":"Aviso aos usu&aacute;rios de produtos no Brasil"}},[_vm._v("\n     Aviso aos usuários de produtos no Brasil\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_pt","title":"Avisos regulamentares para equipamentos de terminal de telecomunica&ccedil;&atilde;o"}},[_vm._v("\n     Avisos regulamentares para equipamentos de terminal de telecomunicação\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22601","title":"Avisos regulamentares para produtos sem fio"}},[_vm._v("\n     Avisos regulamentares para produtos sem fio\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_pt","title":"Aviso de componente modular"}},[_vm._v("\n     Aviso de componente modular\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_pt","title":"Exposi&ccedil;&atilde;o &agrave; radia&ccedil;&atilde;o de radiofreq&uuml;&ecirc;ncia"}},[_vm._v("\n     Exposição à radiação de radiofreqüência\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e22626","title":"Conformidade com as diretivas da Comunidade Europeia (CE)"}},[_vm._v("\n     Conformidade com as diretivas da Comunidade Europeia (CE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-b_pt","title":"Conformidade com as diretivas da Comunidade Europeia (CE)"}},[_vm._v("\n     Conformidade com as diretivas da Comunidade Europeia (CE)\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js